import { trigger, transition, style, animate } from '@angular/animations';
import * as i3 from '@angular/common';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, PLATFORM_ID, booleanAttribute, numberAttribute, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, Input, Output, ViewChild, ContentChildren, Directive, HostListener, Optional, NgModule } from '@angular/core';
import * as i7 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i1 from 'primeng/api';
import { FilterOperator, FilterMatchMode, PrimeTemplate, TranslationKeys, SharedModule } from 'primeng/api';
import * as i8 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i11 from 'primeng/calendar';
import { CalendarModule } from 'primeng/calendar';
import { DomHandler, ConnectedOverlayScrollHandler } from 'primeng/dom';
import * as i6 from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import { ArrowDownIcon } from 'primeng/icons/arrowdown';
import { ArrowUpIcon } from 'primeng/icons/arrowup';
import { CheckIcon } from 'primeng/icons/check';
import { FilterIcon } from 'primeng/icons/filter';
import { FilterSlashIcon } from 'primeng/icons/filterslash';
import { PlusIcon } from 'primeng/icons/plus';
import { SortAltIcon } from 'primeng/icons/sortalt';
import { SortAmountDownIcon } from 'primeng/icons/sortamountdown';
import { SortAmountUpAltIcon } from 'primeng/icons/sortamountupalt';
import { SpinnerIcon } from 'primeng/icons/spinner';
import { TrashIcon } from 'primeng/icons/trash';
import * as i9 from 'primeng/inputnumber';
import { InputNumberModule } from 'primeng/inputnumber';
import * as i10 from 'primeng/inputtext';
import { InputTextModule } from 'primeng/inputtext';
import * as i4 from 'primeng/paginator';
import { PaginatorModule } from 'primeng/paginator';
import * as i5 from 'primeng/scroller';
import { ScrollerModule } from 'primeng/scroller';
import { SelectButtonModule } from 'primeng/selectbutton';
import * as i12 from 'primeng/tristatecheckbox';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { UniqueComponentId, ObjectUtils, ZIndexUtils } from 'primeng/utils';
import { Subject } from 'rxjs';
import * as i2 from '@angular/platform-browser';
const _c0 = ["container"];
const _c1 = ["resizeHelper"];
const _c2 = ["reorderIndicatorUp"];
const _c3 = ["reorderIndicatorDown"];
const _c4 = ["wrapper"];
const _c5 = ["table"];
const _c6 = ["thead"];
const _c7 = ["tfoot"];
const _c8 = ["scroller"];
const _c9 = (a0, a1, a2) => ({
  "p-datatable p-component": true,
  "p-datatable-hoverable-rows": a0,
  "p-datatable-scrollable": a1,
  "p-datatable-flex-scrollable": a2
});
const _c10 = a0 => ({
  maxHeight: a0
});
const _c11 = a0 => ({
  height: a0
});
const _c12 = (a0, a1) => ({
  $implicit: a0,
  options: a1
});
const _c13 = a0 => ({
  columns: a0
});
const _c14 = (a0, a1, a2) => ({
  "p-datatable-table": true,
  "p-datatable-scrollable-table": a0,
  "p-datatable-resizable-table": a1,
  "p-datatable-resizable-table-fit": a2
});
const _c15 = a0 => ({
  $implicit: a0
});
const _c16 = () => ({
  display: "none"
});
function Table_div_2_i_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("p-datatable-loading-icon " + ctx_r0.loadingIcon);
  }
}
function Table_div_2_ng_container_2_SpinnerIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SpinnerIcon", 25);
  }
  if (rf & 2) {
    i0.ɵɵproperty("spin", true)("styleClass", "p-datatable-loading-icon");
  }
}
function Table_div_2_ng_container_2_span_2_1_ng_template_0_Template(rf, ctx) {}
function Table_div_2_ng_container_2_span_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_div_2_ng_container_2_span_2_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function Table_div_2_ng_container_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵtemplate(1, Table_div_2_ng_container_2_span_2_1_Template, 1, 0, null, 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.loadingIconTemplate);
  }
}
function Table_div_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Table_div_2_ng_container_2_SpinnerIcon_1_Template, 1, 2, "SpinnerIcon", 23)(2, Table_div_2_ng_container_2_span_2_Template, 2, 1, "span", 24);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.loadingIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.loadingIconTemplate);
  }
}
function Table_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, Table_div_2_i_1_Template, 1, 2, "i", 22)(2, Table_div_2_ng_container_2_Template, 3, 2, "ng-container", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.loadingIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.loadingIcon);
  }
}
function Table_div_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, Table_div_3_ng_container_1_Template, 1, 0, "ng-container", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.captionTemplate);
  }
}
function Table_p_paginator_4_1_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_p_paginator_4_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_4_1_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 27);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorDropdownIconTemplate);
  }
}
function Table_p_paginator_4_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_4_1_ng_template_0_Template, 1, 1, "ng-template", 30);
  }
}
function Table_p_paginator_4_2_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_p_paginator_4_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_4_2_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 27);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorFirstPageLinkIconTemplate);
  }
}
function Table_p_paginator_4_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_4_2_ng_template_0_Template, 1, 1, "ng-template", 31);
  }
}
function Table_p_paginator_4_3_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_p_paginator_4_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_4_3_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 27);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorPreviousPageLinkIconTemplate);
  }
}
function Table_p_paginator_4_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_4_3_ng_template_0_Template, 1, 1, "ng-template", 32);
  }
}
function Table_p_paginator_4_4_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_p_paginator_4_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_4_4_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 27);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorLastPageLinkIconTemplate);
  }
}
function Table_p_paginator_4_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_4_4_ng_template_0_Template, 1, 1, "ng-template", 33);
  }
}
function Table_p_paginator_4_5_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_p_paginator_4_5_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_4_5_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 27);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorNextPageLinkIconTemplate);
  }
}
function Table_p_paginator_4_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_4_5_ng_template_0_Template, 1, 1, "ng-template", 34);
  }
}
function Table_p_paginator_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-paginator", 29);
    i0.ɵɵlistener("onPageChange", function Table_p_paginator_4_Template_p_paginator_onPageChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onPageChange($event));
    });
    i0.ɵɵtemplate(1, Table_p_paginator_4_1_Template, 1, 0, null, 16)(2, Table_p_paginator_4_2_Template, 1, 0, null, 16)(3, Table_p_paginator_4_3_Template, 1, 0, null, 16)(4, Table_p_paginator_4_4_Template, 1, 0, null, 16)(5, Table_p_paginator_4_5_Template, 1, 0, null, 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("rows", ctx_r0.rows)("first", ctx_r0.first)("totalRecords", ctx_r0.totalRecords)("pageLinkSize", ctx_r0.pageLinks)("alwaysShow", ctx_r0.alwaysShowPaginator)("rowsPerPageOptions", ctx_r0.rowsPerPageOptions)("templateLeft", ctx_r0.paginatorLeftTemplate)("templateRight", ctx_r0.paginatorRightTemplate)("dropdownAppendTo", ctx_r0.paginatorDropdownAppendTo)("dropdownScrollHeight", ctx_r0.paginatorDropdownScrollHeight)("currentPageReportTemplate", ctx_r0.currentPageReportTemplate)("showFirstLastIcon", ctx_r0.showFirstLastIcon)("dropdownItemTemplate", ctx_r0.paginatorDropdownItemTemplate)("showCurrentPageReport", ctx_r0.showCurrentPageReport)("showJumpToPageDropdown", ctx_r0.showJumpToPageDropdown)("showJumpToPageInput", ctx_r0.showJumpToPageInput)("showPageLinks", ctx_r0.showPageLinks)("styleClass", ctx_r0.getPaginatorStyleClasses("p-paginator-top"))("locale", ctx_r0.paginatorLocale);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.paginatorDropdownIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.paginatorFirstPageLinkIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.paginatorPreviousPageLinkIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.paginatorLastPageLinkIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.paginatorNextPageLinkIconTemplate);
  }
}
function Table_p_scroller_7_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_p_scroller_7_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_scroller_7_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 37);
  }
  if (rf & 2) {
    const items_r4 = ctx.$implicit;
    const scrollerOptions_r5 = ctx.options;
    i0.ɵɵnextContext(2);
    const buildInTable_r6 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", buildInTable_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c12, items_r4, scrollerOptions_r5));
  }
}
function Table_p_scroller_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-scroller", 35, 3);
    i0.ɵɵlistener("onLazyLoad", function Table_p_scroller_7_Template_p_scroller_onLazyLoad_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onLazyItemLoad($event));
    });
    i0.ɵɵtemplate(2, Table_p_scroller_7_ng_template_2_Template, 1, 5, "ng-template", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(15, _c11, ctx_r0.scrollHeight !== "flex" ? ctx_r0.scrollHeight : undefined));
    i0.ɵɵproperty("items", ctx_r0.processedData)("columns", ctx_r0.columns)("scrollHeight", ctx_r0.scrollHeight !== "flex" ? undefined : "100%")("itemSize", ctx_r0.virtualScrollItemSize || ctx_r0._virtualRowHeight)("step", ctx_r0.rows)("delay", ctx_r0.lazy ? ctx_r0.virtualScrollDelay : 0)("inline", true)("autoSize", true)("lazy", ctx_r0.lazy)("loaderDisabled", true)("showSpacer", false)("showLoader", ctx_r0.loadingBodyTemplate)("options", ctx_r0.virtualScrollOptions);
  }
}
function Table_ng_container_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Table_ng_container_8_ng_container_1_Template, 1, 0, "ng-container", 37);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const buildInTable_r6 = i0.ɵɵreference(10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", buildInTable_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(4, _c12, ctx_r0.processedData, i0.ɵɵpureFunction1(2, _c13, ctx_r0.columns)));
  }
}
function Table_ng_template_9_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_ng_template_9_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_ng_template_9_tbody_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tbody", 44);
  }
  if (rf & 2) {
    const scrollerOptions_r7 = i0.ɵɵnextContext().options;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.frozenValue)("frozenRows", true)("pTableBody", scrollerOptions_r7.columns)("pTableBodyTemplate", ctx_r0.frozenBodyTemplate)("frozen", true);
  }
}
function Table_ng_template_9_tbody_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tbody", 45);
  }
  if (rf & 2) {
    const scrollerOptions_r7 = i0.ɵɵnextContext().options;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c11, "calc(" + scrollerOptions_r7.spacerStyle.height + " - " + scrollerOptions_r7.rows.length * scrollerOptions_r7.itemSize + "px)"));
  }
}
function Table_ng_template_9_tfoot_9_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_ng_template_9_tfoot_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tfoot", 46, 6);
    i0.ɵɵtemplate(2, Table_ng_template_9_tfoot_9_ng_container_2_Template, 1, 0, "ng-container", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const scrollerOptions_r7 = i0.ɵɵnextContext().options;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.footerGroupedTemplate || ctx_r0.footerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c15, scrollerOptions_r7.columns));
  }
}
function Table_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 38, 4);
    i0.ɵɵtemplate(2, Table_ng_template_9_ng_container_2_Template, 1, 0, "ng-container", 37);
    i0.ɵɵelementStart(3, "thead", 39, 5);
    i0.ɵɵtemplate(5, Table_ng_template_9_ng_container_5_Template, 1, 0, "ng-container", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, Table_ng_template_9_tbody_6_Template, 1, 5, "tbody", 40);
    i0.ɵɵelement(7, "tbody", 41);
    i0.ɵɵtemplate(8, Table_ng_template_9_tbody_8_Template, 1, 3, "tbody", 42)(9, Table_ng_template_9_tfoot_9_Template, 3, 4, "tfoot", 43);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const scrollerOptions_r7 = ctx.options;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.tableStyleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(18, _c14, ctx_r0.scrollable, ctx_r0.resizableColumns, ctx_r0.resizableColumns && ctx_r0.columnResizeMode === "fit"))("ngStyle", ctx_r0.tableStyle);
    i0.ɵɵattribute("id", ctx_r0.id + "-table");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.colGroupTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(22, _c15, scrollerOptions_r7.columns));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerGroupedTemplate || ctx_r0.headerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(24, _c15, scrollerOptions_r7.columns));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.frozenValue || ctx_r0.frozenBodyTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", scrollerOptions_r7.contentStyleClass)("ngStyle", scrollerOptions_r7.contentStyle)("value", ctx_r0.dataToRender(scrollerOptions_r7.rows))("pTableBody", scrollerOptions_r7.columns)("pTableBodyTemplate", ctx_r0.bodyTemplate)("scrollerOptions", scrollerOptions_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", scrollerOptions_r7.spacerStyle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.footerGroupedTemplate || ctx_r0.footerTemplate);
  }
}
function Table_p_paginator_11_1_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_p_paginator_11_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_11_1_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 27);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorDropdownIconTemplate);
  }
}
function Table_p_paginator_11_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_11_1_ng_template_0_Template, 1, 1, "ng-template", 30);
  }
}
function Table_p_paginator_11_2_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_p_paginator_11_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_11_2_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 27);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorFirstPageLinkIconTemplate);
  }
}
function Table_p_paginator_11_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_11_2_ng_template_0_Template, 1, 1, "ng-template", 31);
  }
}
function Table_p_paginator_11_3_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_p_paginator_11_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_11_3_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 27);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorPreviousPageLinkIconTemplate);
  }
}
function Table_p_paginator_11_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_11_3_ng_template_0_Template, 1, 1, "ng-template", 32);
  }
}
function Table_p_paginator_11_4_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_p_paginator_11_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_11_4_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 27);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorLastPageLinkIconTemplate);
  }
}
function Table_p_paginator_11_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_11_4_ng_template_0_Template, 1, 1, "ng-template", 33);
  }
}
function Table_p_paginator_11_5_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_p_paginator_11_5_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_11_5_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 27);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorNextPageLinkIconTemplate);
  }
}
function Table_p_paginator_11_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_p_paginator_11_5_ng_template_0_Template, 1, 1, "ng-template", 34);
  }
}
function Table_p_paginator_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-paginator", 29);
    i0.ɵɵlistener("onPageChange", function Table_p_paginator_11_Template_p_paginator_onPageChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onPageChange($event));
    });
    i0.ɵɵtemplate(1, Table_p_paginator_11_1_Template, 1, 0, null, 16)(2, Table_p_paginator_11_2_Template, 1, 0, null, 16)(3, Table_p_paginator_11_3_Template, 1, 0, null, 16)(4, Table_p_paginator_11_4_Template, 1, 0, null, 16)(5, Table_p_paginator_11_5_Template, 1, 0, null, 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("rows", ctx_r0.rows)("first", ctx_r0.first)("totalRecords", ctx_r0.totalRecords)("pageLinkSize", ctx_r0.pageLinks)("alwaysShow", ctx_r0.alwaysShowPaginator)("rowsPerPageOptions", ctx_r0.rowsPerPageOptions)("templateLeft", ctx_r0.paginatorLeftTemplate)("templateRight", ctx_r0.paginatorRightTemplate)("dropdownAppendTo", ctx_r0.paginatorDropdownAppendTo)("dropdownScrollHeight", ctx_r0.paginatorDropdownScrollHeight)("currentPageReportTemplate", ctx_r0.currentPageReportTemplate)("showFirstLastIcon", ctx_r0.showFirstLastIcon)("dropdownItemTemplate", ctx_r0.paginatorDropdownItemTemplate)("showCurrentPageReport", ctx_r0.showCurrentPageReport)("showJumpToPageDropdown", ctx_r0.showJumpToPageDropdown)("showJumpToPageInput", ctx_r0.showJumpToPageInput)("showPageLinks", ctx_r0.showPageLinks)("styleClass", ctx_r0.getPaginatorStyleClasses("p-paginator-bottom"))("locale", ctx_r0.paginatorLocale);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.paginatorDropdownIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.paginatorFirstPageLinkIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.paginatorPreviousPageLinkIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.paginatorLastPageLinkIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.paginatorNextPageLinkIconTemplate);
  }
}
function Table_div_12_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function Table_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtemplate(1, Table_div_12_ng_container_1_Template, 1, 0, "ng-container", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.summaryTemplate);
  }
}
function Table_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 48, 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(1, _c16));
  }
}
function Table_span_14_ArrowDownIcon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ArrowDownIcon");
  }
}
function Table_span_14_3_ng_template_0_Template(rf, ctx) {}
function Table_span_14_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_span_14_3_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function Table_span_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49, 8);
    i0.ɵɵtemplate(2, Table_span_14_ArrowDownIcon_2_Template, 1, 0, "ArrowDownIcon", 16)(3, Table_span_14_3_Template, 1, 0, null, 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(3, _c16));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.reorderIndicatorUpIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.reorderIndicatorUpIconTemplate);
  }
}
function Table_span_15_ArrowUpIcon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ArrowUpIcon");
  }
}
function Table_span_15_3_ng_template_0_Template(rf, ctx) {}
function Table_span_15_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Table_span_15_3_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function Table_span_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 50, 9);
    i0.ɵɵtemplate(2, Table_span_15_ArrowUpIcon_2_Template, 1, 0, "ArrowUpIcon", 16)(3, Table_span_15_3_Template, 1, 0, null, 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(3, _c16));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.reorderIndicatorDownIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.reorderIndicatorDownIconTemplate);
  }
}
const _c17 = ["pTableBody", ""];
const _c18 = (a0, a1, a2, a3, a4) => ({
  $implicit: a0,
  rowIndex: a1,
  columns: a2,
  editing: a3,
  frozen: a4
});
const _c19 = (a0, a1, a2, a3, a4, a5, a6) => ({
  $implicit: a0,
  rowIndex: a1,
  columns: a2,
  editing: a3,
  frozen: a4,
  rowgroup: a5,
  rowspan: a6
});
const _c20 = (a0, a1, a2, a3, a4, a5) => ({
  $implicit: a0,
  rowIndex: a1,
  columns: a2,
  expanded: a3,
  editing: a4,
  frozen: a5
});
const _c21 = (a0, a1, a2, a3) => ({
  $implicit: a0,
  rowIndex: a1,
  columns: a2,
  frozen: a3
});
const _c22 = (a0, a1) => ({
  $implicit: a0,
  frozen: a1
});
function TableBody_ng_container_0_ng_template_1_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_0_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 3);
    i0.ɵɵtemplate(1, TableBody_ng_container_0_ng_template_1_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const rowData_r2 = ctx_r0.$implicit;
    const rowIndex_r3 = ctx_r0.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.groupHeaderTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c18, rowData_r2, ctx_r3.getRowIndex(rowIndex_r3), ctx_r3.columns, ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r2), ctx_r3.frozen));
  }
}
function TableBody_ng_container_0_ng_template_1_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_0_ng_template_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableBody_ng_container_0_ng_template_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const rowData_r2 = ctx_r0.$implicit;
    const rowIndex_r3 = ctx_r0.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", rowData_r2 ? ctx_r3.template : ctx_r3.dt.loadingBodyTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c18, rowData_r2, ctx_r3.getRowIndex(rowIndex_r3), ctx_r3.columns, ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r2), ctx_r3.frozen));
  }
}
function TableBody_ng_container_0_ng_template_1_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_0_ng_template_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableBody_ng_container_0_ng_template_1_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const rowData_r2 = ctx_r0.$implicit;
    const rowIndex_r3 = ctx_r0.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", rowData_r2 ? ctx_r3.template : ctx_r3.dt.loadingBodyTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction7(2, _c19, rowData_r2, ctx_r3.getRowIndex(rowIndex_r3), ctx_r3.columns, ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r2), ctx_r3.frozen, ctx_r3.shouldRenderRowspan(ctx_r3.value, rowData_r2, rowIndex_r3), ctx_r3.calculateRowGroupSize(ctx_r3.value, rowData_r2, rowIndex_r3)));
  }
}
function TableBody_ng_container_0_ng_template_1_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_0_ng_template_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 3);
    i0.ɵɵtemplate(1, TableBody_ng_container_0_ng_template_1_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const rowData_r2 = ctx_r0.$implicit;
    const rowIndex_r3 = ctx_r0.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.groupFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c18, rowData_r2, ctx_r3.getRowIndex(rowIndex_r3), ctx_r3.columns, ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r2), ctx_r3.frozen));
  }
}
function TableBody_ng_container_0_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableBody_ng_container_0_ng_template_1_ng_container_0_Template, 2, 8, "ng-container", 2)(1, TableBody_ng_container_0_ng_template_1_ng_container_1_Template, 2, 8, "ng-container", 0)(2, TableBody_ng_container_0_ng_template_1_ng_container_2_Template, 2, 10, "ng-container", 0)(3, TableBody_ng_container_0_ng_template_1_ng_container_3_Template, 2, 8, "ng-container", 2);
  }
  if (rf & 2) {
    const rowData_r2 = ctx.$implicit;
    const rowIndex_r3 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r3.dt.groupHeaderTemplate && !ctx_r3.dt.virtualScroll && ctx_r3.dt.rowGroupMode === "subheader" && ctx_r3.shouldRenderRowGroupHeader(ctx_r3.value, rowData_r2, ctx_r3.getRowIndex(rowIndex_r3)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dt.rowGroupMode !== "rowspan");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dt.rowGroupMode === "rowspan");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dt.groupFooterTemplate && !ctx_r3.dt.virtualScroll && ctx_r3.dt.rowGroupMode === "subheader" && ctx_r3.shouldRenderRowGroupFooter(ctx_r3.value, rowData_r2, rowIndex_r3));
  }
}
function TableBody_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableBody_ng_container_0_ng_template_1_Template, 4, 4, "ng-template", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.value)("ngForTrackBy", ctx_r3.dt.rowTrackBy);
  }
}
function TableBody_ng_container_1_ng_template_1_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_1_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableBody_ng_container_1_ng_template_1_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const rowData_r6 = ctx_r4.$implicit;
    const rowIndex_r7 = ctx_r4.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.template)("ngTemplateOutletContext", i0.ɵɵpureFunction6(2, _c20, rowData_r6, ctx_r3.getRowIndex(rowIndex_r7), ctx_r3.columns, ctx_r3.dt.isRowExpanded(rowData_r6), ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r6), ctx_r3.frozen));
  }
}
function TableBody_ng_container_1_ng_template_1_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_1_ng_template_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 3);
    i0.ɵɵtemplate(1, TableBody_ng_container_1_ng_template_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const rowData_r6 = ctx_r4.$implicit;
    const rowIndex_r7 = ctx_r4.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.groupHeaderTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction6(2, _c20, rowData_r6, ctx_r3.getRowIndex(rowIndex_r7), ctx_r3.columns, ctx_r3.dt.isRowExpanded(rowData_r6), ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r6), ctx_r3.frozen));
  }
}
function TableBody_ng_container_1_ng_template_1_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_1_ng_template_1_ng_container_2_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_1_ng_template_1_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 3);
    i0.ɵɵtemplate(1, TableBody_ng_container_1_ng_template_1_ng_container_2_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    const rowData_r6 = ctx_r4.$implicit;
    const rowIndex_r7 = ctx_r4.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.groupFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction6(2, _c20, rowData_r6, ctx_r3.getRowIndex(rowIndex_r7), ctx_r3.columns, ctx_r3.dt.isRowExpanded(rowData_r6), ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r6), ctx_r3.frozen));
  }
}
function TableBody_ng_container_1_ng_template_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableBody_ng_container_1_ng_template_1_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 4)(2, TableBody_ng_container_1_ng_template_1_ng_container_2_ng_container_2_Template, 2, 9, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const rowData_r6 = ctx_r4.$implicit;
    const rowIndex_r7 = ctx_r4.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.expandedRowTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(3, _c21, rowData_r6, ctx_r3.getRowIndex(rowIndex_r7), ctx_r3.columns, ctx_r3.frozen));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dt.groupFooterTemplate && ctx_r3.dt.rowGroupMode === "subheader" && ctx_r3.shouldRenderRowGroupFooter(ctx_r3.value, rowData_r6, ctx_r3.getRowIndex(rowIndex_r7)));
  }
}
function TableBody_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableBody_ng_container_1_ng_template_1_ng_container_0_Template, 2, 9, "ng-container", 0)(1, TableBody_ng_container_1_ng_template_1_ng_container_1_Template, 2, 9, "ng-container", 2)(2, TableBody_ng_container_1_ng_template_1_ng_container_2_Template, 3, 8, "ng-container", 0);
  }
  if (rf & 2) {
    const rowData_r6 = ctx.$implicit;
    const rowIndex_r7 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", !ctx_r3.dt.groupHeaderTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dt.groupHeaderTemplate && ctx_r3.dt.rowGroupMode === "subheader" && ctx_r3.shouldRenderRowGroupHeader(ctx_r3.value, rowData_r6, ctx_r3.getRowIndex(rowIndex_r7)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dt.isRowExpanded(rowData_r6));
  }
}
function TableBody_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableBody_ng_container_1_ng_template_1_Template, 3, 3, "ng-template", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.value)("ngForTrackBy", ctx_r3.dt.rowTrackBy);
  }
}
function TableBody_ng_container_2_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_2_ng_template_1_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_2_ng_template_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableBody_ng_container_2_ng_template_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const rowData_r9 = ctx_r7.$implicit;
    const rowIndex_r10 = ctx_r7.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.frozenExpandedRowTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c21, rowData_r9, ctx_r3.getRowIndex(rowIndex_r10), ctx_r3.columns, ctx_r3.frozen));
  }
}
function TableBody_ng_container_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableBody_ng_container_2_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 4)(1, TableBody_ng_container_2_ng_template_1_ng_container_1_Template, 2, 7, "ng-container", 0);
  }
  if (rf & 2) {
    const rowData_r9 = ctx.$implicit;
    const rowIndex_r10 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.template)("ngTemplateOutletContext", i0.ɵɵpureFunction6(3, _c20, rowData_r9, ctx_r3.getRowIndex(rowIndex_r10), ctx_r3.columns, ctx_r3.dt.isRowExpanded(rowData_r9), ctx_r3.dt.editMode === "row" && ctx_r3.dt.isRowEditing(rowData_r9), ctx_r3.frozen));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dt.isRowExpanded(rowData_r9));
  }
}
function TableBody_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableBody_ng_container_2_ng_template_1_Template, 2, 10, "ng-template", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.value)("ngForTrackBy", ctx_r3.dt.rowTrackBy);
  }
}
function TableBody_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableBody_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.loadingBodyTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c22, ctx_r3.columns, ctx_r3.frozen));
  }
}
function TableBody_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TableBody_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableBody_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dt.emptyMessageTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c22, ctx_r3.columns, ctx_r3.frozen));
  }
}
function SortIcon_ng_container_0_SortAltIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SortAltIcon", 4);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-sortable-column-icon");
  }
}
function SortIcon_ng_container_0_SortAmountUpAltIcon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SortAmountUpAltIcon", 4);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-sortable-column-icon");
  }
}
function SortIcon_ng_container_0_SortAmountDownIcon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SortAmountDownIcon", 4);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-sortable-column-icon");
  }
}
function SortIcon_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SortIcon_ng_container_0_SortAltIcon_1_Template, 1, 1, "SortAltIcon", 3)(2, SortIcon_ng_container_0_SortAmountUpAltIcon_2_Template, 1, 1, "SortAmountUpAltIcon", 3)(3, SortIcon_ng_container_0_SortAmountDownIcon_3_Template, 1, 1, "SortAmountDownIcon", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.sortOrder === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.sortOrder === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.sortOrder === -1);
  }
}
function SortIcon_span_1_1_ng_template_0_Template(rf, ctx) {}
function SortIcon_span_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SortIcon_span_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function SortIcon_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, SortIcon_span_1_1_Template, 1, 0, null, 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.dt.sortIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c15, ctx_r0.sortOrder));
  }
}
function SortIcon_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.getBadgeValue());
  }
}
function CellEditor_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CellEditor_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CellEditor_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.inputTemplate);
  }
}
function CellEditor_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CellEditor_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CellEditor_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.outputTemplate);
  }
}
const _c23 = ["rb"];
const _c24 = (a0, a1, a2) => ({
  "p-radiobutton-focused": a0,
  "p-radiobutton-checked": a1,
  "p-radiobutton-disabled": a2
});
const _c25 = (a0, a1, a2) => ({
  "p-radiobutton-box p-component": true,
  "p-highlight": a0,
  "p-focus": a1,
  "p-disabled": a2
});
const _c26 = (a0, a1) => ({
  "p-checkbox-focused": a0,
  "p-checkbox-disabled": a1
});
const _c27 = (a0, a1, a2) => ({
  "p-checkbox-box p-component": true,
  "p-highlight": a0,
  "p-focus": a1,
  "p-disabled": a2
});
function TableCheckbox_ng_container_5_CheckIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "CheckIcon", 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-checkbox-icon");
  }
}
function TableCheckbox_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableCheckbox_ng_container_5_CheckIcon_1_Template, 1, 1, "CheckIcon", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.checked);
  }
}
function TableCheckbox_span_6_1_ng_template_0_Template(rf, ctx) {}
function TableCheckbox_span_6_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableCheckbox_span_6_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function TableCheckbox_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, TableCheckbox_span_6_1_Template, 1, 0, null, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.dt.checkboxIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c15, ctx_r1.checked));
  }
}
const _c28 = (a0, a1, a2) => ({
  "p-checkbox-box": true,
  "p-highlight": a0,
  "p-focus": a1,
  "p-disabled": a2
});
function TableHeaderCheckbox_ng_container_6_CheckIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "CheckIcon", 9);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-checkbox-icon");
  }
}
function TableHeaderCheckbox_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableHeaderCheckbox_ng_container_6_CheckIcon_1_Template, 1, 1, "CheckIcon", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.checked);
  }
}
function TableHeaderCheckbox_span_7_1_ng_template_0_Template(rf, ctx) {}
function TableHeaderCheckbox_span_7_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TableHeaderCheckbox_span_7_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function TableHeaderCheckbox_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtemplate(1, TableHeaderCheckbox_span_7_1_Template, 1, 0, null, 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.dt.headerCheckboxIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c15, ctx_r1.checked));
  }
}
const _c29 = ["icon"];
const _c30 = ["clearBtn"];
const _c31 = (a0, a1) => ({
  "p-column-filter-row": a0,
  "p-column-filter-menu": a1
});
const _c32 = (a0, a1) => ({
  "p-column-filter-menu-button-open": a0,
  "p-column-filter-menu-button-active": a1
});
const _c33 = a0 => ({
  "p-hidden-space": a0
});
const _c34 = a0 => ({
  "p-column-filter-overlay p-component p-fluid": true,
  "p-column-filter-overlay-menu": a0
});
const _c35 = a0 => ({
  "p-highlight": a0
});
function ColumnFilter_p_columnFilterFormElement_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-columnFilterFormElement", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", ctx_r0.type)("field", ctx_r0.field)("ariaLabel", ctx_r0.ariaLabel)("filterConstraint", ctx_r0.dt.filters[ctx_r0.field])("filterTemplate", ctx_r0.filterTemplate)("placeholder", ctx_r0.placeholder)("minFractionDigits", ctx_r0.minFractionDigits)("maxFractionDigits", ctx_r0.maxFractionDigits)("prefix", ctx_r0.prefix)("suffix", ctx_r0.suffix)("locale", ctx_r0.locale)("localeMatcher", ctx_r0.localeMatcher)("currency", ctx_r0.currency)("currencyDisplay", ctx_r0.currencyDisplay)("useGrouping", ctx_r0.useGrouping)("showButtons", ctx_r0.showButtons);
  }
}
function ColumnFilter_button_2_FilterIcon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "FilterIcon", 12);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "pi-filter-icon");
  }
}
function ColumnFilter_button_2_span_3_1_ng_template_0_Template(rf, ctx) {}
function ColumnFilter_button_2_span_3_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ColumnFilter_button_2_span_3_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function ColumnFilter_button_2_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtemplate(1, ColumnFilter_button_2_span_3_1_Template, 1, 0, null, 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.filterIconTemplate);
  }
}
function ColumnFilter_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9, 0);
    i0.ɵɵlistener("click", function ColumnFilter_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.toggleMenu());
    })("keydown", function ColumnFilter_button_2_Template_button_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onToggleButtonKeyDown($event));
    });
    i0.ɵɵtemplate(2, ColumnFilter_button_2_FilterIcon_2_Template, 1, 1, "FilterIcon", 10)(3, ColumnFilter_button_2_span_3_Template, 2, 1, "span", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c32, ctx_r0.overlayVisible, ctx_r0.hasFilter()));
    i0.ɵɵattribute("aria-label", ctx_r0.filterMenuButtonAriaLabel)("aria-controls", ctx_r0.overlayVisible ? ctx_r0.overlayId : null)("aria-expanded", (tmp_5_0 = ctx_r0.overlayVisible) !== null && tmp_5_0 !== undefined ? tmp_5_0 : false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.filterIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.filterIconTemplate);
  }
}
function ColumnFilter_button_3_FilterSlashIcon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "FilterSlashIcon");
  }
}
function ColumnFilter_button_3_3_ng_template_0_Template(rf, ctx) {}
function ColumnFilter_button_3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ColumnFilter_button_3_3_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function ColumnFilter_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15, 0);
    i0.ɵɵlistener("click", function ColumnFilter_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.clearFilter());
    });
    i0.ɵɵtemplate(2, ColumnFilter_button_3_FilterSlashIcon_2_Template, 1, 0, "FilterSlashIcon", 16)(3, ColumnFilter_button_3_3_Template, 1, 0, null, 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c33, !ctx_r0.hasRowFilter()));
    i0.ɵɵattribute("aria-label", ctx_r0.clearButtonLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.clearFilterIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.clearFilterIconTemplate);
  }
}
function ColumnFilter_div_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ColumnFilter_div_4_ul_2_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 24);
    i0.ɵɵlistener("click", function ColumnFilter_div_4_ul_2_li_1_Template_li_click_0_listener() {
      const matchMode_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onRowMatchModeChange(matchMode_r7.value));
    })("keydown", function ColumnFilter_div_4_ul_2_li_1_Template_li_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onRowMatchModeKeyDown($event));
    })("keydown.enter", function ColumnFilter_div_4_ul_2_li_1_Template_li_keydown_enter_0_listener() {
      const matchMode_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onRowMatchModeChange(matchMode_r7.value));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const matchMode_r7 = ctx.$implicit;
    const i_r8 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c35, ctx_r0.isRowMatchModeSelected(matchMode_r7.value)));
    i0.ɵɵattribute("tabindex", i_r8 === 0 ? "0" : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", matchMode_r7.label, " ");
  }
}
function ColumnFilter_div_4_ul_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ul", 20);
    i0.ɵɵtemplate(1, ColumnFilter_div_4_ul_2_li_1_Template, 2, 5, "li", 21);
    i0.ɵɵelement(2, "li", 22);
    i0.ɵɵelementStart(3, "li", 23);
    i0.ɵɵlistener("click", function ColumnFilter_div_4_ul_2_Template_li_click_3_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onRowClearItemClick());
    })("keydown", function ColumnFilter_div_4_ul_2_Template_li_keydown_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onRowMatchModeKeyDown($event));
    })("keydown.enter", function ColumnFilter_div_4_ul_2_Template_li_keydown_enter_3_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onRowClearItemClick());
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.matchModes);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.noFilterLabel);
  }
}
function ColumnFilter_div_4_ng_template_3_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30)(1, "p-dropdown", 31);
    i0.ɵɵlistener("ngModelChange", function ColumnFilter_div_4_ng_template_3_div_0_Template_p_dropdown_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onOperatorChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r0.operatorOptions)("ngModel", ctx_r0.operator);
  }
}
function ColumnFilter_div_4_ng_template_3_div_2_p_dropdown_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dropdown", 36);
    i0.ɵɵlistener("ngModelChange", function ColumnFilter_div_4_ng_template_3_div_2_p_dropdown_1_Template_p_dropdown_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const fieldConstraint_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onMenuMatchModeChange($event, fieldConstraint_r11));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const fieldConstraint_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("options", ctx_r0.matchModes)("ngModel", fieldConstraint_r11.matchMode);
  }
}
function ColumnFilter_div_4_ng_template_3_div_2_button_4_TrashIcon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "TrashIcon", 12);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-button-icon-left");
  }
}
function ColumnFilter_div_4_ng_template_3_div_2_button_4_2_ng_template_0_Template(rf, ctx) {}
function ColumnFilter_div_4_ng_template_3_div_2_button_4_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ColumnFilter_div_4_ng_template_3_div_2_button_4_2_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function ColumnFilter_div_4_ng_template_3_div_2_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function ColumnFilter_div_4_ng_template_3_div_2_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const fieldConstraint_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.removeConstraint(fieldConstraint_r11));
    });
    i0.ɵɵtemplate(1, ColumnFilter_div_4_ng_template_3_div_2_button_4_TrashIcon_1_Template, 1, 1, "TrashIcon", 10)(2, ColumnFilter_div_4_ng_template_3_div_2_button_4_2_Template, 1, 0, null, 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("label", ctx_r0.removeRuleButtonLabel);
    i0.ɵɵattribute("aria-label", ctx_r0.removeRuleButtonLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.removeRuleIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.removeRuleIconTemplate);
  }
}
function ColumnFilter_div_4_ng_template_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, ColumnFilter_div_4_ng_template_3_div_2_p_dropdown_1_Template, 1, 2, "p-dropdown", 33);
    i0.ɵɵelement(2, "p-columnFilterFormElement", 34);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtemplate(4, ColumnFilter_div_4_ng_template_3_div_2_button_4_Template, 3, 4, "button", 35);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const fieldConstraint_r11 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showMatchModes && ctx_r0.matchModes);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r0.type)("field", ctx_r0.field)("filterConstraint", fieldConstraint_r11)("filterTemplate", ctx_r0.filterTemplate)("placeholder", ctx_r0.placeholder)("minFractionDigits", ctx_r0.minFractionDigits)("maxFractionDigits", ctx_r0.maxFractionDigits)("prefix", ctx_r0.prefix)("suffix", ctx_r0.suffix)("locale", ctx_r0.locale)("localeMatcher", ctx_r0.localeMatcher)("currency", ctx_r0.currency)("currencyDisplay", ctx_r0.currencyDisplay)("useGrouping", ctx_r0.useGrouping);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showRemoveIcon);
  }
}
function ColumnFilter_div_4_ng_template_3_div_3_PlusIcon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "PlusIcon", 12);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-button-icon-left");
  }
}
function ColumnFilter_div_4_ng_template_3_div_3_3_ng_template_0_Template(rf, ctx) {}
function ColumnFilter_div_4_ng_template_3_div_3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ColumnFilter_div_4_ng_template_3_div_3_3_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function ColumnFilter_div_4_ng_template_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38)(1, "button", 39);
    i0.ɵɵlistener("click", function ColumnFilter_div_4_ng_template_3_div_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.addConstraint());
    });
    i0.ɵɵtemplate(2, ColumnFilter_div_4_ng_template_3_div_3_PlusIcon_2_Template, 1, 1, "PlusIcon", 10)(3, ColumnFilter_div_4_ng_template_3_div_3_3_Template, 1, 0, null, 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", ctx_r0.addRuleButtonLabel);
    i0.ɵɵattribute("aria-label", ctx_r0.addRuleButtonLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.addRuleIconTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.addRuleIconTemplate);
  }
}
function ColumnFilter_div_4_ng_template_3_div_4_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43, 2);
    i0.ɵɵlistener("click", function ColumnFilter_div_4_ng_template_3_div_4_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.clearFilter());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("label", ctx_r0.clearButtonLabel);
    i0.ɵɵattribute("aria-label", ctx_r0.clearButtonLabel);
  }
}
function ColumnFilter_div_4_ng_template_3_div_4_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 44);
    i0.ɵɵlistener("click", function ColumnFilter_div_4_ng_template_3_div_4_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.applyFilter());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("label", ctx_r0.applyButtonLabel);
    i0.ɵɵattribute("aria-label", ctx_r0.applyButtonLabel);
  }
}
function ColumnFilter_div_4_ng_template_3_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtemplate(1, ColumnFilter_div_4_ng_template_3_div_4_button_1_Template, 2, 2, "button", 41)(2, ColumnFilter_div_4_ng_template_3_div_4_button_2_Template, 1, 2, "button", 42);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showClearButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showApplyButton);
  }
}
function ColumnFilter_div_4_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ColumnFilter_div_4_ng_template_3_div_0_Template, 2, 2, "div", 25);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵtemplate(2, ColumnFilter_div_4_ng_template_3_div_2_Template, 5, 16, "div", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ColumnFilter_div_4_ng_template_3_div_3_Template, 4, 4, "div", 28)(4, ColumnFilter_div_4_ng_template_3_div_4_Template, 3, 2, "div", 29);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isShowOperator);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.fieldConstraints);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isShowAddConstraint);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.showButtons);
  }
}
function ColumnFilter_div_4_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ColumnFilter_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function ColumnFilter_div_4_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onContentClick());
    })("@overlayAnimation.start", function ColumnFilter_div_4_Template_div_animation_overlayAnimation_start_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onOverlayAnimationStart($event));
    })("@overlayAnimation.done", function ColumnFilter_div_4_Template_div_animation_overlayAnimation_done_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onOverlayAnimationEnd($event));
    })("keydown.escape", function ColumnFilter_div_4_Template_div_keydown_escape_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onEscape());
    });
    i0.ɵɵtemplate(1, ColumnFilter_div_4_ng_container_1_Template, 1, 0, "ng-container", 18)(2, ColumnFilter_div_4_ul_2_Template, 5, 2, "ul", 19)(3, ColumnFilter_div_4_ng_template_3_Template, 5, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, ColumnFilter_div_4_ng_container_5_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menu_r16 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c34, ctx_r0.display === "menu"))("id", ctx_r0.overlayId)("@overlayAnimation", "visible");
    i0.ɵɵattribute("aria-modal", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(12, _c15, ctx_r0.field));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.display === "row")("ngIfElse", menu_r16);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.footerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(14, _c15, ctx_r0.field));
  }
}
const _c36 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15) => ({
  $implicit: a0,
  filterCallback: a1,
  type: a2,
  field: a3,
  filterConstraint: a4,
  placeholder: a5,
  minFractionDigits: a6,
  maxFractionDigits: a7,
  prefix: a8,
  suffix: a9,
  locale: a10,
  localeMatcher: a11,
  currency: a12,
  currencyDisplay: a13,
  useGrouping: a14,
  showButtons: a15
});
function ColumnFilterFormElement_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ColumnFilterFormElement_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ColumnFilterFormElement_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.filterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunctionV(2, _c36, [ctx_r0.filterConstraint == null ? null : ctx_r0.filterConstraint.value, ctx_r0.filterCallback, ctx_r0.type, ctx_r0.field, ctx_r0.filterConstraint, ctx_r0.placeholder, ctx_r0.minFractionDigits, ctx_r0.maxFractionDigits, ctx_r0.prefix, ctx_r0.suffix, ctx_r0.locale, ctx_r0.localeMatcher, ctx_r0.currency, ctx_r0.currencyDisplay, ctx_r0.useGrouping, ctx_r0.showButtons]));
  }
}
function ColumnFilterFormElement_ng_template_1_input_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 8);
    i0.ɵɵlistener("input", function ColumnFilterFormElement_ng_template_1_input_1_Template_input_input_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onModelChange($event.target.value));
    })("keydown.enter", function ColumnFilterFormElement_ng_template_1_input_1_Template_input_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onTextInputEnterKeyDown($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ariaLabel", ctx_r0.ariaLabel)("value", ctx_r0.filterConstraint == null ? null : ctx_r0.filterConstraint.value);
    i0.ɵɵattribute("placeholder", ctx_r0.placeholder);
  }
}
function ColumnFilterFormElement_ng_template_1_p_inputNumber_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-inputNumber", 9);
    i0.ɵɵlistener("ngModelChange", function ColumnFilterFormElement_ng_template_1_p_inputNumber_2_Template_p_inputNumber_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onModelChange($event));
    })("onKeyDown", function ColumnFilterFormElement_ng_template_1_p_inputNumber_2_Template_p_inputNumber_onKeyDown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onNumericInputKeyDown($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngModel", ctx_r0.filterConstraint == null ? null : ctx_r0.filterConstraint.value)("showButtons", ctx_r0.showButtons)("minFractionDigits", ctx_r0.minFractionDigits)("maxFractionDigits", ctx_r0.maxFractionDigits)("ariaLabel", ctx_r0.ariaLabel)("prefix", ctx_r0.prefix)("suffix", ctx_r0.suffix)("placeholder", ctx_r0.placeholder)("mode", ctx_r0.currency ? "currency" : "decimal")("locale", ctx_r0.locale)("localeMatcher", ctx_r0.localeMatcher)("currency", ctx_r0.currency)("currencyDisplay", ctx_r0.currencyDisplay)("useGrouping", ctx_r0.useGrouping);
  }
}
function ColumnFilterFormElement_ng_template_1_p_triStateCheckbox_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-triStateCheckbox", 10);
    i0.ɵɵlistener("ngModelChange", function ColumnFilterFormElement_ng_template_1_p_triStateCheckbox_3_Template_p_triStateCheckbox_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onModelChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ariaLabel", ctx_r0.ariaLabel)("ngModel", ctx_r0.filterConstraint == null ? null : ctx_r0.filterConstraint.value);
  }
}
function ColumnFilterFormElement_ng_template_1_p_calendar_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-calendar", 11);
    i0.ɵɵlistener("ngModelChange", function ColumnFilterFormElement_ng_template_1_p_calendar_4_Template_p_calendar_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onModelChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ariaLabel", ctx_r0.ariaLabel)("placeholder", ctx_r0.placeholder)("ngModel", ctx_r0.filterConstraint == null ? null : ctx_r0.filterConstraint.value);
  }
}
function ColumnFilterFormElement_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 3);
    i0.ɵɵtemplate(1, ColumnFilterFormElement_ng_template_1_input_1_Template, 1, 3, "input", 4)(2, ColumnFilterFormElement_ng_template_1_p_inputNumber_2_Template, 1, 14, "p-inputNumber", 5)(3, ColumnFilterFormElement_ng_template_1_p_triStateCheckbox_3_Template, 1, 2, "p-triStateCheckbox", 6)(4, ColumnFilterFormElement_ng_template_1_p_calendar_4_Template, 1, 3, "p-calendar", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r0.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "numeric");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "boolean");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "date");
  }
}
let TableService = /*#__PURE__*/(() => {
  class TableService {
    sortSource = new Subject();
    selectionSource = new Subject();
    contextMenuSource = new Subject();
    valueSource = new Subject();
    totalRecordsSource = new Subject();
    columnsSource = new Subject();
    isHeaderCheckboxSelection = new Subject();
    sortSource$ = this.sortSource.asObservable();
    isHeaderCheckboxSelection$ = this.isHeaderCheckboxSelection.asObservable();
    selectionSource$ = this.selectionSource.asObservable();
    contextMenuSource$ = this.contextMenuSource.asObservable();
    valueSource$ = this.valueSource.asObservable();
    totalRecordsSource$ = this.totalRecordsSource.asObservable();
    columnsSource$ = this.columnsSource.asObservable();
    onSort(sortMeta) {
      this.sortSource.next(sortMeta);
    }
    onSelectionChange() {
      this.selectionSource.next(null);
    }
    onContextMenu(data) {
      this.contextMenuSource.next(data);
    }
    onValueChange(value) {
      this.valueSource.next(value);
    }
    onTotalRecordsChange(value) {
      this.totalRecordsSource.next(value);
    }
    onColumnsChange(columns) {
      this.columnsSource.next(columns);
    }
    onHeaderCheckboxSelection(value) {
      this.isHeaderCheckboxSelection.next(value);
    }
    static ɵfac = function TableService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TableService,
      factory: TableService.ɵfac
    });
  }
  return TableService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Table displays data in tabular format.
 * @group Components
 */
let Table = /*#__PURE__*/(() => {
  class Table {
    document;
    platformId;
    renderer;
    el;
    zone;
    tableService;
    cd;
    filterService;
    overlayService;
    config;
    domSanitizer;
    /**
     * An array of objects to represent dynamic columns that are frozen.
     * @group Props
     */
    frozenColumns;
    /**
     * An array of objects to display as frozen.
     * @group Props
     */
    frozenValue;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    /**
     * Style class of the component.
     * @group Props
     */
    styleClass;
    /**
     * Inline style of the table.
     * @group Props
     */
    tableStyle;
    /**
     * Style class of the table.
     * @group Props
     */
    tableStyleClass;
    /**
     * When specified as true, enables the pagination.
     * @group Props
     */
    paginator;
    /**
     * Number of page links to display in paginator.
     * @group Props
     */
    pageLinks = 5;
    /**
     * Array of integer/object values to display inside rows per page dropdown of paginator
     * @group Props
     */
    rowsPerPageOptions;
    /**
     * Whether to show it even there is only one page.
     * @group Props
     */
    alwaysShowPaginator = true;
    /**
     * Position of the paginator, options are "top", "bottom" or "both".
     * @group Props
     */
    paginatorPosition = 'bottom';
    /**
     * Custom style class for paginator
     * @group Props
     */
    paginatorStyleClass;
    /**
     * Target element to attach the paginator dropdown overlay, valid values are "body" or a local ng-template variable of another element (note: use binding with brackets for template variables, e.g. [appendTo]="mydiv" for a div element having #mydiv as variable name).
     * @group Props
     */
    paginatorDropdownAppendTo;
    /**
     * Paginator dropdown height of the viewport in pixels, a scrollbar is defined if height of list exceeds this value.
     * @group Props
     */
    paginatorDropdownScrollHeight = '200px';
    /**
     * Template of the current page report element. Available placeholders are {currentPage},{totalPages},{rows},{first},{last} and {totalRecords}
     * @group Props
     */
    currentPageReportTemplate = '{currentPage} of {totalPages}';
    /**
     * Whether to display current page report.
     * @group Props
     */
    showCurrentPageReport;
    /**
     * Whether to display a dropdown to navigate to any page.
     * @group Props
     */
    showJumpToPageDropdown;
    /**
     * Whether to display a input to navigate to any page.
     * @group Props
     */
    showJumpToPageInput;
    /**
     * When enabled, icons are displayed on paginator to go first and last page.
     * @group Props
     */
    showFirstLastIcon = true;
    /**
     * Whether to show page links.
     * @group Props
     */
    showPageLinks = true;
    /**
     * Sort order to use when an unsorted column gets sorted by user interaction.
     * @group Props
     */
    defaultSortOrder = 1;
    /**
     * Defines whether sorting works on single column or on multiple columns.
     * @group Props
     */
    sortMode = 'single';
    /**
     * When true, resets paginator to first page after sorting. Available only when sortMode is set to single.
     * @group Props
     */
    resetPageOnSort = true;
    /**
     * Specifies the selection mode, valid values are "single" and "multiple".
     * @group Props
     */
    selectionMode;
    /**
     * When enabled with paginator and checkbox selection mode, the select all checkbox in the header will select all rows on the current page.
     * @group Props
     */
    selectionPageOnly;
    /**
     * Selected row with a context menu.
     * @group Props
     */
    contextMenuSelection;
    /**
     * Callback to invoke on context menu selection change.
     * @param {*} object - row data.
     * @group Emits
     */
    contextMenuSelectionChange = new EventEmitter();
    /**
     *  Defines the behavior of context menu selection, in "separate" mode context menu updates contextMenuSelection property whereas in joint mode selection property is used instead so that when row selection is enabled, both row selection and context menu selection use the same property.
     * @group Props
     */
    contextMenuSelectionMode = 'separate';
    /**
     * A property to uniquely identify a record in data.
     * @group Props
     */
    dataKey;
    /**
     * Defines whether metaKey should be considered for the selection. On touch enabled devices, metaKeySelection is turned off automatically.
     * @group Props
     */
    metaKeySelection = false;
    /**
     * Defines if the row is selectable.
     * @group Props
     */
    rowSelectable;
    /**
     * Function to optimize the dom operations by delegating to ngForTrackBy, default algorithm checks for object identity.
     * @group Props
     */
    rowTrackBy = (index, item) => item;
    /**
     * Defines if data is loaded and interacted with in lazy manner.
     * @group Props
     */
    lazy = false;
    /**
     * Whether to call lazy loading on initialization.
     * @group Props
     */
    lazyLoadOnInit = true;
    /**
     * Algorithm to define if a row is selected, valid values are "equals" that compares by reference and "deepEquals" that compares all fields.
     * @group Props
     */
    compareSelectionBy = 'deepEquals';
    /**
     * Character to use as the csv separator.
     * @group Props
     */
    csvSeparator = ',';
    /**
     * Name of the exported file.
     * @group Props
     */
    exportFilename = 'download';
    /**
     * An array of FilterMetadata objects to provide external filters.
     * @group Props
     */
    filters = {};
    /**
     * An array of fields as string to use in global filtering.
     * @group Props
     */
    globalFilterFields;
    /**
     * Delay in milliseconds before filtering the data.
     * @group Props
     */
    filterDelay = 300;
    /**
     * Locale to use in filtering. The default locale is the host environment's current locale.
     * @group Props
     */
    filterLocale;
    /**
     * Map instance to keep the expanded rows where key of the map is the data key of the row.
     * @group Props
     */
    expandedRowKeys = {};
    /**
     * Map instance to keep the rows being edited where key of the map is the data key of the row.
     * @group Props
     */
    editingRowKeys = {};
    /**
     * Whether multiple rows can be expanded at any time. Valid values are "multiple" and "single".
     * @group Props
     */
    rowExpandMode = 'multiple';
    /**
     * Enables scrollable tables.
     * @group Props
     */
    scrollable;
    /**
     * Orientation of the scrolling, options are "vertical", "horizontal" and "both".
     * @group Props
     * @deprecated Property is obselete since v14.2.0.
     */
    scrollDirection = 'vertical';
    /**
     * Type of the row grouping, valid values are "subheader" and "rowspan".
     * @group Props
     */
    rowGroupMode;
    /**
     * Height of the scroll viewport in fixed pixels or the "flex" keyword for a dynamic size.
     * @group Props
     */
    scrollHeight;
    /**
     * Whether the data should be loaded on demand during scroll.
     * @group Props
     */
    virtualScroll;
    /**
     * Height of a row to use in calculations of virtual scrolling.
     * @group Props
     */
    virtualScrollItemSize;
    /**
     * Whether to use the scroller feature. The properties of scroller component can be used like an object in it.
     * @group Props
     */
    virtualScrollOptions;
    /**
     * Threshold in milliseconds to delay lazy loading during scrolling.
     * @group Props
     */
    virtualScrollDelay = 250;
    /**
     * Width of the frozen columns container.
     * @group Props
     */
    frozenWidth;
    /**
     * Defines if the table is responsive.
     * @group Props
     * @deprecated table is always responsive with scrollable behavior.
     */
    get responsive() {
      return this._responsive;
    }
    set responsive(val) {
      this._responsive = val;
      console.warn('responsive property is deprecated as table is always responsive with scrollable behavior.');
    }
    _responsive;
    /**
     * Local ng-template varilable of a ContextMenu.
     * @group Props
     */
    contextMenu;
    /**
     * When enabled, columns can be resized using drag and drop.
     * @group Props
     */
    resizableColumns;
    /**
     * Defines whether the overall table width should change on column resize, valid values are "fit" and "expand".
     * @group Props
     */
    columnResizeMode = 'fit';
    /**
     * When enabled, columns can be reordered using drag and drop.
     * @group Props
     */
    reorderableColumns;
    /**
     * Displays a loader to indicate data load is in progress.
     * @group Props
     */
    loading;
    /**
     * The icon to show while indicating data load is in progress.
     * @group Props
     */
    loadingIcon;
    /**
     * Whether to show the loading mask when loading property is true.
     * @group Props
     */
    showLoader = true;
    /**
     * Adds hover effect to rows without the need for selectionMode. Note that tr elements that can be hovered need to have "p-selectable-row" class for rowHover to work.
     * @group Props
     */
    rowHover;
    /**
     * Whether to use the default sorting or a custom one using sortFunction.
     * @group Props
     */
    customSort;
    /**
     * Whether to use the initial sort badge or not.
     * @group Props
     */
    showInitialSortBadge = true;
    /**
     * Whether the cell widths scale according to their content or not.  Deprecated:  Table layout is always "auto".
     * @group Props
     */
    autoLayout;
    /**
     * Export function.
     * @group Props
     */
    exportFunction;
    /**
     * Custom export header of the column to be exported as CSV.
     * @group Props
     */
    exportHeader;
    /**
     * Unique identifier of a stateful table to use in state storage.
     * @group Props
     */
    stateKey;
    /**
     * Defines where a stateful table keeps its state, valid values are "session" for sessionStorage and "local" for localStorage.
     * @group Props
     */
    stateStorage = 'session';
    /**
     * Defines the editing mode, valid values are "cell" and "row".
     * @group Props
     */
    editMode = 'cell';
    /**
     * Field name to use in row grouping.
     * @group Props
     */
    groupRowsBy;
    /**
     * Order to sort when default row grouping is enabled.
     * @group Props
     */
    groupRowsByOrder = 1;
    /**
     * Defines the responsive mode, valid options are "stack" and "scroll".
     * @group Props
     */
    responsiveLayout = 'scroll';
    /**
     * The breakpoint to define the maximum width boundary when using stack responsive layout.
     * @group Props
     */
    breakpoint = '960px';
    /**
     * Locale to be used in paginator formatting.
     * @group Props
     */
    paginatorLocale;
    /**
     * An array of objects to display.
     * @group Props
     */
    get value() {
      return this._value;
    }
    set value(val) {
      this._value = val;
    }
    /**
     * An array of objects to represent dynamic columns.
     * @group Props
     */
    get columns() {
      return this._columns;
    }
    set columns(cols) {
      this._columns = cols;
    }
    /**
     * Index of the first row to be displayed.
     * @group Props
     */
    get first() {
      return this._first;
    }
    set first(val) {
      this._first = val;
    }
    /**
     * Number of rows to display per page.
     * @group Props
     */
    get rows() {
      return this._rows;
    }
    set rows(val) {
      this._rows = val;
    }
    /**
     * Number of total records, defaults to length of value when not defined.
     * @group Props
     */
    get totalRecords() {
      return this._totalRecords;
    }
    set totalRecords(val) {
      this._totalRecords = val;
      this.tableService.onTotalRecordsChange(this._totalRecords);
    }
    /**
     * Name of the field to sort data by default.
     * @group Props
     */
    get sortField() {
      return this._sortField;
    }
    set sortField(val) {
      this._sortField = val;
    }
    /**
     * Order to sort when default sorting is enabled.
     * @group Props
     */
    get sortOrder() {
      return this._sortOrder;
    }
    set sortOrder(val) {
      this._sortOrder = val;
    }
    /**
     * An array of SortMeta objects to sort the data by default in multiple sort mode.
     * @group Props
     */
    get multiSortMeta() {
      return this._multiSortMeta;
    }
    set multiSortMeta(val) {
      this._multiSortMeta = val;
    }
    /**
     * Selected row in single mode or an array of values in multiple mode.
     * @group Props
     */
    get selection() {
      return this._selection;
    }
    set selection(val) {
      this._selection = val;
    }
    /**
     * Whether all data is selected.
     * @group Props
     */
    get selectAll() {
      return this._selection;
    }
    set selectAll(val) {
      this._selection = val;
    }
    /**
     * Emits when the all of the items selected or unselected.
     * @param {TableSelectAllChangeEvent} event - custom  all selection change event.
     * @group Emits
     */
    selectAllChange = new EventEmitter();
    /**
     * Callback to invoke on selection changed.
     * @param {any | null} value - selected data.
     * @group Emits
     */
    selectionChange = new EventEmitter();
    /**
     * Callback to invoke when a row is selected.
     * @param {TableRowSelectEvent} event - custom select event.
     * @group Emits
     */
    onRowSelect = new EventEmitter();
    /**
     * Callback to invoke when a row is unselected.
     * @param {TableRowUnSelectEvent} event - custom unselect event.
     * @group Emits
     */
    onRowUnselect = new EventEmitter();
    /**
     * Callback to invoke when pagination occurs.
     * @param {TablePageEvent} event - custom pagination event.
     * @group Emits
     */
    onPage = new EventEmitter();
    /**
     * Callback to invoke when a column gets sorted.
     * @param {Object} object - sort meta.
     * @group Emits
     */
    onSort = new EventEmitter();
    /**
     * Callback to invoke when data is filtered.
     * @param {TableFilterEvent} event - custom filtering event.
     * @group Emits
     */
    onFilter = new EventEmitter();
    /**
     * Callback to invoke when paging, sorting or filtering happens in lazy mode.
     * @param {TableLazyLoadEvent} event - custom lazy loading event.
     * @group Emits
     */
    onLazyLoad = new EventEmitter();
    /**
     * Callback to invoke when a row is expanded.
     * @param {TableRowExpandEvent} event - custom row expand event.
     * @group Emits
     */
    onRowExpand = new EventEmitter();
    /**
     * Callback to invoke when a row is collapsed.
     * @param {TableRowCollapseEvent} event - custom row collapse event.
     * @group Emits
     */
    onRowCollapse = new EventEmitter();
    /**
     * Callback to invoke when a row is selected with right click.
     * @param {TableContextMenuSelectEvent} event - custom context menu select event.
     * @group Emits
     */
    onContextMenuSelect = new EventEmitter();
    /**
     * Callback to invoke when a column is resized.
     * @param {TableColResizeEvent} event - custom column resize event.
     * @group Emits
     */
    onColResize = new EventEmitter();
    /**
     * Callback to invoke when a column is reordered.
     * @param {TableColumnReorderEvent} event - custom column reorder event.
     * @group Emits
     */
    onColReorder = new EventEmitter();
    /**
     * Callback to invoke when a row is reordered.
     * @param {TableRowReorderEvent} event - custom row reorder event.
     * @group Emits
     */
    onRowReorder = new EventEmitter();
    /**
     * Callback to invoke when a cell switches to edit mode.
     * @param {TableEditInitEvent} event - custom edit init event.
     * @group Emits
     */
    onEditInit = new EventEmitter();
    /**
     * Callback to invoke when cell edit is completed.
     * @param {TableEditCompleteEvent} event - custom edit complete event.
     * @group Emits
     */
    onEditComplete = new EventEmitter();
    /**
     * Callback to invoke when cell edit is cancelled with escape key.
     * @param {TableEditCancelEvent} event - custom edit cancel event.
     * @group Emits
     */
    onEditCancel = new EventEmitter();
    /**
     * Callback to invoke when state of header checkbox changes.
     * @param {TableHeaderCheckboxToggleEvent} event - custom header checkbox event.
     * @group Emits
     */
    onHeaderCheckboxToggle = new EventEmitter();
    /**
     * A function to implement custom sorting, refer to sorting section for details.
     * @param {any} any - sort meta.
     * @group Emits
     */
    sortFunction = new EventEmitter();
    /**
     * Callback to invoke on pagination.
     * @param {number} number - first element.
     * @group Emits
     */
    firstChange = new EventEmitter();
    /**
     * Callback to invoke on rows change.
     * @param {number} number - Row count.
     * @group Emits
     */
    rowsChange = new EventEmitter();
    /**
     * Callback to invoke table state is saved.
     * @param {TableState} object - table state.
     * @group Emits
     */
    onStateSave = new EventEmitter();
    /**
     * Callback to invoke table state is restored.
     * @param {TableState} object - table state.
     * @group Emits
     */
    onStateRestore = new EventEmitter();
    containerViewChild;
    resizeHelperViewChild;
    reorderIndicatorUpViewChild;
    reorderIndicatorDownViewChild;
    wrapperViewChild;
    tableViewChild;
    tableHeaderViewChild;
    tableFooterViewChild;
    scroller;
    templates;
    /**
     * Indicates the height of rows to be scrolled.
     * @group Props
     * @deprecated use virtualScrollItemSize property instead.
     */
    get virtualRowHeight() {
      return this._virtualRowHeight;
    }
    set virtualRowHeight(val) {
      this._virtualRowHeight = val;
      console.warn('The virtualRowHeight property is deprecated.');
    }
    _virtualRowHeight = 28;
    _value = [];
    _columns;
    _totalRecords = 0;
    _first = 0;
    _rows;
    filteredValue;
    headerTemplate;
    headerGroupedTemplate;
    bodyTemplate;
    loadingBodyTemplate;
    captionTemplate;
    footerTemplate;
    footerGroupedTemplate;
    summaryTemplate;
    colGroupTemplate;
    expandedRowTemplate;
    groupHeaderTemplate;
    groupFooterTemplate;
    frozenExpandedRowTemplate;
    frozenHeaderTemplate;
    frozenBodyTemplate;
    frozenFooterTemplate;
    frozenColGroupTemplate;
    emptyMessageTemplate;
    paginatorLeftTemplate;
    paginatorRightTemplate;
    paginatorDropdownItemTemplate;
    loadingIconTemplate;
    reorderIndicatorUpIconTemplate;
    reorderIndicatorDownIconTemplate;
    sortIconTemplate;
    checkboxIconTemplate;
    headerCheckboxIconTemplate;
    paginatorDropdownIconTemplate;
    paginatorFirstPageLinkIconTemplate;
    paginatorLastPageLinkIconTemplate;
    paginatorPreviousPageLinkIconTemplate;
    paginatorNextPageLinkIconTemplate;
    selectionKeys = {};
    lastResizerHelperX;
    reorderIconWidth;
    reorderIconHeight;
    draggedColumn;
    draggedRowIndex;
    droppedRowIndex;
    rowDragging;
    dropPosition;
    editingCell;
    editingCellData;
    editingCellField;
    editingCellRowIndex;
    selfClick;
    documentEditListener;
    _multiSortMeta;
    _sortField;
    _sortOrder = 1;
    preventSelectionSetterPropagation;
    _selection;
    _selectAll = null;
    anchorRowIndex;
    rangeRowIndex;
    filterTimeout;
    initialized;
    rowTouched;
    restoringSort;
    restoringFilter;
    stateRestored;
    columnOrderStateRestored;
    columnWidthsState;
    tableWidthState;
    overlaySubscription;
    resizeColumnElement;
    columnResizing = false;
    rowGroupHeaderStyleObject = {};
    id = UniqueComponentId();
    styleElement;
    responsiveStyleElement;
    window;
    constructor(document, platformId, renderer, el, zone, tableService, cd, filterService, overlayService, config, domSanitizer) {
      this.document = document;
      this.platformId = platformId;
      this.renderer = renderer;
      this.el = el;
      this.zone = zone;
      this.tableService = tableService;
      this.cd = cd;
      this.filterService = filterService;
      this.overlayService = overlayService;
      this.config = config;
      this.domSanitizer = domSanitizer;
      this.window = this.document.defaultView;
    }
    ngOnInit() {
      if (this.lazy && this.lazyLoadOnInit) {
        if (!this.virtualScroll) {
          this.onLazyLoad.emit(this.createLazyLoadMetadata());
        }
        if (this.restoringFilter) {
          this.restoringFilter = false;
        }
      }
      if (this.responsiveLayout === 'stack') {
        this.createResponsiveStyle();
      }
      this.initialized = true;
    }
    ngAfterContentInit() {
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'caption':
            this.captionTemplate = item.template;
            break;
          case 'header':
            this.headerTemplate = item.template;
            break;
          case 'headergrouped':
            this.headerGroupedTemplate = item.template;
            break;
          case 'body':
            this.bodyTemplate = item.template;
            break;
          case 'loadingbody':
            this.loadingBodyTemplate = item.template;
            break;
          case 'footer':
            this.footerTemplate = item.template;
            break;
          case 'footergrouped':
            this.footerGroupedTemplate = item.template;
            break;
          case 'summary':
            this.summaryTemplate = item.template;
            break;
          case 'colgroup':
            this.colGroupTemplate = item.template;
            break;
          case 'rowexpansion':
            this.expandedRowTemplate = item.template;
            break;
          case 'groupheader':
            this.groupHeaderTemplate = item.template;
            break;
          case 'groupfooter':
            this.groupFooterTemplate = item.template;
            break;
          case 'frozenheader':
            this.frozenHeaderTemplate = item.template;
            break;
          case 'frozenbody':
            this.frozenBodyTemplate = item.template;
            break;
          case 'frozenfooter':
            this.frozenFooterTemplate = item.template;
            break;
          case 'frozencolgroup':
            this.frozenColGroupTemplate = item.template;
            break;
          case 'frozenrowexpansion':
            this.frozenExpandedRowTemplate = item.template;
            break;
          case 'emptymessage':
            this.emptyMessageTemplate = item.template;
            break;
          case 'paginatorleft':
            this.paginatorLeftTemplate = item.template;
            break;
          case 'paginatorright':
            this.paginatorRightTemplate = item.template;
            break;
          case 'paginatordropdownicon':
            this.paginatorDropdownIconTemplate = item.template;
            break;
          case 'paginatordropdownitem':
            this.paginatorDropdownItemTemplate = item.template;
            break;
          case 'paginatorfirstpagelinkicon':
            this.paginatorFirstPageLinkIconTemplate = item.template;
            break;
          case 'paginatorlastpagelinkicon':
            this.paginatorLastPageLinkIconTemplate = item.template;
            break;
          case 'paginatorpreviouspagelinkicon':
            this.paginatorPreviousPageLinkIconTemplate = item.template;
            break;
          case 'paginatornextpagelinkicon':
            this.paginatorNextPageLinkIconTemplate = item.template;
            break;
          case 'loadingicon':
            this.loadingIconTemplate = item.template;
            break;
          case 'reorderindicatorupicon':
            this.reorderIndicatorUpIconTemplate = item.template;
            break;
          case 'reorderindicatordownicon':
            this.reorderIndicatorDownIconTemplate = item.template;
            break;
          case 'sorticon':
            this.sortIconTemplate = item.template;
            break;
          case 'checkboxicon':
            this.checkboxIconTemplate = item.template;
            break;
          case 'headercheckboxicon':
            this.headerCheckboxIconTemplate = item.template;
            break;
        }
      });
    }
    ngAfterViewInit() {
      if (isPlatformBrowser(this.platformId)) {
        if (this.isStateful() && this.resizableColumns) {
          this.restoreColumnWidths();
        }
      }
    }
    ngOnChanges(simpleChange) {
      if (simpleChange.value) {
        if (this.isStateful() && !this.stateRestored && isPlatformBrowser(this.platformId)) {
          this.restoreState();
        }
        this._value = simpleChange.value.currentValue;
        if (!this.lazy) {
          this.totalRecords = this._value ? this._value.length : 0;
          if (this.sortMode == 'single' && (this.sortField || this.groupRowsBy)) this.sortSingle();else if (this.sortMode == 'multiple' && (this.multiSortMeta || this.groupRowsBy)) this.sortMultiple();else if (this.hasFilter())
            //sort already filters
            this._filter();
        }
        this.tableService.onValueChange(simpleChange.value.currentValue);
      }
      if (simpleChange.columns) {
        if (!this.isStateful()) {
          this._columns = simpleChange.columns.currentValue;
          this.tableService.onColumnsChange(simpleChange.columns.currentValue);
        }
        if (this._columns && this.isStateful() && this.reorderableColumns && !this.columnOrderStateRestored) {
          this.restoreColumnOrder();
          this.tableService.onColumnsChange(this._columns);
        }
      }
      if (simpleChange.sortField) {
        this._sortField = simpleChange.sortField.currentValue;
        //avoid triggering lazy load prior to lazy initialization at onInit
        if (!this.lazy || this.initialized) {
          if (this.sortMode === 'single') {
            this.sortSingle();
          }
        }
      }
      if (simpleChange.groupRowsBy) {
        //avoid triggering lazy load prior to lazy initialization at onInit
        if (!this.lazy || this.initialized) {
          if (this.sortMode === 'single') {
            this.sortSingle();
          }
        }
      }
      if (simpleChange.sortOrder) {
        this._sortOrder = simpleChange.sortOrder.currentValue;
        //avoid triggering lazy load prior to lazy initialization at onInit
        if (!this.lazy || this.initialized) {
          if (this.sortMode === 'single') {
            this.sortSingle();
          }
        }
      }
      if (simpleChange.groupRowsByOrder) {
        //avoid triggering lazy load prior to lazy initialization at onInit
        if (!this.lazy || this.initialized) {
          if (this.sortMode === 'single') {
            this.sortSingle();
          }
        }
      }
      if (simpleChange.multiSortMeta) {
        this._multiSortMeta = simpleChange.multiSortMeta.currentValue;
        if (this.sortMode === 'multiple' && (this.initialized || !this.lazy && !this.virtualScroll)) {
          this.sortMultiple();
        }
      }
      if (simpleChange.selection) {
        this._selection = simpleChange.selection.currentValue;
        if (!this.preventSelectionSetterPropagation) {
          this.updateSelectionKeys();
          this.tableService.onSelectionChange();
        }
        this.preventSelectionSetterPropagation = false;
      }
      if (simpleChange.selectAll) {
        this._selectAll = simpleChange.selectAll.currentValue;
        if (!this.preventSelectionSetterPropagation) {
          this.updateSelectionKeys();
          this.tableService.onSelectionChange();
          if (this.isStateful()) {
            this.saveState();
          }
        }
        this.preventSelectionSetterPropagation = false;
      }
    }
    get processedData() {
      return this.filteredValue || this.value || [];
    }
    _initialColWidths;
    dataToRender(data) {
      const _data = data || this.processedData;
      if (_data && this.paginator) {
        const first = this.lazy ? 0 : this.first;
        return _data.slice(first, first + this.rows);
      }
      return _data;
    }
    updateSelectionKeys() {
      if (this.dataKey && this._selection) {
        this.selectionKeys = {};
        if (Array.isArray(this._selection)) {
          for (let data of this._selection) {
            this.selectionKeys[String(ObjectUtils.resolveFieldData(data, this.dataKey))] = 1;
          }
        } else {
          this.selectionKeys[String(ObjectUtils.resolveFieldData(this._selection, this.dataKey))] = 1;
        }
      }
    }
    onPageChange(event) {
      this.first = event.first;
      this.rows = event.rows;
      this.onPage.emit({
        first: this.first,
        rows: this.rows
      });
      if (this.lazy) {
        this.onLazyLoad.emit(this.createLazyLoadMetadata());
      }
      this.firstChange.emit(this.first);
      this.rowsChange.emit(this.rows);
      this.tableService.onValueChange(this.value);
      if (this.isStateful()) {
        this.saveState();
      }
      this.anchorRowIndex = null;
      if (this.scrollable) {
        this.resetScrollTop();
      }
    }
    sort(event) {
      let originalEvent = event.originalEvent;
      if (this.sortMode === 'single') {
        this._sortOrder = this.sortField === event.field ? this.sortOrder * -1 : this.defaultSortOrder;
        this._sortField = event.field;
        if (this.resetPageOnSort) {
          this._first = 0;
          this.firstChange.emit(this._first);
          if (this.scrollable) {
            this.resetScrollTop();
          }
        }
        this.sortSingle();
      }
      if (this.sortMode === 'multiple') {
        let metaKey = originalEvent.metaKey || originalEvent.ctrlKey;
        let sortMeta = this.getSortMeta(event.field);
        if (sortMeta) {
          if (!metaKey) {
            this._multiSortMeta = [{
              field: event.field,
              order: sortMeta.order * -1
            }];
            if (this.resetPageOnSort) {
              this._first = 0;
              this.firstChange.emit(this._first);
              if (this.scrollable) {
                this.resetScrollTop();
              }
            }
          } else {
            sortMeta.order = sortMeta.order * -1;
          }
        } else {
          if (!metaKey || !this.multiSortMeta) {
            this._multiSortMeta = [];
            if (this.resetPageOnSort) {
              this._first = 0;
              this.firstChange.emit(this._first);
            }
          }
          this._multiSortMeta.push({
            field: event.field,
            order: this.defaultSortOrder
          });
        }
        this.sortMultiple();
      }
      if (this.isStateful()) {
        this.saveState();
      }
      this.anchorRowIndex = null;
    }
    sortSingle() {
      let field = this.sortField || this.groupRowsBy;
      let order = this.sortField ? this.sortOrder : this.groupRowsByOrder;
      if (this.groupRowsBy && this.sortField && this.groupRowsBy !== this.sortField) {
        this._multiSortMeta = [this.getGroupRowsMeta(), {
          field: this.sortField,
          order: this.sortOrder
        }];
        this.sortMultiple();
        return;
      }
      if (field && order) {
        if (this.restoringSort) {
          this.restoringSort = false;
        }
        if (this.lazy) {
          this.onLazyLoad.emit(this.createLazyLoadMetadata());
        } else if (this.value) {
          if (this.customSort) {
            this.sortFunction.emit({
              data: this.value,
              mode: this.sortMode,
              field: field,
              order: order
            });
          } else {
            this.value.sort((data1, data2) => {
              let value1 = ObjectUtils.resolveFieldData(data1, field);
              let value2 = ObjectUtils.resolveFieldData(data2, field);
              let result = null;
              if (value1 == null && value2 != null) result = -1;else if (value1 != null && value2 == null) result = 1;else if (value1 == null && value2 == null) result = 0;else if (typeof value1 === 'string' && typeof value2 === 'string') result = value1.localeCompare(value2);else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
              return order * result;
            });
            this._value = [...this.value];
          }
          if (this.hasFilter()) {
            this._filter();
          }
        }
        let sortMeta = {
          field: field,
          order: order
        };
        this.onSort.emit(sortMeta);
        this.tableService.onSort(sortMeta);
      }
    }
    sortMultiple() {
      if (this.groupRowsBy) {
        if (!this._multiSortMeta) this._multiSortMeta = [this.getGroupRowsMeta()];else if (this.multiSortMeta[0].field !== this.groupRowsBy) this._multiSortMeta = [this.getGroupRowsMeta(), ...this._multiSortMeta];
      }
      if (this.multiSortMeta) {
        if (this.lazy) {
          this.onLazyLoad.emit(this.createLazyLoadMetadata());
        } else if (this.value) {
          if (this.customSort) {
            this.sortFunction.emit({
              data: this.value,
              mode: this.sortMode,
              multiSortMeta: this.multiSortMeta
            });
          } else {
            this.value.sort((data1, data2) => {
              return this.multisortField(data1, data2, this.multiSortMeta, 0);
            });
            this._value = [...this.value];
          }
          if (this.hasFilter()) {
            this._filter();
          }
        }
        this.onSort.emit({
          multisortmeta: this.multiSortMeta
        });
        this.tableService.onSort(this.multiSortMeta);
      }
    }
    multisortField(data1, data2, multiSortMeta, index) {
      const value1 = ObjectUtils.resolveFieldData(data1, multiSortMeta[index].field);
      const value2 = ObjectUtils.resolveFieldData(data2, multiSortMeta[index].field);
      if (ObjectUtils.compare(value1, value2, this.filterLocale) === 0) {
        return multiSortMeta.length - 1 > index ? this.multisortField(data1, data2, multiSortMeta, index + 1) : 0;
      }
      return this.compareValuesOnSort(value1, value2, multiSortMeta[index].order);
    }
    compareValuesOnSort(value1, value2, order) {
      return ObjectUtils.sort(value1, value2, order, this.filterLocale, this.sortOrder);
    }
    getSortMeta(field) {
      if (this.multiSortMeta && this.multiSortMeta.length) {
        for (let i = 0; i < this.multiSortMeta.length; i++) {
          if (this.multiSortMeta[i].field === field) {
            return this.multiSortMeta[i];
          }
        }
      }
      return null;
    }
    isSorted(field) {
      if (this.sortMode === 'single') {
        return this.sortField && this.sortField === field;
      } else if (this.sortMode === 'multiple') {
        let sorted = false;
        if (this.multiSortMeta) {
          for (let i = 0; i < this.multiSortMeta.length; i++) {
            if (this.multiSortMeta[i].field == field) {
              sorted = true;
              break;
            }
          }
        }
        return sorted;
      }
    }
    handleRowClick(event) {
      let target = event.originalEvent.target;
      let targetNode = target.nodeName;
      let parentNode = target.parentElement && target.parentElement.nodeName;
      if (targetNode == 'INPUT' || targetNode == 'BUTTON' || targetNode == 'A' || parentNode == 'INPUT' || parentNode == 'BUTTON' || parentNode == 'A' || DomHandler.hasClass(event.originalEvent.target, 'p-clickable')) {
        return;
      }
      if (this.selectionMode) {
        let rowData = event.rowData;
        let rowIndex = event.rowIndex;
        this.preventSelectionSetterPropagation = true;
        if (this.isMultipleSelectionMode() && event.originalEvent.shiftKey && this.anchorRowIndex != null) {
          DomHandler.clearSelection();
          if (this.rangeRowIndex != null) {
            this.clearSelectionRange(event.originalEvent);
          }
          this.rangeRowIndex = rowIndex;
          this.selectRange(event.originalEvent, rowIndex);
        } else {
          let selected = this.isSelected(rowData);
          if (!selected && !this.isRowSelectable(rowData, rowIndex)) {
            return;
          }
          let metaSelection = this.rowTouched ? false : this.metaKeySelection;
          let dataKeyValue = this.dataKey ? String(ObjectUtils.resolveFieldData(rowData, this.dataKey)) : null;
          this.anchorRowIndex = rowIndex;
          this.rangeRowIndex = rowIndex;
          if (metaSelection) {
            let metaKey = event.originalEvent.metaKey || event.originalEvent.ctrlKey;
            if (selected && metaKey) {
              if (this.isSingleSelectionMode()) {
                this._selection = null;
                this.selectionKeys = {};
                this.selectionChange.emit(null);
              } else {
                let selectionIndex = this.findIndexInSelection(rowData);
                this._selection = this.selection.filter((val, i) => i != selectionIndex);
                this.selectionChange.emit(this.selection);
                if (dataKeyValue) {
                  delete this.selectionKeys[dataKeyValue];
                }
              }
              this.onRowUnselect.emit({
                originalEvent: event.originalEvent,
                data: rowData,
                type: 'row'
              });
            } else {
              if (this.isSingleSelectionMode()) {
                this._selection = rowData;
                this.selectionChange.emit(rowData);
                if (dataKeyValue) {
                  this.selectionKeys = {};
                  this.selectionKeys[dataKeyValue] = 1;
                }
              } else if (this.isMultipleSelectionMode()) {
                if (metaKey) {
                  this._selection = this.selection || [];
                } else {
                  this._selection = [];
                  this.selectionKeys = {};
                }
                this._selection = [...this.selection, rowData];
                this.selectionChange.emit(this.selection);
                if (dataKeyValue) {
                  this.selectionKeys[dataKeyValue] = 1;
                }
              }
              this.onRowSelect.emit({
                originalEvent: event.originalEvent,
                data: rowData,
                type: 'row',
                index: rowIndex
              });
            }
          } else {
            if (this.selectionMode === 'single') {
              if (selected) {
                this._selection = null;
                this.selectionKeys = {};
                this.selectionChange.emit(this.selection);
                this.onRowUnselect.emit({
                  originalEvent: event.originalEvent,
                  data: rowData,
                  type: 'row',
                  index: rowIndex
                });
              } else {
                this._selection = rowData;
                this.selectionChange.emit(this.selection);
                this.onRowSelect.emit({
                  originalEvent: event.originalEvent,
                  data: rowData,
                  type: 'row',
                  index: rowIndex
                });
                if (dataKeyValue) {
                  this.selectionKeys = {};
                  this.selectionKeys[dataKeyValue] = 1;
                }
              }
            } else if (this.selectionMode === 'multiple') {
              if (selected) {
                let selectionIndex = this.findIndexInSelection(rowData);
                this._selection = this.selection.filter((val, i) => i != selectionIndex);
                this.selectionChange.emit(this.selection);
                this.onRowUnselect.emit({
                  originalEvent: event.originalEvent,
                  data: rowData,
                  type: 'row',
                  index: rowIndex
                });
                if (dataKeyValue) {
                  delete this.selectionKeys[dataKeyValue];
                }
              } else {
                this._selection = this.selection ? [...this.selection, rowData] : [rowData];
                this.selectionChange.emit(this.selection);
                this.onRowSelect.emit({
                  originalEvent: event.originalEvent,
                  data: rowData,
                  type: 'row',
                  index: rowIndex
                });
                if (dataKeyValue) {
                  this.selectionKeys[dataKeyValue] = 1;
                }
              }
            }
          }
        }
        this.tableService.onSelectionChange();
        if (this.isStateful()) {
          this.saveState();
        }
      }
      this.rowTouched = false;
    }
    handleRowTouchEnd(event) {
      this.rowTouched = true;
    }
    handleRowRightClick(event) {
      if (this.contextMenu) {
        const rowData = event.rowData;
        const rowIndex = event.rowIndex;
        if (this.contextMenuSelectionMode === 'separate') {
          this.contextMenuSelection = rowData;
          this.contextMenuSelectionChange.emit(rowData);
          this.onContextMenuSelect.emit({
            originalEvent: event.originalEvent,
            data: rowData,
            index: event.rowIndex
          });
          this.contextMenu.show(event.originalEvent);
          this.tableService.onContextMenu(rowData);
        } else if (this.contextMenuSelectionMode === 'joint') {
          this.preventSelectionSetterPropagation = true;
          let selected = this.isSelected(rowData);
          let dataKeyValue = this.dataKey ? String(ObjectUtils.resolveFieldData(rowData, this.dataKey)) : null;
          if (!selected) {
            if (!this.isRowSelectable(rowData, rowIndex)) {
              return;
            }
            if (this.isSingleSelectionMode()) {
              this.selection = rowData;
              this.selectionChange.emit(rowData);
              if (dataKeyValue) {
                this.selectionKeys = {};
                this.selectionKeys[dataKeyValue] = 1;
              }
            } else if (this.isMultipleSelectionMode()) {
              this._selection = this.selection ? [...this.selection, rowData] : [rowData];
              this.selectionChange.emit(this.selection);
              if (dataKeyValue) {
                this.selectionKeys[dataKeyValue] = 1;
              }
            }
          }
          this.tableService.onSelectionChange();
          this.contextMenu.show(event.originalEvent);
          this.onContextMenuSelect.emit({
            originalEvent: event,
            data: rowData,
            index: event.rowIndex
          });
        }
      }
    }
    selectRange(event, rowIndex, isMetaKeySelection) {
      let rangeStart, rangeEnd;
      if (this.anchorRowIndex > rowIndex) {
        rangeStart = rowIndex;
        rangeEnd = this.anchorRowIndex;
      } else if (this.anchorRowIndex < rowIndex) {
        rangeStart = this.anchorRowIndex;
        rangeEnd = rowIndex;
      } else {
        rangeStart = rowIndex;
        rangeEnd = rowIndex;
      }
      if (this.lazy && this.paginator) {
        rangeStart -= this.first;
        rangeEnd -= this.first;
      }
      let rangeRowsData = [];
      for (let i = rangeStart; i <= rangeEnd; i++) {
        let rangeRowData = this.filteredValue ? this.filteredValue[i] : this.value[i];
        if (!this.isSelected(rangeRowData) && !isMetaKeySelection) {
          if (!this.isRowSelectable(rangeRowData, rowIndex)) {
            continue;
          }
          rangeRowsData.push(rangeRowData);
          this._selection = [...this.selection, rangeRowData];
          let dataKeyValue = this.dataKey ? String(ObjectUtils.resolveFieldData(rangeRowData, this.dataKey)) : null;
          if (dataKeyValue) {
            this.selectionKeys[dataKeyValue] = 1;
          }
        }
      }
      this.selectionChange.emit(this.selection);
      this.onRowSelect.emit({
        originalEvent: event,
        data: rangeRowsData,
        type: 'row'
      });
    }
    clearSelectionRange(event) {
      let rangeStart, rangeEnd;
      let rangeRowIndex = this.rangeRowIndex;
      let anchorRowIndex = this.anchorRowIndex;
      if (rangeRowIndex > anchorRowIndex) {
        rangeStart = this.anchorRowIndex;
        rangeEnd = this.rangeRowIndex;
      } else if (rangeRowIndex < anchorRowIndex) {
        rangeStart = this.rangeRowIndex;
        rangeEnd = this.anchorRowIndex;
      } else {
        rangeStart = this.rangeRowIndex;
        rangeEnd = this.rangeRowIndex;
      }
      for (let i = rangeStart; i <= rangeEnd; i++) {
        let rangeRowData = this.value[i];
        let selectionIndex = this.findIndexInSelection(rangeRowData);
        this._selection = this.selection.filter((val, i) => i != selectionIndex);
        let dataKeyValue = this.dataKey ? String(ObjectUtils.resolveFieldData(rangeRowData, this.dataKey)) : null;
        if (dataKeyValue) {
          delete this.selectionKeys[dataKeyValue];
        }
        this.onRowUnselect.emit({
          originalEvent: event,
          data: rangeRowData,
          type: 'row'
        });
      }
    }
    isSelected(rowData) {
      if (rowData && this.selection) {
        if (this.dataKey) {
          return this.selectionKeys[ObjectUtils.resolveFieldData(rowData, this.dataKey)] !== undefined;
        } else {
          if (Array.isArray(this.selection)) return this.findIndexInSelection(rowData) > -1;else return this.equals(rowData, this.selection);
        }
      }
      return false;
    }
    findIndexInSelection(rowData) {
      let index = -1;
      if (this.selection && this.selection.length) {
        for (let i = 0; i < this.selection.length; i++) {
          if (this.equals(rowData, this.selection[i])) {
            index = i;
            break;
          }
        }
      }
      return index;
    }
    isRowSelectable(data, index) {
      if (this.rowSelectable && !this.rowSelectable({
        data,
        index
      })) {
        return false;
      }
      return true;
    }
    toggleRowWithRadio(event, rowData) {
      this.preventSelectionSetterPropagation = true;
      if (this.selection != rowData) {
        if (!this.isRowSelectable(rowData, event.rowIndex)) {
          return;
        }
        this._selection = rowData;
        this.selectionChange.emit(this.selection);
        this.onRowSelect.emit({
          originalEvent: event.originalEvent,
          index: event.rowIndex,
          data: rowData,
          type: 'radiobutton'
        });
        if (this.dataKey) {
          this.selectionKeys = {};
          this.selectionKeys[String(ObjectUtils.resolveFieldData(rowData, this.dataKey))] = 1;
        }
      } else {
        this._selection = null;
        this.selectionChange.emit(this.selection);
        this.onRowUnselect.emit({
          originalEvent: event.originalEvent,
          index: event.rowIndex,
          data: rowData,
          type: 'radiobutton'
        });
      }
      this.tableService.onSelectionChange();
      if (this.isStateful()) {
        this.saveState();
      }
    }
    toggleRowWithCheckbox(event, rowData) {
      this.selection = this.selection || [];
      let selected = this.isSelected(rowData);
      let dataKeyValue = this.dataKey ? String(ObjectUtils.resolveFieldData(rowData, this.dataKey)) : null;
      this.preventSelectionSetterPropagation = true;
      if (selected) {
        let selectionIndex = this.findIndexInSelection(rowData);
        this._selection = this.selection.filter((val, i) => i != selectionIndex);
        this.selectionChange.emit(this.selection);
        this.onRowUnselect.emit({
          originalEvent: event.originalEvent,
          index: event.rowIndex,
          data: rowData,
          type: 'checkbox'
        });
        if (dataKeyValue) {
          delete this.selectionKeys[dataKeyValue];
        }
      } else {
        if (!this.isRowSelectable(rowData, event.rowIndex)) {
          return;
        }
        this._selection = this.selection ? [...this.selection, rowData] : [rowData];
        this.selectionChange.emit(this.selection);
        this.onRowSelect.emit({
          originalEvent: event.originalEvent,
          index: event.rowIndex,
          data: rowData,
          type: 'checkbox'
        });
        if (dataKeyValue) {
          this.selectionKeys[dataKeyValue] = 1;
        }
      }
      this.tableService.onSelectionChange();
      if (this.isStateful()) {
        this.saveState();
      }
    }
    toggleRowsWithCheckbox(event, check) {
      if (this._selectAll !== null) {
        this.selectAllChange.emit({
          originalEvent: event,
          checked: check
        });
      } else {
        const data = this.selectionPageOnly ? this.dataToRender(this.processedData) : this.processedData;
        let selection = this.selectionPageOnly && this._selection ? this._selection.filter(s => !data.some(d => this.equals(s, d))) : [];
        if (check) {
          selection = this.frozenValue ? [...selection, ...this.frozenValue, ...data] : [...selection, ...data];
          selection = this.rowSelectable ? selection.filter((data, index) => this.rowSelectable({
            data,
            index
          })) : selection;
        }
        this._selection = selection;
        this.preventSelectionSetterPropagation = true;
        this.updateSelectionKeys();
        this.selectionChange.emit(this._selection);
        this.tableService.onSelectionChange();
        this.onHeaderCheckboxToggle.emit({
          originalEvent: event,
          checked: check
        });
        if (this.isStateful()) {
          this.saveState();
        }
      }
    }
    equals(data1, data2) {
      return this.compareSelectionBy === 'equals' ? data1 === data2 : ObjectUtils.equals(data1, data2, this.dataKey);
    }
    /* Legacy Filtering for custom elements */
    filter(value, field, matchMode) {
      if (this.filterTimeout) {
        clearTimeout(this.filterTimeout);
      }
      if (!this.isFilterBlank(value)) {
        this.filters[field] = {
          value: value,
          matchMode: matchMode
        };
      } else if (this.filters[field]) {
        delete this.filters[field];
      }
      this.filterTimeout = setTimeout(() => {
        this._filter();
        this.filterTimeout = null;
      }, this.filterDelay);
      this.anchorRowIndex = null;
    }
    filterGlobal(value, matchMode) {
      this.filter(value, 'global', matchMode);
    }
    isFilterBlank(filter) {
      if (filter !== null && filter !== undefined) {
        if (typeof filter === 'string' && filter.trim().length == 0 || Array.isArray(filter) && filter.length == 0) return true;else return false;
      }
      return true;
    }
    _filter() {
      if (!this.restoringFilter) {
        this.first = 0;
        this.firstChange.emit(this.first);
      }
      if (this.lazy) {
        this.onLazyLoad.emit(this.createLazyLoadMetadata());
      } else {
        if (!this.value) {
          return;
        }
        if (!this.hasFilter()) {
          this.filteredValue = null;
          if (this.paginator) {
            this.totalRecords = this.value ? this.value.length : 0;
          }
        } else {
          let globalFilterFieldsArray;
          if (this.filters['global']) {
            if (!this.columns && !this.globalFilterFields) throw new Error('Global filtering requires dynamic columns or globalFilterFields to be defined.');else globalFilterFieldsArray = this.globalFilterFields || this.columns;
          }
          this.filteredValue = [];
          for (let i = 0; i < this.value.length; i++) {
            let localMatch = true;
            let globalMatch = false;
            let localFiltered = false;
            for (let prop in this.filters) {
              if (this.filters.hasOwnProperty(prop) && prop !== 'global') {
                localFiltered = true;
                let filterField = prop;
                let filterMeta = this.filters[filterField];
                if (Array.isArray(filterMeta)) {
                  for (let meta of filterMeta) {
                    localMatch = this.executeLocalFilter(filterField, this.value[i], meta);
                    if (meta.operator === FilterOperator.OR && localMatch || meta.operator === FilterOperator.AND && !localMatch) {
                      break;
                    }
                  }
                } else {
                  localMatch = this.executeLocalFilter(filterField, this.value[i], filterMeta);
                }
                if (!localMatch) {
                  break;
                }
              }
            }
            if (this.filters['global'] && !globalMatch && globalFilterFieldsArray) {
              for (let j = 0; j < globalFilterFieldsArray.length; j++) {
                let globalFilterField = globalFilterFieldsArray[j].field || globalFilterFieldsArray[j];
                globalMatch = this.filterService.filters[this.filters['global'].matchMode](ObjectUtils.resolveFieldData(this.value[i], globalFilterField), this.filters['global'].value, this.filterLocale);
                if (globalMatch) {
                  break;
                }
              }
            }
            let matches;
            if (this.filters['global']) {
              matches = localFiltered ? localFiltered && localMatch && globalMatch : globalMatch;
            } else {
              matches = localFiltered && localMatch;
            }
            if (matches) {
              this.filteredValue.push(this.value[i]);
            }
          }
          if (this.filteredValue.length === this.value.length) {
            this.filteredValue = null;
          }
          if (this.paginator) {
            this.totalRecords = this.filteredValue ? this.filteredValue.length : this.value ? this.value.length : 0;
          }
        }
      }
      this.onFilter.emit({
        filters: this.filters,
        filteredValue: this.filteredValue || this.value
      });
      this.tableService.onValueChange(this.value);
      if (this.isStateful() && !this.restoringFilter) {
        this.saveState();
      }
      if (this.restoringFilter) {
        this.restoringFilter = false;
      }
      this.cd.markForCheck();
      if (this.scrollable) {
        this.resetScrollTop();
      }
    }
    executeLocalFilter(field, rowData, filterMeta) {
      let filterValue = filterMeta.value;
      let filterMatchMode = filterMeta.matchMode || FilterMatchMode.STARTS_WITH;
      let dataFieldValue = ObjectUtils.resolveFieldData(rowData, field);
      let filterConstraint = this.filterService.filters[filterMatchMode];
      return filterConstraint(dataFieldValue, filterValue, this.filterLocale);
    }
    hasFilter() {
      let empty = true;
      for (let prop in this.filters) {
        if (this.filters.hasOwnProperty(prop)) {
          empty = false;
          break;
        }
      }
      return !empty;
    }
    createLazyLoadMetadata() {
      return {
        first: this.first,
        rows: this.rows,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        filters: this.filters,
        globalFilter: this.filters && this.filters['global'] ? this.filters['global'].value : null,
        multiSortMeta: this.multiSortMeta,
        forceUpdate: () => this.cd.detectChanges()
      };
    }
    clear() {
      this._sortField = null;
      this._sortOrder = this.defaultSortOrder;
      this._multiSortMeta = null;
      this.tableService.onSort(null);
      this.clearFilterValues();
      this.filteredValue = null;
      this.first = 0;
      this.firstChange.emit(this.first);
      if (this.lazy) {
        this.onLazyLoad.emit(this.createLazyLoadMetadata());
      } else {
        this.totalRecords = this._value ? this._value.length : 0;
      }
    }
    clearFilterValues() {
      for (const [, filterMetadata] of Object.entries(this.filters)) {
        if (Array.isArray(filterMetadata)) {
          for (let filter of filterMetadata) {
            filter.value = null;
          }
        } else if (filterMetadata) {
          filterMetadata.value = null;
        }
      }
    }
    reset() {
      this.clear();
    }
    getExportHeader(column) {
      return column[this.exportHeader] || column.header || column.field;
    }
    /**
     * Data export method.
     * @param {ExportCSVOptions} object - Export options.
     * @group Method
     */
    exportCSV(options) {
      let data;
      let csv = '';
      let columns = this.columns;
      if (options && options.selectionOnly) {
        data = this.selection || [];
      } else if (options && options.allValues) {
        data = this.value || [];
      } else {
        data = this.filteredValue || this.value;
        if (this.frozenValue) {
          data = data ? [...this.frozenValue, ...data] : this.frozenValue;
        }
      }
      const exportableColumns = columns.filter(column => column.exportable !== false && column.field);
      //headers
      csv += exportableColumns.map(column => '"' + this.getExportHeader(column) + '"').join(this.csvSeparator);
      //body
      const body = data.map(record => exportableColumns.map(column => {
        let cellData = ObjectUtils.resolveFieldData(record, column.field);
        if (cellData != null) {
          if (this.exportFunction) {
            cellData = this.exportFunction({
              data: cellData,
              field: column.field
            });
          } else cellData = String(cellData).replace(/"/g, '""');
        } else cellData = '';
        return '"' + cellData + '"';
      }).join(this.csvSeparator)).join('\n');
      if (body.length) {
        csv += '\n' + body;
      }
      let blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csv], {
        type: 'text/csv;charset=utf-8;'
      });
      let link = this.renderer.createElement('a');
      link.style.display = 'none';
      this.renderer.appendChild(this.document.body, link);
      if (link.download !== undefined) {
        link.setAttribute('href', URL.createObjectURL(blob));
        link.setAttribute('download', this.exportFilename + '.csv');
        link.click();
      } else {
        csv = 'data:text/csv;charset=utf-8,' + csv;
        this.window.open(encodeURI(csv));
      }
      this.renderer.removeChild(this.document.body, link);
    }
    onLazyItemLoad(event) {
      this.onLazyLoad.emit({
        ...this.createLazyLoadMetadata(),
        ...event,
        rows: event.last - event.first
      });
    }
    /**
     * Resets scroll to top.
     * @group Method
     */
    resetScrollTop() {
      if (this.virtualScroll) this.scrollToVirtualIndex(0);else this.scrollTo({
        top: 0
      });
    }
    /**
     * Scrolls to given index when using virtual scroll.
     * @param {number} index - index of the element.
     * @group Method
     */
    scrollToVirtualIndex(index) {
      this.scroller && this.scroller.scrollToIndex(index);
    }
    /**
     * Scrolls to given index.
     * @param {ScrollToOptions} options - scroll options.
     * @group Method
     */
    scrollTo(options) {
      if (this.virtualScroll) {
        this.scroller?.scrollTo(options);
      } else if (this.wrapperViewChild && this.wrapperViewChild.nativeElement) {
        if (this.wrapperViewChild.nativeElement.scrollTo) {
          this.wrapperViewChild.nativeElement.scrollTo(options);
        } else {
          this.wrapperViewChild.nativeElement.scrollLeft = options.left;
          this.wrapperViewChild.nativeElement.scrollTop = options.top;
        }
      }
    }
    updateEditingCell(cell, data, field, index) {
      this.editingCell = cell;
      this.editingCellData = data;
      this.editingCellField = field;
      this.editingCellRowIndex = index;
      this.bindDocumentEditListener();
    }
    isEditingCellValid() {
      return this.editingCell && DomHandler.find(this.editingCell, '.ng-invalid.ng-dirty').length === 0;
    }
    bindDocumentEditListener() {
      if (!this.documentEditListener) {
        this.documentEditListener = this.renderer.listen(this.document, 'click', event => {
          if (this.editingCell && !this.selfClick && this.isEditingCellValid()) {
            DomHandler.removeClass(this.editingCell, 'p-cell-editing');
            this.editingCell = null;
            this.onEditComplete.emit({
              field: this.editingCellField,
              data: this.editingCellData,
              originalEvent: event,
              index: this.editingCellRowIndex
            });
            this.editingCellField = null;
            this.editingCellData = null;
            this.editingCellRowIndex = null;
            this.unbindDocumentEditListener();
            this.cd.markForCheck();
            if (this.overlaySubscription) {
              this.overlaySubscription.unsubscribe();
            }
          }
          this.selfClick = false;
        });
      }
    }
    unbindDocumentEditListener() {
      if (this.documentEditListener) {
        this.documentEditListener();
        this.documentEditListener = null;
      }
    }
    initRowEdit(rowData) {
      let dataKeyValue = String(ObjectUtils.resolveFieldData(rowData, this.dataKey));
      this.editingRowKeys[dataKeyValue] = true;
    }
    saveRowEdit(rowData, rowElement) {
      if (DomHandler.find(rowElement, '.ng-invalid.ng-dirty').length === 0) {
        let dataKeyValue = String(ObjectUtils.resolveFieldData(rowData, this.dataKey));
        delete this.editingRowKeys[dataKeyValue];
      }
    }
    cancelRowEdit(rowData) {
      let dataKeyValue = String(ObjectUtils.resolveFieldData(rowData, this.dataKey));
      delete this.editingRowKeys[dataKeyValue];
    }
    toggleRow(rowData, event) {
      if (!this.dataKey && !this.groupRowsBy) {
        throw new Error('dataKey or groupRowsBy must be defined to use row expansion');
      }
      let dataKeyValue = this.groupRowsBy ? String(ObjectUtils.resolveFieldData(rowData, this.groupRowsBy)) : String(ObjectUtils.resolveFieldData(rowData, this.dataKey));
      if (this.expandedRowKeys[dataKeyValue] != null) {
        delete this.expandedRowKeys[dataKeyValue];
        this.onRowCollapse.emit({
          originalEvent: event,
          data: rowData
        });
      } else {
        if (this.rowExpandMode === 'single') {
          this.expandedRowKeys = {};
        }
        this.expandedRowKeys[dataKeyValue] = true;
        this.onRowExpand.emit({
          originalEvent: event,
          data: rowData
        });
      }
      if (event) {
        event.preventDefault();
      }
      if (this.isStateful()) {
        this.saveState();
      }
    }
    isRowExpanded(rowData) {
      return this.groupRowsBy ? this.expandedRowKeys[String(ObjectUtils.resolveFieldData(rowData, this.groupRowsBy))] === true : this.expandedRowKeys[String(ObjectUtils.resolveFieldData(rowData, this.dataKey))] === true;
    }
    isRowEditing(rowData) {
      return this.editingRowKeys[String(ObjectUtils.resolveFieldData(rowData, this.dataKey))] === true;
    }
    isSingleSelectionMode() {
      return this.selectionMode === 'single';
    }
    isMultipleSelectionMode() {
      return this.selectionMode === 'multiple';
    }
    onColumnResizeBegin(event) {
      let containerLeft = DomHandler.getOffset(this.containerViewChild?.nativeElement).left;
      this.resizeColumnElement = event.target.closest('th');
      this.columnResizing = true;
      if (event.type == 'touchstart') {
        this.lastResizerHelperX = event.changedTouches[0].clientX - containerLeft + this.containerViewChild?.nativeElement.scrollLeft;
      } else {
        this.lastResizerHelperX = event.pageX - containerLeft + this.containerViewChild?.nativeElement.scrollLeft;
      }
      this.onColumnResize(event);
      event.preventDefault();
    }
    onColumnResize(event) {
      let containerLeft = DomHandler.getOffset(this.containerViewChild?.nativeElement).left;
      DomHandler.addClass(this.containerViewChild?.nativeElement, 'p-unselectable-text');
      this.resizeHelperViewChild.nativeElement.style.height = this.containerViewChild?.nativeElement.offsetHeight + 'px';
      this.resizeHelperViewChild.nativeElement.style.top = 0 + 'px';
      if (event.type == 'touchmove') {
        this.resizeHelperViewChild.nativeElement.style.left = event.changedTouches[0].clientX - containerLeft + this.containerViewChild?.nativeElement.scrollLeft + 'px';
      } else {
        this.resizeHelperViewChild.nativeElement.style.left = event.pageX - containerLeft + this.containerViewChild?.nativeElement.scrollLeft + 'px';
      }
      this.resizeHelperViewChild.nativeElement.style.display = 'block';
    }
    onColumnResizeEnd() {
      const delta = this.resizeHelperViewChild?.nativeElement.offsetLeft - this.lastResizerHelperX;
      const columnWidth = this.resizeColumnElement.offsetWidth;
      const newColumnWidth = columnWidth + delta;
      const elementMinWidth = this.resizeColumnElement.style.minWidth.replace(/[^\d.]/g, '');
      const minWidth = elementMinWidth ? parseFloat(elementMinWidth) : 15;
      if (newColumnWidth >= minWidth) {
        if (this.columnResizeMode === 'fit') {
          const nextColumn = this.resizeColumnElement.nextElementSibling;
          const nextColumnWidth = nextColumn.offsetWidth - delta;
          if (newColumnWidth > 15 && nextColumnWidth > 15) {
            this.resizeTableCells(newColumnWidth, nextColumnWidth);
          }
        } else if (this.columnResizeMode === 'expand') {
          this._initialColWidths = this._totalTableWidth();
          const tableWidth = this.tableViewChild?.nativeElement.offsetWidth + delta;
          this.setResizeTableWidth(tableWidth + 'px');
          this.resizeTableCells(newColumnWidth, null);
        }
        this.onColResize.emit({
          element: this.resizeColumnElement,
          delta: delta
        });
        if (this.isStateful()) {
          this.saveState();
        }
      }
      this.resizeHelperViewChild.nativeElement.style.display = 'none';
      DomHandler.removeClass(this.containerViewChild?.nativeElement, 'p-unselectable-text');
    }
    _totalTableWidth() {
      let widths = [];
      const tableHead = DomHandler.findSingle(this.containerViewChild.nativeElement, '.p-datatable-thead');
      let headers = DomHandler.find(tableHead, 'tr > th');
      headers.forEach(header => widths.push(DomHandler.getOuterWidth(header)));
      return widths;
    }
    onColumnDragStart(event, columnElement) {
      this.reorderIconWidth = DomHandler.getHiddenElementOuterWidth(this.reorderIndicatorUpViewChild?.nativeElement);
      this.reorderIconHeight = DomHandler.getHiddenElementOuterHeight(this.reorderIndicatorDownViewChild?.nativeElement);
      this.draggedColumn = columnElement;
      event.dataTransfer.setData('text', 'b'); // For firefox
    }
    onColumnDragEnter(event, dropHeader) {
      if (this.reorderableColumns && this.draggedColumn && dropHeader) {
        event.preventDefault();
        let containerOffset = DomHandler.getOffset(this.containerViewChild?.nativeElement);
        let dropHeaderOffset = DomHandler.getOffset(dropHeader);
        if (this.draggedColumn != dropHeader) {
          let dragIndex = DomHandler.indexWithinGroup(this.draggedColumn, 'preorderablecolumn');
          let dropIndex = DomHandler.indexWithinGroup(dropHeader, 'preorderablecolumn');
          let targetLeft = dropHeaderOffset.left - containerOffset.left;
          let targetTop = containerOffset.top - dropHeaderOffset.top;
          let columnCenter = dropHeaderOffset.left + dropHeader.offsetWidth / 2;
          this.reorderIndicatorUpViewChild.nativeElement.style.top = dropHeaderOffset.top - containerOffset.top - (this.reorderIconHeight - 1) + 'px';
          this.reorderIndicatorDownViewChild.nativeElement.style.top = dropHeaderOffset.top - containerOffset.top + dropHeader.offsetHeight + 'px';
          if (event.pageX > columnCenter) {
            this.reorderIndicatorUpViewChild.nativeElement.style.left = targetLeft + dropHeader.offsetWidth - Math.ceil(this.reorderIconWidth / 2) + 'px';
            this.reorderIndicatorDownViewChild.nativeElement.style.left = targetLeft + dropHeader.offsetWidth - Math.ceil(this.reorderIconWidth / 2) + 'px';
            this.dropPosition = 1;
          } else {
            this.reorderIndicatorUpViewChild.nativeElement.style.left = targetLeft - Math.ceil(this.reorderIconWidth / 2) + 'px';
            this.reorderIndicatorDownViewChild.nativeElement.style.left = targetLeft - Math.ceil(this.reorderIconWidth / 2) + 'px';
            this.dropPosition = -1;
          }
          this.reorderIndicatorUpViewChild.nativeElement.style.display = 'block';
          this.reorderIndicatorDownViewChild.nativeElement.style.display = 'block';
        } else {
          event.dataTransfer.dropEffect = 'none';
        }
      }
    }
    onColumnDragLeave(event) {
      if (this.reorderableColumns && this.draggedColumn) {
        event.preventDefault();
      }
    }
    onColumnDrop(event, dropColumn) {
      event.preventDefault();
      if (this.draggedColumn) {
        let dragIndex = DomHandler.indexWithinGroup(this.draggedColumn, 'preorderablecolumn');
        let dropIndex = DomHandler.indexWithinGroup(dropColumn, 'preorderablecolumn');
        let allowDrop = dragIndex != dropIndex;
        if (allowDrop && (dropIndex - dragIndex == 1 && this.dropPosition === -1 || dragIndex - dropIndex == 1 && this.dropPosition === 1)) {
          allowDrop = false;
        }
        if (allowDrop && dropIndex < dragIndex && this.dropPosition === 1) {
          dropIndex = dropIndex + 1;
        }
        if (allowDrop && dropIndex > dragIndex && this.dropPosition === -1) {
          dropIndex = dropIndex - 1;
        }
        if (allowDrop) {
          ObjectUtils.reorderArray(this.columns, dragIndex, dropIndex);
          this.onColReorder.emit({
            dragIndex: dragIndex,
            dropIndex: dropIndex,
            columns: this.columns
          });
          if (this.isStateful()) {
            this.zone.runOutsideAngular(() => {
              setTimeout(() => {
                this.saveState();
              });
            });
          }
        }
        if (this.resizableColumns && this.resizeColumnElement) {
          let width = this.columnResizeMode === 'expand' ? this._initialColWidths : this._totalTableWidth();
          ObjectUtils.reorderArray(width, dragIndex + 1, dropIndex + 1);
          this.updateStyleElement(width, dragIndex, null, null);
        }
        this.reorderIndicatorUpViewChild.nativeElement.style.display = 'none';
        this.reorderIndicatorDownViewChild.nativeElement.style.display = 'none';
        this.draggedColumn.draggable = false;
        this.draggedColumn = null;
        this.dropPosition = null;
      }
    }
    resizeTableCells(newColumnWidth, nextColumnWidth) {
      let colIndex = DomHandler.index(this.resizeColumnElement);
      let width = this.columnResizeMode === 'expand' ? this._initialColWidths : this._totalTableWidth();
      this.updateStyleElement(width, colIndex, newColumnWidth, nextColumnWidth);
    }
    updateStyleElement(width, colIndex, newColumnWidth, nextColumnWidth) {
      this.destroyStyleElement();
      this.createStyleElement();
      let innerHTML = '';
      width.forEach((width, index) => {
        let colWidth = index === colIndex ? newColumnWidth : nextColumnWidth && index === colIndex + 1 ? nextColumnWidth : width;
        let style = `width: ${colWidth}px !important; max-width: ${colWidth}px !important;`;
        innerHTML += `
                #${this.id}-table > .p-datatable-thead > tr > th:nth-child(${index + 1}),
                #${this.id}-table > .p-datatable-tbody > tr > td:nth-child(${index + 1}),
                #${this.id}-table > .p-datatable-tfoot > tr > td:nth-child(${index + 1}) {
                    ${style}
                }
            `;
      });
      this.renderer.setProperty(this.styleElement, 'innerHTML', this.domSanitizer.bypassSecurityTrustStyle(innerHTML));
    }
    onRowDragStart(event, index) {
      this.rowDragging = true;
      this.draggedRowIndex = index;
      event.dataTransfer.setData('text', 'b'); // For firefox
    }
    onRowDragOver(event, index, rowElement) {
      if (this.rowDragging && this.draggedRowIndex !== index) {
        let rowY = DomHandler.getOffset(rowElement).top;
        let pageY = event.pageY;
        let rowMidY = rowY + DomHandler.getOuterHeight(rowElement) / 2;
        let prevRowElement = rowElement.previousElementSibling;
        if (pageY < rowMidY) {
          DomHandler.removeClass(rowElement, 'p-datatable-dragpoint-bottom');
          this.droppedRowIndex = index;
          if (prevRowElement) DomHandler.addClass(prevRowElement, 'p-datatable-dragpoint-bottom');else DomHandler.addClass(rowElement, 'p-datatable-dragpoint-top');
        } else {
          if (prevRowElement) DomHandler.removeClass(prevRowElement, 'p-datatable-dragpoint-bottom');else DomHandler.addClass(rowElement, 'p-datatable-dragpoint-top');
          this.droppedRowIndex = index + 1;
          DomHandler.addClass(rowElement, 'p-datatable-dragpoint-bottom');
        }
      }
    }
    onRowDragLeave(event, rowElement) {
      let prevRowElement = rowElement.previousElementSibling;
      if (prevRowElement) {
        DomHandler.removeClass(prevRowElement, 'p-datatable-dragpoint-bottom');
      }
      DomHandler.removeClass(rowElement, 'p-datatable-dragpoint-bottom');
      DomHandler.removeClass(rowElement, 'p-datatable-dragpoint-top');
    }
    onRowDragEnd(event) {
      this.rowDragging = false;
      this.draggedRowIndex = null;
      this.droppedRowIndex = null;
    }
    onRowDrop(event, rowElement) {
      if (this.droppedRowIndex != null) {
        let dropIndex = this.draggedRowIndex > this.droppedRowIndex ? this.droppedRowIndex : this.droppedRowIndex === 0 ? 0 : this.droppedRowIndex - 1;
        ObjectUtils.reorderArray(this.value, this.draggedRowIndex, dropIndex);
        if (this.virtualScroll) {
          // TODO: Check
          this._value = [...this._value];
        }
        this.onRowReorder.emit({
          dragIndex: this.draggedRowIndex,
          dropIndex: dropIndex
        });
      }
      //cleanup
      this.onRowDragLeave(event, rowElement);
      this.onRowDragEnd(event);
    }
    isEmpty() {
      let data = this.filteredValue || this.value;
      return data == null || data.length == 0;
    }
    getBlockableElement() {
      return this.el.nativeElement.children[0];
    }
    getStorage() {
      if (isPlatformBrowser(this.platformId)) {
        switch (this.stateStorage) {
          case 'local':
            return window.localStorage;
          case 'session':
            return window.sessionStorage;
          default:
            throw new Error(this.stateStorage + ' is not a valid value for the state storage, supported values are "local" and "session".');
        }
      } else {
        throw new Error('Browser storage is not available in the server side.');
      }
    }
    isStateful() {
      return this.stateKey != null;
    }
    saveState() {
      const storage = this.getStorage();
      let state = {};
      if (this.paginator) {
        state.first = this.first;
        state.rows = this.rows;
      }
      if (this.sortField) {
        state.sortField = this.sortField;
        state.sortOrder = this.sortOrder;
      }
      if (this.multiSortMeta) {
        state.multiSortMeta = this.multiSortMeta;
      }
      if (this.hasFilter()) {
        state.filters = this.filters;
      }
      if (this.resizableColumns) {
        this.saveColumnWidths(state);
      }
      if (this.reorderableColumns) {
        this.saveColumnOrder(state);
      }
      if (this.selection) {
        state.selection = this.selection;
      }
      if (Object.keys(this.expandedRowKeys).length) {
        state.expandedRowKeys = this.expandedRowKeys;
      }
      storage.setItem(this.stateKey, JSON.stringify(state));
      this.onStateSave.emit(state);
    }
    clearState() {
      const storage = this.getStorage();
      if (this.stateKey) {
        storage.removeItem(this.stateKey);
      }
    }
    restoreState() {
      const storage = this.getStorage();
      const stateString = storage.getItem(this.stateKey);
      const dateFormat = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/;
      const reviver = function (key, value) {
        if (typeof value === 'string' && dateFormat.test(value)) {
          return new Date(value);
        }
        return value;
      };
      if (stateString) {
        let state = JSON.parse(stateString, reviver);
        if (this.paginator) {
          if (this.first !== undefined) {
            this.first = state.first;
            this.firstChange.emit(this.first);
          }
          if (this.rows !== undefined) {
            this.rows = state.rows;
            this.rowsChange.emit(this.rows);
          }
        }
        if (state.sortField) {
          this.restoringSort = true;
          this._sortField = state.sortField;
          this._sortOrder = state.sortOrder;
        }
        if (state.multiSortMeta) {
          this.restoringSort = true;
          this._multiSortMeta = state.multiSortMeta;
        }
        if (state.filters) {
          this.restoringFilter = true;
          this.filters = state.filters;
        }
        if (this.resizableColumns) {
          this.columnWidthsState = state.columnWidths;
          this.tableWidthState = state.tableWidth;
        }
        // if (this.reorderableColumns) {
        //     this.restoreColumnOrder();
        // }
        if (state.expandedRowKeys) {
          this.expandedRowKeys = state.expandedRowKeys;
        }
        if (state.selection) {
          Promise.resolve(null).then(() => this.selectionChange.emit(state.selection));
        }
        this.stateRestored = true;
        this.onStateRestore.emit(state);
      }
    }
    saveColumnWidths(state) {
      let widths = [];
      let headers = [];
      const container = this.containerViewChild?.nativeElement;
      if (container) {
        headers = DomHandler.find(container, '.p-datatable-thead > tr > th');
      }
      headers.forEach(header => widths.push(DomHandler.getOuterWidth(header)));
      state.columnWidths = widths.join(',');
      if (this.columnResizeMode === 'expand') {
        state.tableWidth = DomHandler.getOuterWidth(this.tableViewChild?.nativeElement);
      }
    }
    setResizeTableWidth(width) {
      this.tableViewChild.nativeElement.style.width = width;
      this.tableViewChild.nativeElement.style.minWidth = width;
    }
    restoreColumnWidths() {
      if (this.columnWidthsState) {
        let widths = this.columnWidthsState.split(',');
        if (this.columnResizeMode === 'expand' && this.tableWidthState) {
          this.setResizeTableWidth(this.tableWidthState + 'px');
        }
        if (ObjectUtils.isNotEmpty(widths)) {
          this.createStyleElement();
          let innerHTML = '';
          widths.forEach((width, index) => {
            let style = `width: ${width}px !important; max-width: ${width}px !important`;
            innerHTML += `
                        #${this.id}-table > .p-datatable-thead > tr > th:nth-child(${index + 1}),
                        #${this.id}-table > .p-datatable-tbody > tr > td:nth-child(${index + 1}),
                        #${this.id}-table > .p-datatable-tfoot > tr > td:nth-child(${index + 1}) {
                            ${style}
                        }
                    `;
          });
          this.styleElement.textContent = innerHTML;
        }
      }
    }
    saveColumnOrder(state) {
      if (this.columns) {
        let columnOrder = [];
        this.columns.map(column => {
          columnOrder.push(column.field || column.key);
        });
        state.columnOrder = columnOrder;
      }
    }
    restoreColumnOrder() {
      const storage = this.getStorage();
      const stateString = storage.getItem(this.stateKey);
      if (stateString) {
        let state = JSON.parse(stateString);
        let columnOrder = state.columnOrder;
        if (columnOrder) {
          let reorderedColumns = [];
          columnOrder.map(key => {
            let col = this.findColumnByKey(key);
            if (col) {
              reorderedColumns.push(col);
            }
          });
          this.columnOrderStateRestored = true;
          this.columns = reorderedColumns;
        }
      }
    }
    findColumnByKey(key) {
      if (this.columns) {
        for (let col of this.columns) {
          if (col.key === key || col.field === key) return col;else continue;
        }
      } else {
        return null;
      }
    }
    createStyleElement() {
      this.styleElement = this.renderer.createElement('style');
      this.styleElement.type = 'text/css';
      DomHandler.setAttribute(this.styleElement, 'nonce', this.config?.csp()?.nonce);
      this.renderer.appendChild(this.document.head, this.styleElement);
    }
    getGroupRowsMeta() {
      return {
        field: this.groupRowsBy,
        order: this.groupRowsByOrder
      };
    }
    createResponsiveStyle() {
      if (isPlatformBrowser(this.platformId)) {
        if (!this.responsiveStyleElement) {
          this.responsiveStyleElement = this.renderer.createElement('style');
          this.responsiveStyleElement.type = 'text/css';
          DomHandler.setAttribute(this.responsiveStyleElement, 'nonce', this.config?.csp()?.nonce);
          this.renderer.appendChild(this.document.head, this.responsiveStyleElement);
          let innerHTML = `
    @media screen and (max-width: ${this.breakpoint}) {
        #${this.id}-table > .p-datatable-thead > tr > th,
        #${this.id}-table > .p-datatable-tfoot > tr > td {
            display: none !important;
        }

        #${this.id}-table > .p-datatable-tbody > tr > td {
            display: flex;
            width: 100% !important;
            align-items: center;
            justify-content: space-between;
        }

        #${this.id}-table > .p-datatable-tbody > tr > td:not(:last-child) {
            border: 0 none;
        }

        #${this.id}.p-datatable-gridlines > .p-datatable-wrapper > .p-datatable-table > .p-datatable-tbody > tr > td:last-child {
            border-top: 0;
            border-right: 0;
            border-left: 0;
        }

        #${this.id}-table > .p-datatable-tbody > tr > td > .p-column-title {
            display: block;
        }
    }
    `;
          this.renderer.setProperty(this.responsiveStyleElement, 'innerHTML', this.domSanitizer.bypassSecurityTrustStyle(innerHTML));
        }
      }
    }
    destroyResponsiveStyle() {
      if (this.responsiveStyleElement) {
        this.renderer.removeChild(this.document.head, this.responsiveStyleElement);
        this.responsiveStyleElement = null;
      }
    }
    destroyStyleElement() {
      if (this.styleElement) {
        this.renderer.removeChild(this.document.head, this.styleElement);
        this.styleElement = null;
      }
    }
    ngOnDestroy() {
      this.unbindDocumentEditListener();
      this.editingCell = null;
      this.initialized = null;
      this.destroyStyleElement();
      this.destroyResponsiveStyle();
    }
    getPaginatorStyleClasses(className) {
      return [this.paginatorStyleClass, className].filter(c => !!c).join(' ').trim();
    }
    static ɵfac = function Table_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Table)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(TableService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(i1.OverlayService), i0.ɵɵdirectiveInject(i1.PrimeNGConfig), i0.ɵɵdirectiveInject(i2.DomSanitizer));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Table,
      selectors: [["p-table"]],
      contentQueries: function Table_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function Table_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
          i0.ɵɵviewQuery(_c3, 5);
          i0.ɵɵviewQuery(_c4, 5);
          i0.ɵɵviewQuery(_c5, 5);
          i0.ɵɵviewQuery(_c6, 5);
          i0.ɵɵviewQuery(_c7, 5);
          i0.ɵɵviewQuery(_c8, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.containerViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resizeHelperViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reorderIndicatorUpViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reorderIndicatorDownViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.wrapperViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tableViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tableHeaderViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tableFooterViewChild = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scroller = _t.first);
        }
      },
      hostAttrs: [1, "p-element"],
      inputs: {
        frozenColumns: "frozenColumns",
        frozenValue: "frozenValue",
        style: "style",
        styleClass: "styleClass",
        tableStyle: "tableStyle",
        tableStyleClass: "tableStyleClass",
        paginator: [2, "paginator", "paginator", booleanAttribute],
        pageLinks: [2, "pageLinks", "pageLinks", numberAttribute],
        rowsPerPageOptions: "rowsPerPageOptions",
        alwaysShowPaginator: [2, "alwaysShowPaginator", "alwaysShowPaginator", booleanAttribute],
        paginatorPosition: "paginatorPosition",
        paginatorStyleClass: "paginatorStyleClass",
        paginatorDropdownAppendTo: "paginatorDropdownAppendTo",
        paginatorDropdownScrollHeight: "paginatorDropdownScrollHeight",
        currentPageReportTemplate: "currentPageReportTemplate",
        showCurrentPageReport: [2, "showCurrentPageReport", "showCurrentPageReport", booleanAttribute],
        showJumpToPageDropdown: [2, "showJumpToPageDropdown", "showJumpToPageDropdown", booleanAttribute],
        showJumpToPageInput: [2, "showJumpToPageInput", "showJumpToPageInput", booleanAttribute],
        showFirstLastIcon: [2, "showFirstLastIcon", "showFirstLastIcon", booleanAttribute],
        showPageLinks: [2, "showPageLinks", "showPageLinks", booleanAttribute],
        defaultSortOrder: [2, "defaultSortOrder", "defaultSortOrder", numberAttribute],
        sortMode: "sortMode",
        resetPageOnSort: [2, "resetPageOnSort", "resetPageOnSort", booleanAttribute],
        selectionMode: "selectionMode",
        selectionPageOnly: [2, "selectionPageOnly", "selectionPageOnly", booleanAttribute],
        contextMenuSelection: "contextMenuSelection",
        contextMenuSelectionMode: "contextMenuSelectionMode",
        dataKey: "dataKey",
        metaKeySelection: [2, "metaKeySelection", "metaKeySelection", booleanAttribute],
        rowSelectable: "rowSelectable",
        rowTrackBy: "rowTrackBy",
        lazy: [2, "lazy", "lazy", booleanAttribute],
        lazyLoadOnInit: [2, "lazyLoadOnInit", "lazyLoadOnInit", booleanAttribute],
        compareSelectionBy: "compareSelectionBy",
        csvSeparator: "csvSeparator",
        exportFilename: "exportFilename",
        filters: "filters",
        globalFilterFields: "globalFilterFields",
        filterDelay: [2, "filterDelay", "filterDelay", numberAttribute],
        filterLocale: "filterLocale",
        expandedRowKeys: "expandedRowKeys",
        editingRowKeys: "editingRowKeys",
        rowExpandMode: "rowExpandMode",
        scrollable: [2, "scrollable", "scrollable", booleanAttribute],
        scrollDirection: "scrollDirection",
        rowGroupMode: "rowGroupMode",
        scrollHeight: "scrollHeight",
        virtualScroll: [2, "virtualScroll", "virtualScroll", booleanAttribute],
        virtualScrollItemSize: [2, "virtualScrollItemSize", "virtualScrollItemSize", numberAttribute],
        virtualScrollOptions: "virtualScrollOptions",
        virtualScrollDelay: [2, "virtualScrollDelay", "virtualScrollDelay", numberAttribute],
        frozenWidth: "frozenWidth",
        responsive: "responsive",
        contextMenu: "contextMenu",
        resizableColumns: [2, "resizableColumns", "resizableColumns", booleanAttribute],
        columnResizeMode: "columnResizeMode",
        reorderableColumns: [2, "reorderableColumns", "reorderableColumns", booleanAttribute],
        loading: [2, "loading", "loading", booleanAttribute],
        loadingIcon: "loadingIcon",
        showLoader: [2, "showLoader", "showLoader", booleanAttribute],
        rowHover: [2, "rowHover", "rowHover", booleanAttribute],
        customSort: [2, "customSort", "customSort", booleanAttribute],
        showInitialSortBadge: [2, "showInitialSortBadge", "showInitialSortBadge", booleanAttribute],
        autoLayout: [2, "autoLayout", "autoLayout", booleanAttribute],
        exportFunction: "exportFunction",
        exportHeader: "exportHeader",
        stateKey: "stateKey",
        stateStorage: "stateStorage",
        editMode: "editMode",
        groupRowsBy: "groupRowsBy",
        groupRowsByOrder: [2, "groupRowsByOrder", "groupRowsByOrder", numberAttribute],
        responsiveLayout: "responsiveLayout",
        breakpoint: "breakpoint",
        paginatorLocale: "paginatorLocale",
        value: "value",
        columns: "columns",
        first: "first",
        rows: "rows",
        totalRecords: "totalRecords",
        sortField: "sortField",
        sortOrder: "sortOrder",
        multiSortMeta: "multiSortMeta",
        selection: "selection",
        selectAll: "selectAll",
        virtualRowHeight: "virtualRowHeight"
      },
      outputs: {
        contextMenuSelectionChange: "contextMenuSelectionChange",
        selectAllChange: "selectAllChange",
        selectionChange: "selectionChange",
        onRowSelect: "onRowSelect",
        onRowUnselect: "onRowUnselect",
        onPage: "onPage",
        onSort: "onSort",
        onFilter: "onFilter",
        onLazyLoad: "onLazyLoad",
        onRowExpand: "onRowExpand",
        onRowCollapse: "onRowCollapse",
        onContextMenuSelect: "onContextMenuSelect",
        onColResize: "onColResize",
        onColReorder: "onColReorder",
        onRowReorder: "onRowReorder",
        onEditInit: "onEditInit",
        onEditComplete: "onEditComplete",
        onEditCancel: "onEditCancel",
        onHeaderCheckboxToggle: "onHeaderCheckboxToggle",
        sortFunction: "sortFunction",
        firstChange: "firstChange",
        rowsChange: "rowsChange",
        onStateSave: "onStateSave",
        onStateRestore: "onStateRestore"
      },
      features: [i0.ɵɵProvidersFeature([TableService]), i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature],
      decls: 16,
      vars: 22,
      consts: [["container", ""], ["wrapper", ""], ["buildInTable", ""], ["scroller", ""], ["table", ""], ["thead", ""], ["tfoot", ""], ["resizeHelper", ""], ["reorderIndicatorUp", ""], ["reorderIndicatorDown", ""], [3, "ngStyle", "ngClass"], ["class", "p-datatable-loading-overlay p-component-overlay", 4, "ngIf"], ["class", "p-datatable-header", 4, "ngIf"], [3, "rows", "first", "totalRecords", "pageLinkSize", "alwaysShow", "rowsPerPageOptions", "templateLeft", "templateRight", "dropdownAppendTo", "dropdownScrollHeight", "currentPageReportTemplate", "showFirstLastIcon", "dropdownItemTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showJumpToPageInput", "showPageLinks", "styleClass", "locale", "onPageChange", 4, "ngIf"], [1, "p-datatable-wrapper", 3, "ngStyle"], [3, "items", "columns", "style", "scrollHeight", "itemSize", "step", "delay", "inline", "autoSize", "lazy", "loaderDisabled", "showSpacer", "showLoader", "options", "onLazyLoad", 4, "ngIf"], [4, "ngIf"], ["class", "p-datatable-footer", 4, "ngIf"], ["class", "p-column-resizer-helper", 3, "ngStyle", 4, "ngIf"], ["class", "p-datatable-reorder-indicator-up", 3, "ngStyle", 4, "ngIf"], ["class", "p-datatable-reorder-indicator-down", 3, "ngStyle", 4, "ngIf"], [1, "p-datatable-loading-overlay", "p-component-overlay"], [3, "class", 4, "ngIf"], [3, "spin", "styleClass", 4, "ngIf"], ["class", "p-datatable-loading-icon", 4, "ngIf"], [3, "spin", "styleClass"], [1, "p-datatable-loading-icon"], [4, "ngTemplateOutlet"], [1, "p-datatable-header"], [3, "onPageChange", "rows", "first", "totalRecords", "pageLinkSize", "alwaysShow", "rowsPerPageOptions", "templateLeft", "templateRight", "dropdownAppendTo", "dropdownScrollHeight", "currentPageReportTemplate", "showFirstLastIcon", "dropdownItemTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showJumpToPageInput", "showPageLinks", "styleClass", "locale"], ["pTemplate", "dropdownicon"], ["pTemplate", "firstpagelinkicon"], ["pTemplate", "previouspagelinkicon"], ["pTemplate", "lastpagelinkicon"], ["pTemplate", "nextpagelinkicon"], [3, "onLazyLoad", "items", "columns", "scrollHeight", "itemSize", "step", "delay", "inline", "autoSize", "lazy", "loaderDisabled", "showSpacer", "showLoader", "options"], ["pTemplate", "content"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "table", 3, "ngClass", "ngStyle"], ["role", "rowgroup", 1, "p-datatable-thead"], ["role", "rowgroup", "class", "p-datatable-tbody p-datatable-frozen-tbody", 3, "value", "frozenRows", "pTableBody", "pTableBodyTemplate", "frozen", 4, "ngIf"], ["role", "rowgroup", 1, "p-datatable-tbody", 3, "ngClass", "ngStyle", "value", "pTableBody", "pTableBodyTemplate", "scrollerOptions"], ["role", "rowgroup", "class", "p-datatable-scroller-spacer", 3, "ngStyle", 4, "ngIf"], ["role", "rowgroup", "class", "p-datatable-tfoot", 4, "ngIf"], ["role", "rowgroup", 1, "p-datatable-tbody", "p-datatable-frozen-tbody", 3, "value", "frozenRows", "pTableBody", "pTableBodyTemplate", "frozen"], ["role", "rowgroup", 1, "p-datatable-scroller-spacer", 3, "ngStyle"], ["role", "rowgroup", 1, "p-datatable-tfoot"], [1, "p-datatable-footer"], [1, "p-column-resizer-helper", 3, "ngStyle"], [1, "p-datatable-reorder-indicator-up", 3, "ngStyle"], [1, "p-datatable-reorder-indicator-down", 3, "ngStyle"]],
      template: function Table_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 10, 0);
          i0.ɵɵtemplate(2, Table_div_2_Template, 3, 2, "div", 11)(3, Table_div_3_Template, 2, 1, "div", 12)(4, Table_p_paginator_4_Template, 6, 24, "p-paginator", 13);
          i0.ɵɵelementStart(5, "div", 14, 1);
          i0.ɵɵtemplate(7, Table_p_scroller_7_Template, 3, 17, "p-scroller", 15)(8, Table_ng_container_8_Template, 2, 7, "ng-container", 16)(9, Table_ng_template_9_Template, 10, 26, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(11, Table_p_paginator_11_Template, 6, 24, "p-paginator", 13)(12, Table_div_12_Template, 2, 1, "div", 17)(13, Table_div_13_Template, 2, 2, "div", 18)(14, Table_span_14_Template, 4, 4, "span", 19)(15, Table_span_15_Template, 4, 4, "span", 20);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClass);
          i0.ɵɵproperty("ngStyle", ctx.style)("ngClass", i0.ɵɵpureFunction3(16, _c9, ctx.rowHover || ctx.selectionMode, ctx.scrollable, ctx.scrollable && ctx.scrollHeight === "flex"));
          i0.ɵɵattribute("id", ctx.id);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.loading && ctx.showLoader);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.captionTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.paginator && (ctx.paginatorPosition === "top" || ctx.paginatorPosition == "both"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(20, _c10, ctx.virtualScroll ? "" : ctx.scrollHeight));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.virtualScroll);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.virtualScroll);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.paginator && (ctx.paginatorPosition === "bottom" || ctx.paginatorPosition == "both"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.summaryTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.resizableColumns);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.reorderableColumns);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.reorderableColumns);
        }
      },
      dependencies: () => [i3.NgClass, i3.NgIf, i3.NgTemplateOutlet, i3.NgStyle, i4.Paginator, i1.PrimeTemplate, i5.Scroller, ArrowDownIcon, ArrowUpIcon, SpinnerIcon, TableBody],
      styles: ["@layer primeng{.p-datatable{position:relative}.p-datatable>.p-datatable-wrapper{overflow:auto}.p-datatable-table{border-spacing:0px;width:100%}.p-datatable .p-sortable-column{cursor:pointer;-webkit-user-select:none;user-select:none}.p-datatable .p-sortable-column .p-column-title,.p-datatable .p-sortable-column .p-sortable-column-icon,.p-datatable .p-sortable-column .p-sortable-column-badge{vertical-align:middle}.p-datatable .p-sortable-column .p-icon-wrapper{display:inline}.p-datatable .p-sortable-column .p-sortable-column-badge{display:inline-flex;align-items:center;justify-content:center}.p-datatable-hoverable-rows .p-selectable-row{cursor:pointer}.p-datatable-scrollable>.p-datatable-wrapper{position:relative}.p-datatable-scrollable-table>.p-datatable-thead{position:sticky;top:0;z-index:2}.p-datatable-scrollable-table>.p-datatable-frozen-tbody{position:sticky;z-index:1}.p-datatable-scrollable-table>.p-datatable-tfoot{position:sticky;bottom:0;z-index:1}.p-datatable-scrollable .p-frozen-column{position:sticky;background:inherit;z-index:1}.p-datatable-scrollable th.p-frozen-column{z-index:1}.p-datatable-flex-scrollable{display:flex;flex-direction:column;height:100%}.p-datatable-flex-scrollable>.p-datatable-wrapper{display:flex;flex-direction:column;flex:1;height:100%}.p-datatable-scrollable-table>.p-datatable-tbody>.p-rowgroup-header{position:sticky;z-index:2}.p-datatable-resizable-table>.p-datatable-thead>tr>th,.p-datatable-resizable-table>.p-datatable-tfoot>tr>td,.p-datatable-resizable-table>.p-datatable-tbody>tr>td{overflow:hidden;white-space:nowrap}.p-datatable-resizable-table>.p-datatable-thead>tr>th.p-resizable-column:not(.p-frozen-column){background-clip:padding-box;position:relative}.p-datatable-resizable-table-fit>.p-datatable-thead>tr>th.p-resizable-column:last-child .p-column-resizer{display:none}.p-datatable .p-column-resizer{display:block;position:absolute!important;top:0;right:0;margin:0;width:.5rem;height:100%;padding:0;cursor:col-resize;border:1px solid transparent}.p-datatable .p-column-resizer-helper{width:1px;position:absolute;z-index:10;display:none}.p-datatable .p-row-editor-init,.p-datatable .p-row-editor-save,.p-datatable .p-row-editor-cancel,.p-datatable .p-row-toggler{display:inline-flex;align-items:center;justify-content:center;overflow:hidden;position:relative}.p-datatable-reorder-indicator-up,.p-datatable-reorder-indicator-down{position:absolute}.p-datatable-reorderablerow-handle,[pReorderableColumn]{cursor:move}.p-datatable .p-datatable-loading-overlay{position:absolute;display:flex;align-items:center;justify-content:center;z-index:3}.p-column-filter-row{display:flex;align-items:center;width:100%}.p-column-filter-menu{display:inline-flex}.p-column-filter-row p-columnfilterformelement{flex:1 1 auto;width:1%}.p-column-filter-menu-button,.p-column-filter-clear-button{display:inline-flex;justify-content:center;align-items:center;cursor:pointer;text-decoration:none;overflow:hidden;position:relative}.p-column-filter-overlay{position:absolute;top:0;left:0}.p-column-filter-row-items{margin:0;padding:0;list-style:none}.p-column-filter-row-item{cursor:pointer}.p-column-filter-add-button,.p-column-filter-remove-button{justify-content:center}.p-column-filter-add-button .p-button-label,.p-column-filter-remove-button .p-button-label{flex-grow:0}.p-column-filter-buttonbar{display:flex;align-items:center;justify-content:space-between}.p-column-filter-buttonbar .p-button{width:auto}.p-datatable-tbody>tr>td>.p-column-title{display:none}.p-datatable-scroller-spacer{display:flex}.p-datatable .p-scroller .p-scroller-loading{transform:none!important;min-height:0;position:sticky;top:0;left:0}}\n"],
      encapsulation: 2
    });
  }
  return Table;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TableBody = /*#__PURE__*/(() => {
  class TableBody {
    dt;
    tableService;
    cd;
    el;
    columns;
    template;
    get value() {
      return this._value;
    }
    set value(val) {
      this._value = val;
      if (this.frozenRows) {
        this.updateFrozenRowStickyPosition();
      }
      if (this.dt.scrollable && this.dt.rowGroupMode === 'subheader') {
        this.updateFrozenRowGroupHeaderStickyPosition();
      }
    }
    frozen;
    frozenRows;
    scrollerOptions;
    subscription;
    _value;
    ngAfterViewInit() {
      if (this.frozenRows) {
        this.updateFrozenRowStickyPosition();
      }
      if (this.dt.scrollable && this.dt.rowGroupMode === 'subheader') {
        this.updateFrozenRowGroupHeaderStickyPosition();
      }
    }
    constructor(dt, tableService, cd, el) {
      this.dt = dt;
      this.tableService = tableService;
      this.cd = cd;
      this.el = el;
      this.subscription = this.dt.tableService.valueSource$.subscribe(() => {
        if (this.dt.virtualScroll) {
          this.cd.detectChanges();
        }
      });
    }
    shouldRenderRowGroupHeader(value, rowData, i) {
      let currentRowFieldData = ObjectUtils.resolveFieldData(rowData, this.dt.groupRowsBy);
      let prevRowData = value[i - (1 + this.dt._first)];
      if (prevRowData) {
        let previousRowFieldData = ObjectUtils.resolveFieldData(prevRowData, this.dt.groupRowsBy);
        return currentRowFieldData !== previousRowFieldData;
      } else {
        return true;
      }
    }
    shouldRenderRowGroupFooter(value, rowData, i) {
      let currentRowFieldData = ObjectUtils.resolveFieldData(rowData, this.dt.groupRowsBy);
      let nextRowData = value[i + (1 + this.dt._first)];
      if (nextRowData) {
        let nextRowFieldData = ObjectUtils.resolveFieldData(nextRowData, this.dt.groupRowsBy);
        return currentRowFieldData !== nextRowFieldData;
      } else {
        return true;
      }
    }
    shouldRenderRowspan(value, rowData, i) {
      let currentRowFieldData = ObjectUtils.resolveFieldData(rowData, this.dt.groupRowsBy);
      let prevRowData = value[i - 1];
      if (prevRowData) {
        let previousRowFieldData = ObjectUtils.resolveFieldData(prevRowData, this.dt.groupRowsBy);
        return currentRowFieldData !== previousRowFieldData;
      } else {
        return true;
      }
    }
    calculateRowGroupSize(value, rowData, index) {
      let currentRowFieldData = ObjectUtils.resolveFieldData(rowData, this.dt.groupRowsBy);
      let nextRowFieldData = currentRowFieldData;
      let groupRowSpan = 0;
      while (currentRowFieldData === nextRowFieldData) {
        groupRowSpan++;
        let nextRowData = value[++index];
        if (nextRowData) {
          nextRowFieldData = ObjectUtils.resolveFieldData(nextRowData, this.dt.groupRowsBy);
        } else {
          break;
        }
      }
      return groupRowSpan === 1 ? null : groupRowSpan;
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    updateFrozenRowStickyPosition() {
      this.el.nativeElement.style.top = DomHandler.getOuterHeight(this.el.nativeElement.previousElementSibling) + 'px';
    }
    updateFrozenRowGroupHeaderStickyPosition() {
      if (this.el.nativeElement.previousElementSibling) {
        let tableHeaderHeight = DomHandler.getOuterHeight(this.el.nativeElement.previousElementSibling);
        this.dt.rowGroupHeaderStyleObject.top = tableHeaderHeight + 'px';
      }
    }
    getScrollerOption(option, options) {
      if (this.dt.virtualScroll) {
        options = options || this.scrollerOptions;
        return options ? options[option] : null;
      }
      return null;
    }
    getRowIndex(rowIndex) {
      const index = this.dt.paginator ? this.dt.first + rowIndex : rowIndex;
      const getItemOptions = this.getScrollerOption('getItemOptions');
      return getItemOptions ? getItemOptions(index).index : index;
    }
    static ɵfac = function TableBody_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableBody)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(TableService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TableBody,
      selectors: [["", "pTableBody", ""]],
      hostAttrs: [1, "p-element"],
      inputs: {
        columns: [0, "pTableBody", "columns"],
        template: [0, "pTableBodyTemplate", "template"],
        value: "value",
        frozen: [2, "frozen", "frozen", booleanAttribute],
        frozenRows: [2, "frozenRows", "frozenRows", booleanAttribute],
        scrollerOptions: "scrollerOptions"
      },
      features: [i0.ɵɵInputTransformsFeature],
      attrs: _c17,
      decls: 5,
      vars: 5,
      consts: [[4, "ngIf"], ["ngFor", "", 3, "ngForOf", "ngForTrackBy"], ["role", "row", 4, "ngIf"], ["role", "row"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function TableBody_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, TableBody_ng_container_0_Template, 2, 2, "ng-container", 0)(1, TableBody_ng_container_1_Template, 2, 2, "ng-container", 0)(2, TableBody_ng_container_2_Template, 2, 2, "ng-container", 0)(3, TableBody_ng_container_3_Template, 2, 5, "ng-container", 0)(4, TableBody_ng_container_4_Template, 2, 5, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.dt.expandedRowTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dt.expandedRowTemplate && !(ctx.frozen && ctx.dt.frozenExpandedRowTemplate));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dt.frozenExpandedRowTemplate && ctx.frozen);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dt.loading);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dt.isEmpty() && !ctx.dt.loading);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet],
      encapsulation: 2
    });
  }
  return TableBody;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RowGroupHeader = /*#__PURE__*/(() => {
  class RowGroupHeader {
    dt;
    constructor(dt) {
      this.dt = dt;
    }
    get getFrozenRowGroupHeaderStickyPosition() {
      return this.dt.rowGroupHeaderStyleObject ? this.dt.rowGroupHeaderStyleObject.top : '';
    }
    static ɵfac = function RowGroupHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RowGroupHeader)(i0.ɵɵdirectiveInject(Table));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: RowGroupHeader,
      selectors: [["", "pRowGroupHeader", ""]],
      hostAttrs: [1, "p-rowgroup-header", "p-element"],
      hostVars: 2,
      hostBindings: function RowGroupHeader_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵstyleProp("top", ctx.getFrozenRowGroupHeaderStickyPosition);
        }
      }
    });
  }
  return RowGroupHeader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FrozenColumn = /*#__PURE__*/(() => {
  class FrozenColumn {
    el;
    zone;
    get frozen() {
      return this._frozen;
    }
    set frozen(val) {
      this._frozen = val;
      this.updateStickyPosition();
    }
    alignFrozen = 'left';
    constructor(el, zone) {
      this.el = el;
      this.zone = zone;
    }
    ngAfterViewChecked() {
      this.zone.runOutsideAngular(() => {
        this.recalculateColumns();
      });
    }
    recalculateColumns() {
      this.updateStickyPosition();
    }
    _frozen = true;
    updateStickyPosition() {
      if (this._frozen) {
        if (this.alignFrozen === 'right') {
          let right = 0;
          let next = this.el.nativeElement.nextElementSibling;
          if (next) {
            right = DomHandler.getOuterWidth(next) + (parseFloat(next.style.right) || 0);
          }
          this.el.nativeElement.style.right = right + 'px';
        } else {
          let left = 0;
          let prev = this.el.nativeElement.previousElementSibling;
          if (prev) {
            left = DomHandler.getOuterWidth(prev) + (parseFloat(prev.style.left) || 0);
          }
          this.el.nativeElement.style.left = left + 'px';
        }
        const filterRow = this.el.nativeElement?.parentElement?.nextElementSibling;
        if (filterRow) {
          let index = DomHandler.index(this.el.nativeElement);
          if (filterRow.children && filterRow.children[index]) {
            filterRow.children[index].style.left = this.el.nativeElement.style.left;
            filterRow.children[index].style.right = this.el.nativeElement.style.right;
          }
        }
      }
    }
    static ɵfac = function FrozenColumn_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FrozenColumn)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FrozenColumn,
      selectors: [["", "pFrozenColumn", ""]],
      hostAttrs: [1, "p-element"],
      hostVars: 2,
      hostBindings: function FrozenColumn_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("resize", function FrozenColumn_resize_HostBindingHandler($event) {
            return ctx.recalculateColumns($event);
          }, false, i0.ɵɵresolveWindow);
        }
        if (rf & 2) {
          i0.ɵɵclassProp("p-frozen-column", ctx.frozen);
        }
      },
      inputs: {
        frozen: "frozen",
        alignFrozen: "alignFrozen"
      }
    });
  }
  return FrozenColumn;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SortableColumn = /*#__PURE__*/(() => {
  class SortableColumn {
    dt;
    field;
    pSortableColumnDisabled;
    sorted;
    sortOrder;
    subscription;
    constructor(dt) {
      this.dt = dt;
      if (this.isEnabled()) {
        this.subscription = this.dt.tableService.sortSource$.subscribe(sortMeta => {
          this.updateSortState();
        });
      }
    }
    ngOnInit() {
      if (this.isEnabled()) {
        this.updateSortState();
      }
    }
    updateSortState() {
      this.sorted = this.dt.isSorted(this.field);
      this.sortOrder = this.sorted ? this.dt.sortOrder === 1 ? 'ascending' : 'descending' : 'none';
    }
    onClick(event) {
      if (this.isEnabled() && !this.isFilterElement(event.target)) {
        this.updateSortState();
        this.dt.sort({
          originalEvent: event,
          field: this.field
        });
        DomHandler.clearSelection();
      }
    }
    onEnterKey(event) {
      this.onClick(event);
      event.preventDefault();
    }
    isEnabled() {
      return this.pSortableColumnDisabled !== true;
    }
    isFilterElement(element) {
      return this.isFilterElementIconOrButton(element) || this.isFilterElementIconOrButton(element?.parentElement?.parentElement);
    }
    isFilterElementIconOrButton(element) {
      return DomHandler.hasClass(element, 'pi-filter-icon') || DomHandler.hasClass(element, 'p-column-filter-menu-button');
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    static ɵfac = function SortableColumn_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SortableColumn)(i0.ɵɵdirectiveInject(Table));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SortableColumn,
      selectors: [["", "pSortableColumn", ""]],
      hostAttrs: [1, "p-element"],
      hostVars: 7,
      hostBindings: function SortableColumn_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function SortableColumn_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          })("keydown.space", function SortableColumn_keydown_space_HostBindingHandler($event) {
            return ctx.onEnterKey($event);
          })("keydown.enter", function SortableColumn_keydown_enter_HostBindingHandler($event) {
            return ctx.onEnterKey($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("tabindex", ctx.isEnabled() ? "0" : null)("role", "columnheader")("aria-sort", ctx.sortOrder);
          i0.ɵɵclassProp("p-sortable-column", ctx.isEnabled())("p-highlight", ctx.sorted);
        }
      },
      inputs: {
        field: [0, "pSortableColumn", "field"],
        pSortableColumnDisabled: [2, "pSortableColumnDisabled", "pSortableColumnDisabled", booleanAttribute]
      },
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
  return SortableColumn;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SortIcon = /*#__PURE__*/(() => {
  class SortIcon {
    dt;
    cd;
    field;
    subscription;
    sortOrder;
    constructor(dt, cd) {
      this.dt = dt;
      this.cd = cd;
      this.subscription = this.dt.tableService.sortSource$.subscribe(sortMeta => {
        this.updateSortState();
      });
    }
    ngOnInit() {
      this.updateSortState();
    }
    onClick(event) {
      event.preventDefault();
    }
    updateSortState() {
      if (this.dt.sortMode === 'single') {
        this.sortOrder = this.dt.isSorted(this.field) ? this.dt.sortOrder : 0;
      } else if (this.dt.sortMode === 'multiple') {
        let sortMeta = this.dt.getSortMeta(this.field);
        this.sortOrder = sortMeta ? sortMeta.order : 0;
      }
      this.cd.markForCheck();
    }
    getMultiSortMetaIndex() {
      let multiSortMeta = this.dt._multiSortMeta;
      let index = -1;
      if (multiSortMeta && this.dt.sortMode === 'multiple' && this.dt.showInitialSortBadge && multiSortMeta.length > 1) {
        for (let i = 0; i < multiSortMeta.length; i++) {
          let meta = multiSortMeta[i];
          if (meta.field === this.field || meta.field === this.field) {
            index = i;
            break;
          }
        }
      }
      return index;
    }
    getBadgeValue() {
      let index = this.getMultiSortMetaIndex();
      return this.dt.groupRowsBy && index > -1 ? index : index + 1;
    }
    isMultiSorted() {
      return this.dt.sortMode === 'multiple' && this.getMultiSortMetaIndex() > -1;
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    static ɵfac = function SortIcon_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SortIcon)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SortIcon,
      selectors: [["p-sortIcon"]],
      hostAttrs: [1, "p-element"],
      inputs: {
        field: "field"
      },
      decls: 3,
      vars: 3,
      consts: [[4, "ngIf"], ["class", "p-sortable-column-icon", 4, "ngIf"], ["class", "p-sortable-column-badge", 4, "ngIf"], [3, "styleClass", 4, "ngIf"], [3, "styleClass"], [1, "p-sortable-column-icon"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "p-sortable-column-badge"]],
      template: function SortIcon_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SortIcon_ng_container_0_Template, 4, 3, "ng-container", 0)(1, SortIcon_span_1_Template, 2, 4, "span", 1)(2, SortIcon_span_2_Template, 2, 1, "span", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.dt.sortIconTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dt.sortIconTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isMultiSorted());
        }
      },
      dependencies: () => [i3.NgIf, i3.NgTemplateOutlet, SortAltIcon, SortAmountUpAltIcon, SortAmountDownIcon],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return SortIcon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectableRow = /*#__PURE__*/(() => {
  class SelectableRow {
    dt;
    tableService;
    el;
    data;
    index;
    pSelectableRowDisabled;
    selected;
    subscription;
    constructor(dt, tableService, el) {
      this.dt = dt;
      this.tableService = tableService;
      this.el = el;
      if (this.isEnabled()) {
        this.subscription = this.dt.tableService.selectionSource$.subscribe(() => {
          this.selected = this.dt.isSelected(this.data);
        });
      }
    }
    setRowTabIndex() {
      if (this.dt.selectionMode === 'single' || this.dt.selectionMode === 'multiple') {
        return !this.dt.selection ? 0 : this.dt.anchorRowIndex === this.index ? 0 : -1;
      }
    }
    ngOnInit() {
      if (this.isEnabled()) {
        this.selected = this.dt.isSelected(this.data);
      }
    }
    onClick(event) {
      if (this.isEnabled()) {
        this.dt.handleRowClick({
          originalEvent: event,
          rowData: this.data,
          rowIndex: this.index
        });
      }
    }
    onTouchEnd(event) {
      if (this.isEnabled()) {
        this.dt.handleRowTouchEnd(event);
      }
    }
    onKeyDown(event) {
      switch (event.code) {
        case 'ArrowDown':
          this.onArrowDownKey(event);
          break;
        case 'ArrowUp':
          this.onArrowUpKey(event);
          break;
        case 'Home':
          this.onHomeKey(event);
          break;
        case 'End':
          this.onEndKey(event);
          break;
        case 'Space':
          this.onSpaceKey(event);
          break;
        case 'Enter':
          this.onEnterKey(event);
          break;
        default:
          if (event.code === 'KeyA' && (event.metaKey || event.ctrlKey) && this.dt.selectionMode === 'multiple') {
            const data = this.dt.dataToRender(this.dt.processedData);
            this.dt.selection = [...data];
            this.dt.selectRange(event, data.length - 1, true);
            event.preventDefault();
          }
          break;
      }
    }
    onArrowDownKey(event) {
      if (!this.isEnabled()) {
        return;
      }
      const row = event.currentTarget;
      const nextRow = this.findNextSelectableRow(row);
      if (nextRow) {
        nextRow.focus();
      }
      event.preventDefault();
    }
    onArrowUpKey(event) {
      if (!this.isEnabled()) {
        return;
      }
      const row = event.currentTarget;
      const prevRow = this.findPrevSelectableRow(row);
      if (prevRow) {
        prevRow.focus();
      }
      event.preventDefault();
    }
    onEnterKey(event) {
      if (!this.isEnabled()) {
        return;
      }
      this.dt.handleRowClick({
        originalEvent: event,
        rowData: this.data,
        rowIndex: this.index
      });
    }
    onEndKey(event) {
      const lastRow = this.findLastSelectableRow();
      lastRow && this.focusRowChange(this.el.nativeElement, lastRow);
      if (event.ctrlKey && event.shiftKey) {
        const data = this.dt.dataToRender(this.dt.rows);
        const lastSelectableRowIndex = DomHandler.getAttribute(lastRow, 'index');
        this.dt.anchorRowIndex = lastSelectableRowIndex;
        this.dt.selection = data.slice(this.index, data.length);
        this.dt.selectRange(event, this.index);
      }
      event.preventDefault();
    }
    onHomeKey(event) {
      const firstRow = this.findFirstSelectableRow();
      firstRow && this.focusRowChange(this.el.nativeElement, firstRow);
      if (event.ctrlKey && event.shiftKey) {
        const data = this.dt.dataToRender(this.dt.rows);
        const firstSelectableRowIndex = DomHandler.getAttribute(firstRow, 'index');
        this.dt.anchorRowIndex = this.dt.anchorRowIndex || firstSelectableRowIndex;
        this.dt.selection = data.slice(0, this.index + 1);
        this.dt.selectRange(event, this.index);
      }
      event.preventDefault();
    }
    onSpaceKey(event) {
      const isInput = event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement || event.target instanceof HTMLTextAreaElement;
      if (isInput) {
        return;
      } else {
        this.onEnterKey(event);
        if (event.shiftKey && this.dt.selection !== null) {
          const data = this.dt.dataToRender(this.dt.rows);
          let index;
          if (ObjectUtils.isNotEmpty(this.dt.selection) && this.dt.selection.length > 0) {
            let firstSelectedRowIndex, lastSelectedRowIndex;
            firstSelectedRowIndex = ObjectUtils.findIndexInList(this.dt.selection[0], data);
            lastSelectedRowIndex = ObjectUtils.findIndexInList(this.dt.selection[this.dt.selection.length - 1], data);
            index = this.index <= firstSelectedRowIndex ? lastSelectedRowIndex : firstSelectedRowIndex;
          } else {
            index = ObjectUtils.findIndexInList(this.dt.selection, data);
          }
          this.dt.anchorRowIndex = index;
          this.dt.selection = index !== this.index ? data.slice(Math.min(index, this.index), Math.max(index, this.index) + 1) : [this.data];
          this.dt.selectRange(event, this.index);
        }
        event.preventDefault();
      }
    }
    focusRowChange(firstFocusableRow, currentFocusedRow) {
      firstFocusableRow.tabIndex = '-1';
      currentFocusedRow.tabIndex = '0';
      DomHandler.focus(currentFocusedRow);
    }
    findLastSelectableRow() {
      const rows = DomHandler.find(this.dt.el.nativeElement, '.p-selectable-row');
      return rows ? rows[rows.length - 1] : null;
    }
    findFirstSelectableRow() {
      const firstRow = DomHandler.findSingle(this.dt.el.nativeElement, '.p-selectable-row');
      return firstRow;
    }
    findNextSelectableRow(row) {
      let nextRow = row.nextElementSibling;
      if (nextRow) {
        if (DomHandler.hasClass(nextRow, 'p-selectable-row')) return nextRow;else return this.findNextSelectableRow(nextRow);
      } else {
        return null;
      }
    }
    findPrevSelectableRow(row) {
      let prevRow = row.previousElementSibling;
      if (prevRow) {
        if (DomHandler.hasClass(prevRow, 'p-selectable-row')) return prevRow;else return this.findPrevSelectableRow(prevRow);
      } else {
        return null;
      }
    }
    isEnabled() {
      return this.pSelectableRowDisabled !== true;
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    static ɵfac = function SelectableRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectableRow)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(TableService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SelectableRow,
      selectors: [["", "pSelectableRow", ""]],
      hostAttrs: [1, "p-element"],
      hostVars: 7,
      hostBindings: function SelectableRow_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function SelectableRow_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          })("touchend", function SelectableRow_touchend_HostBindingHandler($event) {
            return ctx.onTouchEnd($event);
          })("keydown", function SelectableRow_keydown_HostBindingHandler($event) {
            return ctx.onKeyDown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("tabindex", ctx.setRowTabIndex())("data-p-highlight", ctx.selected)("data-p-selectable-row", true);
          i0.ɵɵclassProp("p-selectable-row", ctx.isEnabled())("p-highlight", ctx.selected);
        }
      },
      inputs: {
        data: [0, "pSelectableRow", "data"],
        index: [0, "pSelectableRowIndex", "index"],
        pSelectableRowDisabled: [2, "pSelectableRowDisabled", "pSelectableRowDisabled", booleanAttribute]
      },
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
  return SelectableRow;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectableRowDblClick = /*#__PURE__*/(() => {
  class SelectableRowDblClick {
    dt;
    tableService;
    data;
    index;
    pSelectableRowDisabled;
    selected;
    subscription;
    constructor(dt, tableService) {
      this.dt = dt;
      this.tableService = tableService;
      if (this.isEnabled()) {
        this.subscription = this.dt.tableService.selectionSource$.subscribe(() => {
          this.selected = this.dt.isSelected(this.data);
        });
      }
    }
    ngOnInit() {
      if (this.isEnabled()) {
        this.selected = this.dt.isSelected(this.data);
      }
    }
    onClick(event) {
      if (this.isEnabled()) {
        this.dt.handleRowClick({
          originalEvent: event,
          rowData: this.data,
          rowIndex: this.index
        });
      }
    }
    isEnabled() {
      return this.pSelectableRowDisabled !== true;
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    static ɵfac = function SelectableRowDblClick_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectableRowDblClick)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(TableService));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SelectableRowDblClick,
      selectors: [["", "pSelectableRowDblClick", ""]],
      hostAttrs: [1, "p-element"],
      hostVars: 4,
      hostBindings: function SelectableRowDblClick_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("dblclick", function SelectableRowDblClick_dblclick_HostBindingHandler($event) {
            return ctx.onClick($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵclassProp("p-selectable-row", ctx.isEnabled())("p-highlight", ctx.selected);
        }
      },
      inputs: {
        data: [0, "pSelectableRowDblClick", "data"],
        index: [0, "pSelectableRowIndex", "index"],
        pSelectableRowDisabled: [2, "pSelectableRowDisabled", "pSelectableRowDisabled", booleanAttribute]
      },
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
  return SelectableRowDblClick;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContextMenuRow = /*#__PURE__*/(() => {
  class ContextMenuRow {
    dt;
    tableService;
    el;
    data;
    index;
    pContextMenuRowDisabled;
    selected;
    subscription;
    constructor(dt, tableService, el) {
      this.dt = dt;
      this.tableService = tableService;
      this.el = el;
      if (this.isEnabled()) {
        this.subscription = this.dt.tableService.contextMenuSource$.subscribe(data => {
          this.selected = this.dt.equals(this.data, data);
        });
      }
    }
    onContextMenu(event) {
      if (this.isEnabled()) {
        this.dt.handleRowRightClick({
          originalEvent: event,
          rowData: this.data,
          rowIndex: this.index
        });
        this.el.nativeElement.focus();
        event.preventDefault();
      }
    }
    isEnabled() {
      return this.pContextMenuRowDisabled !== true;
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    static ɵfac = function ContextMenuRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ContextMenuRow)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(TableService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ContextMenuRow,
      selectors: [["", "pContextMenuRow", ""]],
      hostAttrs: [1, "p-element"],
      hostVars: 3,
      hostBindings: function ContextMenuRow_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("contextmenu", function ContextMenuRow_contextmenu_HostBindingHandler($event) {
            return ctx.onContextMenu($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("tabindex", ctx.isEnabled() ? 0 : undefined);
          i0.ɵɵclassProp("p-highlight-contextmenu", ctx.selected);
        }
      },
      inputs: {
        data: [0, "pContextMenuRow", "data"],
        index: [0, "pContextMenuRowIndex", "index"],
        pContextMenuRowDisabled: [2, "pContextMenuRowDisabled", "pContextMenuRowDisabled", booleanAttribute]
      },
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
  return ContextMenuRow;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RowToggler = /*#__PURE__*/(() => {
  class RowToggler {
    dt;
    data;
    pRowTogglerDisabled;
    constructor(dt) {
      this.dt = dt;
    }
    onClick(event) {
      if (this.isEnabled()) {
        this.dt.toggleRow(this.data, event);
        event.preventDefault();
      }
    }
    isEnabled() {
      return this.pRowTogglerDisabled !== true;
    }
    static ɵfac = function RowToggler_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RowToggler)(i0.ɵɵdirectiveInject(Table));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: RowToggler,
      selectors: [["", "pRowToggler", ""]],
      hostAttrs: [1, "p-element"],
      hostBindings: function RowToggler_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function RowToggler_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          });
        }
      },
      inputs: {
        data: [0, "pRowToggler", "data"],
        pRowTogglerDisabled: [2, "pRowTogglerDisabled", "pRowTogglerDisabled", booleanAttribute]
      },
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
  return RowToggler;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ResizableColumn = /*#__PURE__*/(() => {
  class ResizableColumn {
    document;
    platformId;
    renderer;
    dt;
    el;
    zone;
    pResizableColumnDisabled;
    resizer;
    resizerMouseDownListener;
    resizerTouchStartListener;
    resizerTouchMoveListener;
    resizerTouchEndListener;
    documentMouseMoveListener;
    documentMouseUpListener;
    constructor(document, platformId, renderer, dt, el, zone) {
      this.document = document;
      this.platformId = platformId;
      this.renderer = renderer;
      this.dt = dt;
      this.el = el;
      this.zone = zone;
    }
    ngAfterViewInit() {
      if (isPlatformBrowser(this.platformId)) {
        if (this.isEnabled()) {
          DomHandler.addClass(this.el.nativeElement, 'p-resizable-column');
          this.resizer = this.renderer.createElement('span');
          this.renderer.addClass(this.resizer, 'p-column-resizer');
          this.renderer.appendChild(this.el.nativeElement, this.resizer);
          this.zone.runOutsideAngular(() => {
            this.resizerMouseDownListener = this.renderer.listen(this.resizer, 'mousedown', this.onMouseDown.bind(this));
            this.resizerTouchStartListener = this.renderer.listen(this.resizer, 'touchstart', this.onTouchStart.bind(this));
          });
        }
      }
    }
    bindDocumentEvents() {
      this.zone.runOutsideAngular(() => {
        this.documentMouseMoveListener = this.renderer.listen(this.document, 'mousemove', this.onDocumentMouseMove.bind(this));
        this.documentMouseUpListener = this.renderer.listen(this.document, 'mouseup', this.onDocumentMouseUp.bind(this));
        this.resizerTouchMoveListener = this.renderer.listen(this.resizer, 'touchmove', this.onTouchMove.bind(this));
        this.resizerTouchEndListener = this.renderer.listen(this.resizer, 'touchend', this.onTouchEnd.bind(this));
      });
    }
    unbindDocumentEvents() {
      if (this.documentMouseMoveListener) {
        this.documentMouseMoveListener();
        this.documentMouseMoveListener = null;
      }
      if (this.documentMouseUpListener) {
        this.documentMouseUpListener();
        this.documentMouseUpListener = null;
      }
      if (this.resizerTouchMoveListener) {
        this.resizerTouchMoveListener();
        this.resizerTouchMoveListener = null;
      }
      if (this.resizerTouchEndListener) {
        this.resizerTouchEndListener();
        this.resizerTouchEndListener = null;
      }
    }
    onMouseDown(event) {
      this.dt.onColumnResizeBegin(event);
      this.bindDocumentEvents();
    }
    onTouchStart(event) {
      this.dt.onColumnResizeBegin(event);
      this.bindDocumentEvents();
    }
    onTouchMove(event) {
      this.dt.onColumnResize(event);
    }
    onDocumentMouseMove(event) {
      this.dt.onColumnResize(event);
    }
    onDocumentMouseUp(event) {
      this.dt.onColumnResizeEnd();
      this.unbindDocumentEvents();
    }
    onTouchEnd(event) {
      this.dt.onColumnResizeEnd();
      this.unbindDocumentEvents();
    }
    isEnabled() {
      return this.pResizableColumnDisabled !== true;
    }
    ngOnDestroy() {
      if (this.resizerMouseDownListener) {
        this.resizerMouseDownListener();
        this.resizerMouseDownListener = null;
      }
      this.unbindDocumentEvents();
    }
    static ɵfac = function ResizableColumn_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ResizableColumn)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ResizableColumn,
      selectors: [["", "pResizableColumn", ""]],
      hostAttrs: [1, "p-element"],
      inputs: {
        pResizableColumnDisabled: [2, "pResizableColumnDisabled", "pResizableColumnDisabled", booleanAttribute]
      },
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
  return ResizableColumn;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReorderableColumn = /*#__PURE__*/(() => {
  class ReorderableColumn {
    platformId;
    renderer;
    dt;
    el;
    zone;
    pReorderableColumnDisabled;
    dragStartListener;
    dragOverListener;
    dragEnterListener;
    dragLeaveListener;
    mouseDownListener;
    constructor(platformId, renderer, dt, el, zone) {
      this.platformId = platformId;
      this.renderer = renderer;
      this.dt = dt;
      this.el = el;
      this.zone = zone;
    }
    ngAfterViewInit() {
      if (this.isEnabled()) {
        this.bindEvents();
      }
    }
    bindEvents() {
      if (isPlatformBrowser(this.platformId)) {
        this.zone.runOutsideAngular(() => {
          this.mouseDownListener = this.renderer.listen(this.el.nativeElement, 'mousedown', this.onMouseDown.bind(this));
          this.dragStartListener = this.renderer.listen(this.el.nativeElement, 'dragstart', this.onDragStart.bind(this));
          this.dragOverListener = this.renderer.listen(this.el.nativeElement, 'dragover', this.onDragOver.bind(this));
          this.dragEnterListener = this.renderer.listen(this.el.nativeElement, 'dragenter', this.onDragEnter.bind(this));
          this.dragLeaveListener = this.renderer.listen(this.el.nativeElement, 'dragleave', this.onDragLeave.bind(this));
        });
      }
    }
    unbindEvents() {
      if (this.mouseDownListener) {
        this.mouseDownListener();
        this.mouseDownListener = null;
      }
      if (this.dragStartListener) {
        this.dragStartListener();
        this.dragStartListener = null;
      }
      if (this.dragOverListener) {
        this.dragOverListener();
        this.dragOverListener = null;
      }
      if (this.dragEnterListener) {
        this.dragEnterListener();
        this.dragEnterListener = null;
      }
      if (this.dragLeaveListener) {
        this.dragLeaveListener();
        this.dragLeaveListener = null;
      }
    }
    onMouseDown(event) {
      if (event.target.nodeName === 'INPUT' || event.target.nodeName === 'TEXTAREA' || DomHandler.hasClass(event.target, 'p-column-resizer')) this.el.nativeElement.draggable = false;else this.el.nativeElement.draggable = true;
    }
    onDragStart(event) {
      this.dt.onColumnDragStart(event, this.el.nativeElement);
    }
    onDragOver(event) {
      event.preventDefault();
    }
    onDragEnter(event) {
      this.dt.onColumnDragEnter(event, this.el.nativeElement);
    }
    onDragLeave(event) {
      this.dt.onColumnDragLeave(event);
    }
    onDrop(event) {
      if (this.isEnabled()) {
        this.dt.onColumnDrop(event, this.el.nativeElement);
      }
    }
    isEnabled() {
      return this.pReorderableColumnDisabled !== true;
    }
    ngOnDestroy() {
      this.unbindEvents();
    }
    static ɵfac = function ReorderableColumn_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReorderableColumn)(i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ReorderableColumn,
      selectors: [["", "pReorderableColumn", ""]],
      hostAttrs: [1, "p-element"],
      hostVars: 2,
      hostBindings: function ReorderableColumn_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("drop", function ReorderableColumn_drop_HostBindingHandler($event) {
            return ctx.onDrop($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵstyleProp("cursor", ctx.isEnabled() ? "move" : "default");
        }
      },
      inputs: {
        pReorderableColumnDisabled: [2, "pReorderableColumnDisabled", "pReorderableColumnDisabled", booleanAttribute]
      },
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
  return ReorderableColumn;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EditableColumn = /*#__PURE__*/(() => {
  class EditableColumn {
    dt;
    el;
    zone;
    data;
    field;
    rowIndex;
    pEditableColumnDisabled;
    pFocusCellSelector;
    overlayEventListener;
    constructor(dt, el, zone) {
      this.dt = dt;
      this.el = el;
      this.zone = zone;
    }
    ngOnChanges(changes) {
      if (changes.pEditableColumnDisabled?.currentValue === true && DomHandler.hasClass(this.el.nativeElement, 'p-cell-editing')) {
        this.closeEditingCell(false, new Event('cancel'));
      } else if (changes.data?.firstChange === false && this.el.nativeElement) {
        this.dt.updateEditingCell(this.el.nativeElement, this.data, this.field, this.rowIndex);
      }
    }
    ngAfterViewInit() {
      if (this.isEnabled()) {
        DomHandler.addClass(this.el.nativeElement, 'p-editable-column');
      }
    }
    onClick(event) {
      if (this.isEnabled()) {
        this.dt.selfClick = true;
        if (this.dt.editingCell) {
          if (this.dt.editingCell !== this.el.nativeElement) {
            if (!this.dt.isEditingCellValid()) {
              return;
            }
            this.closeEditingCell(true, event);
            this.openCell();
          }
        } else {
          this.openCell();
        }
      }
    }
    openCell() {
      this.dt.updateEditingCell(this.el.nativeElement, this.data, this.field, this.rowIndex);
      DomHandler.addClass(this.el.nativeElement, 'p-cell-editing');
      this.dt.onEditInit.emit({
        field: this.field,
        data: this.data,
        index: this.rowIndex
      });
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          let focusCellSelector = this.pFocusCellSelector || 'input, textarea, select';
          let focusableElement = DomHandler.findSingle(this.el.nativeElement, focusCellSelector);
          if (focusableElement) {
            focusableElement.focus();
          }
        }, 50);
      });
      this.overlayEventListener = e => {
        if (this.el && this.el.nativeElement.contains(e.target)) {
          this.dt.selfClick = true;
        }
      };
      this.dt.overlaySubscription = this.dt.overlayService.clickObservable.subscribe(this.overlayEventListener);
    }
    closeEditingCell(completed, event) {
      const eventData = {
        field: this.dt.editingCellField,
        data: this.dt.editingCellData,
        originalEvent: event,
        index: this.dt.editingCellRowIndex
      };
      if (completed) {
        this.dt.onEditComplete.emit(eventData);
      } else {
        this.dt.onEditCancel.emit(eventData);
        this.dt.value.forEach(element => {
          if (element[this.dt.editingCellField] === this.data) {
            element[this.dt.editingCellField] = this.dt.editingCellData;
          }
        });
      }
      DomHandler.removeClass(this.dt.editingCell, 'p-cell-editing');
      this.dt.editingCell = null;
      this.dt.editingCellData = null;
      this.dt.editingCellField = null;
      this.dt.unbindDocumentEditListener();
      if (this.dt.overlaySubscription) {
        this.dt.overlaySubscription.unsubscribe();
      }
    }
    onEnterKeyDown(event) {
      if (this.isEnabled() && !event.shiftKey) {
        if (this.dt.isEditingCellValid()) {
          this.closeEditingCell(true, event);
        }
        event.preventDefault();
      }
    }
    onTabKeyDown(event) {
      if (this.isEnabled()) {
        if (this.dt.isEditingCellValid()) {
          this.closeEditingCell(true, event);
        }
        event.preventDefault();
      }
    }
    onEscapeKeyDown(event) {
      if (this.isEnabled()) {
        if (this.dt.isEditingCellValid()) {
          this.closeEditingCell(false, event);
        }
        event.preventDefault();
      }
    }
    onShiftKeyDown(event) {
      if (this.isEnabled()) {
        if (event.shiftKey) this.moveToPreviousCell(event);else {
          this.moveToNextCell(event);
        }
      }
    }
    onArrowDown(event) {
      if (this.isEnabled()) {
        let currentCell = this.findCell(event.target);
        if (currentCell) {
          let cellIndex = DomHandler.index(currentCell);
          let targetCell = this.findNextEditableColumnByIndex(currentCell, cellIndex);
          if (targetCell) {
            if (this.dt.isEditingCellValid()) {
              this.closeEditingCell(true, event);
            }
            DomHandler.invokeElementMethod(event.target, 'blur');
            DomHandler.invokeElementMethod(targetCell, 'click');
          }
          event.preventDefault();
        }
      }
    }
    onArrowUp(event) {
      if (this.isEnabled()) {
        let currentCell = this.findCell(event.target);
        if (currentCell) {
          let cellIndex = DomHandler.index(currentCell);
          let targetCell = this.findPrevEditableColumnByIndex(currentCell, cellIndex);
          if (targetCell) {
            if (this.dt.isEditingCellValid()) {
              this.closeEditingCell(true, event);
            }
            DomHandler.invokeElementMethod(event.target, 'blur');
            DomHandler.invokeElementMethod(targetCell, 'click');
          }
          event.preventDefault();
        }
      }
    }
    onArrowLeft(event) {
      if (this.isEnabled()) {
        this.moveToPreviousCell(event);
      }
    }
    onArrowRight(event) {
      if (this.isEnabled()) {
        this.moveToNextCell(event);
      }
    }
    findCell(element) {
      if (element) {
        let cell = element;
        while (cell && !DomHandler.hasClass(cell, 'p-cell-editing')) {
          cell = cell.parentElement;
        }
        return cell;
      } else {
        return null;
      }
    }
    moveToPreviousCell(event) {
      let currentCell = this.findCell(event.target);
      if (currentCell) {
        let targetCell = this.findPreviousEditableColumn(currentCell);
        if (targetCell) {
          if (this.dt.isEditingCellValid()) {
            this.closeEditingCell(true, event);
          }
          DomHandler.invokeElementMethod(event.target, 'blur');
          DomHandler.invokeElementMethod(targetCell, 'click');
          event.preventDefault();
        }
      }
    }
    moveToNextCell(event) {
      let currentCell = this.findCell(event.target);
      if (currentCell) {
        let targetCell = this.findNextEditableColumn(currentCell);
        if (targetCell) {
          if (this.dt.isEditingCellValid()) {
            this.closeEditingCell(true, event);
          }
          DomHandler.invokeElementMethod(event.target, 'blur');
          DomHandler.invokeElementMethod(targetCell, 'click');
          event.preventDefault();
        } else {
          if (this.dt.isEditingCellValid()) {
            this.closeEditingCell(true, event);
          }
        }
      }
    }
    findPreviousEditableColumn(cell) {
      let prevCell = cell.previousElementSibling;
      if (!prevCell) {
        let previousRow = cell.parentElement?.previousElementSibling;
        if (previousRow) {
          prevCell = previousRow.lastElementChild;
        }
      }
      if (prevCell) {
        if (DomHandler.hasClass(prevCell, 'p-editable-column')) return prevCell;else return this.findPreviousEditableColumn(prevCell);
      } else {
        return null;
      }
    }
    findNextEditableColumn(cell) {
      let nextCell = cell.nextElementSibling;
      if (!nextCell) {
        let nextRow = cell.parentElement?.nextElementSibling;
        if (nextRow) {
          nextCell = nextRow.firstElementChild;
        }
      }
      if (nextCell) {
        if (DomHandler.hasClass(nextCell, 'p-editable-column')) return nextCell;else return this.findNextEditableColumn(nextCell);
      } else {
        return null;
      }
    }
    findNextEditableColumnByIndex(cell, index) {
      let nextRow = cell.parentElement?.nextElementSibling;
      if (nextRow) {
        let nextCell = nextRow.children[index];
        if (nextCell && DomHandler.hasClass(nextCell, 'p-editable-column')) {
          return nextCell;
        }
        return null;
      } else {
        return null;
      }
    }
    findPrevEditableColumnByIndex(cell, index) {
      let prevRow = cell.parentElement?.previousElementSibling;
      if (prevRow) {
        let prevCell = prevRow.children[index];
        if (prevCell && DomHandler.hasClass(prevCell, 'p-editable-column')) {
          return prevCell;
        }
        return null;
      } else {
        return null;
      }
    }
    isEnabled() {
      return this.pEditableColumnDisabled !== true;
    }
    ngOnDestroy() {
      if (this.dt.overlaySubscription) {
        this.dt.overlaySubscription.unsubscribe();
      }
    }
    static ɵfac = function EditableColumn_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EditableColumn)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: EditableColumn,
      selectors: [["", "pEditableColumn", ""]],
      hostAttrs: [1, "p-element"],
      hostBindings: function EditableColumn_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function EditableColumn_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          })("keydown.enter", function EditableColumn_keydown_enter_HostBindingHandler($event) {
            return ctx.onEnterKeyDown($event);
          })("keydown.tab", function EditableColumn_keydown_tab_HostBindingHandler($event) {
            return ctx.onShiftKeyDown($event);
          })("keydown.escape", function EditableColumn_keydown_escape_HostBindingHandler($event) {
            return ctx.onEscapeKeyDown($event);
          })("keydown.shift.tab", function EditableColumn_keydown_shift_tab_HostBindingHandler($event) {
            return ctx.onShiftKeyDown($event);
          })("keydown.meta.tab", function EditableColumn_keydown_meta_tab_HostBindingHandler($event) {
            return ctx.onShiftKeyDown($event);
          })("keydown.arrowdown", function EditableColumn_keydown_arrowdown_HostBindingHandler($event) {
            return ctx.onArrowDown($event);
          })("keydown.arrowup", function EditableColumn_keydown_arrowup_HostBindingHandler($event) {
            return ctx.onArrowUp($event);
          })("keydown.arrowleft", function EditableColumn_keydown_arrowleft_HostBindingHandler($event) {
            return ctx.onArrowLeft($event);
          })("keydown.arrowright", function EditableColumn_keydown_arrowright_HostBindingHandler($event) {
            return ctx.onArrowRight($event);
          });
        }
      },
      inputs: {
        data: [0, "pEditableColumn", "data"],
        field: [0, "pEditableColumnField", "field"],
        rowIndex: [0, "pEditableColumnRowIndex", "rowIndex"],
        pEditableColumnDisabled: [2, "pEditableColumnDisabled", "pEditableColumnDisabled", booleanAttribute],
        pFocusCellSelector: "pFocusCellSelector"
      },
      features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature]
    });
  }
  return EditableColumn;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EditableRow = /*#__PURE__*/(() => {
  class EditableRow {
    el;
    data;
    pEditableRowDisabled;
    constructor(el) {
      this.el = el;
    }
    isEnabled() {
      return this.pEditableRowDisabled !== true;
    }
    static ɵfac = function EditableRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EditableRow)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: EditableRow,
      selectors: [["", "pEditableRow", ""]],
      hostAttrs: [1, "p-element"],
      inputs: {
        data: [0, "pEditableRow", "data"],
        pEditableRowDisabled: [2, "pEditableRowDisabled", "pEditableRowDisabled", booleanAttribute]
      },
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
  return EditableRow;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InitEditableRow = /*#__PURE__*/(() => {
  class InitEditableRow {
    dt;
    editableRow;
    constructor(dt, editableRow) {
      this.dt = dt;
      this.editableRow = editableRow;
    }
    onClick(event) {
      this.dt.initRowEdit(this.editableRow.data);
      event.preventDefault();
    }
    static ɵfac = function InitEditableRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InitEditableRow)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(EditableRow));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: InitEditableRow,
      selectors: [["", "pInitEditableRow", ""]],
      hostAttrs: [1, "p-element"],
      hostBindings: function InitEditableRow_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function InitEditableRow_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          });
        }
      }
    });
  }
  return InitEditableRow;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SaveEditableRow = /*#__PURE__*/(() => {
  class SaveEditableRow {
    dt;
    editableRow;
    constructor(dt, editableRow) {
      this.dt = dt;
      this.editableRow = editableRow;
    }
    onClick(event) {
      this.dt.saveRowEdit(this.editableRow.data, this.editableRow.el.nativeElement);
      event.preventDefault();
    }
    static ɵfac = function SaveEditableRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SaveEditableRow)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(EditableRow));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SaveEditableRow,
      selectors: [["", "pSaveEditableRow", ""]],
      hostAttrs: [1, "p-element"],
      hostBindings: function SaveEditableRow_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function SaveEditableRow_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          });
        }
      }
    });
  }
  return SaveEditableRow;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CancelEditableRow = /*#__PURE__*/(() => {
  class CancelEditableRow {
    dt;
    editableRow;
    constructor(dt, editableRow) {
      this.dt = dt;
      this.editableRow = editableRow;
    }
    onClick(event) {
      this.dt.cancelRowEdit(this.editableRow.data);
      event.preventDefault();
    }
    static ɵfac = function CancelEditableRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CancelEditableRow)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(EditableRow));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: CancelEditableRow,
      selectors: [["", "pCancelEditableRow", ""]],
      hostAttrs: [1, "p-element"],
      hostBindings: function CancelEditableRow_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function CancelEditableRow_click_HostBindingHandler($event) {
            return ctx.onClick($event);
          });
        }
      }
    });
  }
  return CancelEditableRow;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CellEditor = /*#__PURE__*/(() => {
  class CellEditor {
    dt;
    editableColumn;
    editableRow;
    templates;
    inputTemplate;
    outputTemplate;
    constructor(dt, editableColumn, editableRow) {
      this.dt = dt;
      this.editableColumn = editableColumn;
      this.editableRow = editableRow;
    }
    ngAfterContentInit() {
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'input':
            this.inputTemplate = item.template;
            break;
          case 'output':
            this.outputTemplate = item.template;
            break;
        }
      });
    }
    get editing() {
      return this.dt.editingCell && this.editableColumn && this.dt.editingCell === this.editableColumn.el.nativeElement || this.editableRow && this.dt.editMode === 'row' && this.dt.isRowEditing(this.editableRow.data);
    }
    static ɵfac = function CellEditor_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CellEditor)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(EditableColumn, 8), i0.ɵɵdirectiveInject(EditableRow, 8));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CellEditor,
      selectors: [["p-cellEditor"]],
      contentQueries: function CellEditor_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      hostAttrs: [1, "p-element"],
      decls: 2,
      vars: 2,
      consts: [[4, "ngIf"], [4, "ngTemplateOutlet"]],
      template: function CellEditor_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CellEditor_ng_container_0_Template, 2, 1, "ng-container", 0)(1, CellEditor_ng_container_1_Template, 2, 1, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.editing);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.editing);
        }
      },
      dependencies: [i3.NgIf, i3.NgTemplateOutlet],
      encapsulation: 2
    });
  }
  return CellEditor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TableRadioButton = /*#__PURE__*/(() => {
  class TableRadioButton {
    dt;
    cd;
    disabled;
    value;
    index;
    inputId;
    name;
    ariaLabel;
    inputViewChild;
    checked;
    focused;
    subscription;
    constructor(dt, cd) {
      this.dt = dt;
      this.cd = cd;
      this.subscription = this.dt.tableService.selectionSource$.subscribe(() => {
        this.checked = this.dt.isSelected(this.value);
        this.ariaLabel = this.ariaLabel || this.dt.config.translation.aria ? this.checked ? this.dt.config.translation.aria.selectRow : this.dt.config.translation.aria.unselectRow : undefined;
        this.cd.markForCheck();
      });
    }
    ngOnInit() {
      this.checked = this.dt.isSelected(this.value);
    }
    onClick(event) {
      if (!this.disabled) {
        this.dt.toggleRowWithRadio({
          originalEvent: event,
          rowIndex: this.index
        }, this.value);
        this.inputViewChild?.nativeElement?.focus();
      }
      DomHandler.clearSelection();
    }
    onFocus() {
      this.focused = true;
    }
    onBlur() {
      this.focused = false;
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    static ɵfac = function TableRadioButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableRadioButton)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TableRadioButton,
      selectors: [["p-tableRadioButton"]],
      viewQuery: function TableRadioButton_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c23, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputViewChild = _t.first);
        }
      },
      hostAttrs: [1, "p-element"],
      inputs: {
        disabled: [2, "disabled", "disabled", booleanAttribute],
        value: "value",
        index: [2, "index", "index", numberAttribute],
        inputId: "inputId",
        name: "name",
        ariaLabel: "ariaLabel"
      },
      features: [i0.ɵɵInputTransformsFeature],
      decls: 7,
      vars: 16,
      consts: [["rb", ""], ["box", ""], [1, "p-radiobutton", "p-component", 3, "click", "ngClass"], [1, "p-hidden-accessible"], ["type", "radio", 3, "focus", "blur", "checked", "disabled", "tabindex"], [3, "ngClass"], [1, "p-radiobutton-icon"]],
      template: function TableRadioButton_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 2);
          i0.ɵɵlistener("click", function TableRadioButton_Template_div_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick($event));
          });
          i0.ɵɵelementStart(1, "div", 3)(2, "input", 4, 0);
          i0.ɵɵlistener("focus", function TableRadioButton_Template_input_focus_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onFocus());
          })("blur", function TableRadioButton_Template_input_blur_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onBlur());
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "div", 5, 1);
          i0.ɵɵelement(6, "div", 6);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(8, _c24, ctx.focused, ctx.checked, ctx.disabled));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("checked", ctx.checked)("disabled", ctx.disabled)("tabindex", ctx.disabled ? null : "0");
          i0.ɵɵattribute("id", ctx.inputId)("name", ctx.name)("aria-label", ctx.ariaLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(12, _c25, ctx.checked, ctx.focused, ctx.disabled));
        }
      },
      dependencies: [i3.NgClass],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return TableRadioButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TableCheckbox = /*#__PURE__*/(() => {
  class TableCheckbox {
    dt;
    tableService;
    cd;
    disabled;
    value;
    index;
    inputId;
    name;
    required;
    ariaLabel;
    checked;
    focused;
    subscription;
    tableHeaderCheckboxSubscription;
    isTableHeaderCheckboxSelection = false;
    constructor(dt, tableService, cd) {
      this.dt = dt;
      this.tableService = tableService;
      this.cd = cd;
      this.subscription = this.dt.tableService.selectionSource$.subscribe(() => {
        setTimeout(() => {
          this.checked = this.isTableHeaderCheckboxSelection ? this.dt.isSelected(this.value) && !this.disabled : this.dt.isSelected(this.value);
          this.cd.markForCheck();
        });
        this.ariaLabel = this.ariaLabel || this.dt.config.translation.aria ? this.checked ? this.dt.config.translation.aria.selectRow : this.dt.config.translation.aria.unselectRow : undefined;
      });
      this.tableHeaderCheckboxSubscription = this.dt.tableService.isHeaderCheckboxSelection$.subscribe(val => {
        this.isTableHeaderCheckboxSelection = val;
      });
    }
    ngOnInit() {
      this.checked = this.dt.isSelected(this.value);
    }
    onClick(event) {
      if (!this.disabled) {
        this.dt.toggleRowWithCheckbox({
          originalEvent: event,
          rowIndex: this.index
        }, this.value);
        this.tableService.onHeaderCheckboxSelection(false);
      }
      DomHandler.clearSelection();
    }
    onFocus() {
      this.focused = true;
    }
    onBlur() {
      this.focused = false;
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
      if (this.tableHeaderCheckboxSubscription) {
        this.tableHeaderCheckboxSubscription.unsubscribe();
      }
    }
    static ɵfac = function TableCheckbox_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableCheckbox)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(TableService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TableCheckbox,
      selectors: [["p-tableCheckbox"]],
      hostAttrs: [1, "p-element"],
      inputs: {
        disabled: [2, "disabled", "disabled", booleanAttribute],
        value: "value",
        index: [2, "index", "index", numberAttribute],
        inputId: "inputId",
        name: "name",
        required: [2, "required", "required", booleanAttribute],
        ariaLabel: "ariaLabel"
      },
      features: [i0.ɵɵInputTransformsFeature],
      decls: 7,
      vars: 18,
      consts: [["box", ""], [1, "p-checkbox", "p-component", 3, "click", "ngClass"], [1, "p-hidden-accessible"], ["type", "checkbox", 3, "focus", "blur", "checked", "disabled", "tabindex"], [3, "ngClass"], [4, "ngIf"], [3, "styleClass", 4, "ngIf"], [3, "styleClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function TableCheckbox_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵlistener("click", function TableCheckbox_Template_div_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick($event));
          });
          i0.ɵɵelementStart(1, "div", 2)(2, "input", 3);
          i0.ɵɵlistener("focus", function TableCheckbox_Template_input_focus_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onFocus());
          })("blur", function TableCheckbox_Template_input_blur_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onBlur());
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(3, "div", 4, 0);
          i0.ɵɵtemplate(5, TableCheckbox_ng_container_5_Template, 2, 1, "ng-container", 5)(6, TableCheckbox_span_6_Template, 2, 4, "span", 5);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c26, ctx.focused, ctx.disabled));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("checked", ctx.checked)("disabled", ctx.disabled)("tabindex", ctx.disabled ? null : "0");
          i0.ɵɵattribute("id", ctx.inputId)("name", ctx.name)("required", ctx.required)("aria-label", ctx.ariaLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(14, _c27, ctx.checked, ctx.focused, ctx.disabled));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.dt.checkboxIconTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dt.checkboxIconTemplate);
        }
      },
      dependencies: () => [i3.NgClass, i3.NgIf, i3.NgTemplateOutlet, CheckIcon],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return TableCheckbox;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TableHeaderCheckbox = /*#__PURE__*/(() => {
  class TableHeaderCheckbox {
    dt;
    tableService;
    cd;
    disabled;
    inputId;
    name;
    ariaLabel;
    checked;
    focused;
    selectionChangeSubscription;
    valueChangeSubscription;
    tableHeaderCheckboxSubscription;
    constructor(dt, tableService, cd) {
      this.dt = dt;
      this.tableService = tableService;
      this.cd = cd;
      this.valueChangeSubscription = this.dt.tableService.valueSource$.subscribe(() => {
        this.checked = this.updateCheckedState();
        this.ariaLabel = this.ariaLabel || this.dt.config.translation.aria ? this.checked ? this.dt.config.translation.aria.selectAll : this.dt.config.translation.aria.unselectAll : undefined;
      });
      this.selectionChangeSubscription = this.dt.tableService.selectionSource$.subscribe(() => {
        this.checked = this.updateCheckedState();
      });
    }
    ngOnInit() {
      this.checked = this.updateCheckedState();
    }
    onClick(event) {
      if (!this.disabled) {
        if (this.dt.value && this.dt.value.length > 0) {
          this.tableService.onHeaderCheckboxSelection(true);
          this.dt.toggleRowsWithCheckbox(event, !this.checked);
        }
      }
      DomHandler.clearSelection();
    }
    onFocus() {
      this.focused = true;
    }
    onBlur() {
      this.focused = false;
    }
    isDisabled() {
      return this.disabled || !this.dt.value || !this.dt.value.length;
    }
    ngOnDestroy() {
      if (this.selectionChangeSubscription) {
        this.selectionChangeSubscription.unsubscribe();
      }
      if (this.valueChangeSubscription) {
        this.valueChangeSubscription.unsubscribe();
      }
    }
    updateCheckedState() {
      this.cd.markForCheck();
      if (this.dt._selectAll !== null) {
        return this.dt._selectAll;
      } else {
        const data = this.dt.selectionPageOnly ? this.dt.dataToRender(this.dt.processedData) : this.dt.processedData;
        const val = this.dt.frozenValue ? [...this.dt.frozenValue, ...data] : data;
        const selectableVal = this.dt.rowSelectable ? val.filter((data, index) => this.dt.rowSelectable({
          data,
          index
        })) : val;
        return ObjectUtils.isNotEmpty(selectableVal) && ObjectUtils.isNotEmpty(this.dt.selection) && selectableVal.every(v => this.dt.selection.some(s => this.dt.equals(v, s)));
      }
    }
    static ɵfac = function TableHeaderCheckbox_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableHeaderCheckbox)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(TableService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TableHeaderCheckbox,
      selectors: [["p-tableHeaderCheckbox"]],
      hostAttrs: [1, "p-element"],
      inputs: {
        disabled: [2, "disabled", "disabled", booleanAttribute],
        inputId: "inputId",
        name: "name",
        ariaLabel: "ariaLabel"
      },
      features: [i0.ɵɵInputTransformsFeature],
      decls: 8,
      vars: 17,
      consts: [["cb", ""], ["box", ""], [1, "p-checkbox", "p-component", 3, "click", "ngClass"], [1, "p-hidden-accessible"], ["type", "checkbox", 3, "focus", "blur", "tabindex", "checked", "disabled"], [3, "ngClass"], [4, "ngIf"], ["class", "p-checkbox-icon", 4, "ngIf"], [3, "styleClass", 4, "ngIf"], [3, "styleClass"], [1, "p-checkbox-icon"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
      template: function TableHeaderCheckbox_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 2);
          i0.ɵɵlistener("click", function TableHeaderCheckbox_Template_div_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onClick($event));
          });
          i0.ɵɵelementStart(1, "div", 3)(2, "input", 4, 0);
          i0.ɵɵlistener("focus", function TableHeaderCheckbox_Template_input_focus_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onFocus());
          })("blur", function TableHeaderCheckbox_Template_input_blur_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onBlur());
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "div", 5, 1);
          i0.ɵɵtemplate(6, TableHeaderCheckbox_ng_container_6_Template, 2, 1, "ng-container", 6)(7, TableHeaderCheckbox_span_7_Template, 2, 4, "span", 7);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c26, ctx.focused, ctx.isDisabled()));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("tabindex", ctx.disabled ? null : "0")("checked", ctx.checked)("disabled", ctx.isDisabled());
          i0.ɵɵattribute("id", ctx.inputId)("name", ctx.name)("aria-label", ctx.ariaLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(13, _c28, ctx.checked, ctx.focused, ctx.isDisabled()));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.dt.headerCheckboxIconTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dt.headerCheckboxIconTemplate);
        }
      },
      dependencies: () => [i3.NgClass, i3.NgIf, i3.NgTemplateOutlet, CheckIcon],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return TableHeaderCheckbox;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReorderableRowHandle = /*#__PURE__*/(() => {
  class ReorderableRowHandle {
    el;
    constructor(el) {
      this.el = el;
    }
    ngAfterViewInit() {
      DomHandler.addClass(this.el.nativeElement, 'p-datatable-reorderablerow-handle');
    }
    static ɵfac = function ReorderableRowHandle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReorderableRowHandle)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ReorderableRowHandle,
      selectors: [["", "pReorderableRowHandle", ""]],
      hostAttrs: [1, "p-element"]
    });
  }
  return ReorderableRowHandle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReorderableRow = /*#__PURE__*/(() => {
  class ReorderableRow {
    renderer;
    dt;
    el;
    zone;
    index;
    pReorderableRowDisabled;
    mouseDownListener;
    dragStartListener;
    dragEndListener;
    dragOverListener;
    dragLeaveListener;
    dropListener;
    constructor(renderer, dt, el, zone) {
      this.renderer = renderer;
      this.dt = dt;
      this.el = el;
      this.zone = zone;
    }
    ngAfterViewInit() {
      if (this.isEnabled()) {
        this.el.nativeElement.droppable = true;
        this.bindEvents();
      }
    }
    bindEvents() {
      this.zone.runOutsideAngular(() => {
        this.mouseDownListener = this.renderer.listen(this.el.nativeElement, 'mousedown', this.onMouseDown.bind(this));
        this.dragStartListener = this.renderer.listen(this.el.nativeElement, 'dragstart', this.onDragStart.bind(this));
        this.dragEndListener = this.renderer.listen(this.el.nativeElement, 'dragend', this.onDragEnd.bind(this));
        this.dragOverListener = this.renderer.listen(this.el.nativeElement, 'dragover', this.onDragOver.bind(this));
        this.dragLeaveListener = this.renderer.listen(this.el.nativeElement, 'dragleave', this.onDragLeave.bind(this));
      });
    }
    unbindEvents() {
      if (this.mouseDownListener) {
        this.mouseDownListener();
        this.mouseDownListener = null;
      }
      if (this.dragStartListener) {
        this.dragStartListener();
        this.dragStartListener = null;
      }
      if (this.dragEndListener) {
        this.dragEndListener();
        this.dragEndListener = null;
      }
      if (this.dragOverListener) {
        this.dragOverListener();
        this.dragOverListener = null;
      }
      if (this.dragLeaveListener) {
        this.dragLeaveListener();
        this.dragLeaveListener = null;
      }
    }
    onMouseDown(event) {
      const targetElement = event.target;
      const isHandleClicked = this.isHandleElement(targetElement);
      this.el.nativeElement.draggable = isHandleClicked;
    }
    isHandleElement(element) {
      if (element?.classList.contains('p-datatable-reorderablerow-handle')) {
        return true;
      }
      if (element?.parentElement && !['TD', 'TR'].includes(element?.parentElement?.tagName)) {
        return this.isHandleElement(element?.parentElement);
      }
      return false;
    }
    onDragStart(event) {
      this.dt.onRowDragStart(event, this.index);
    }
    onDragEnd(event) {
      this.dt.onRowDragEnd(event);
      this.el.nativeElement.draggable = false;
    }
    onDragOver(event) {
      this.dt.onRowDragOver(event, this.index, this.el.nativeElement);
      event.preventDefault();
    }
    onDragLeave(event) {
      this.dt.onRowDragLeave(event, this.el.nativeElement);
    }
    isEnabled() {
      return this.pReorderableRowDisabled !== true;
    }
    onDrop(event) {
      if (this.isEnabled() && this.dt.rowDragging) {
        this.dt.onRowDrop(event, this.el.nativeElement);
      }
      event.preventDefault();
    }
    ngOnDestroy() {
      this.unbindEvents();
    }
    static ɵfac = function ReorderableRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReorderableRow)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ReorderableRow,
      selectors: [["", "pReorderableRow", ""]],
      hostAttrs: [1, "p-element"],
      hostBindings: function ReorderableRow_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("drop", function ReorderableRow_drop_HostBindingHandler($event) {
            return ctx.onDrop($event);
          });
        }
      },
      inputs: {
        index: [0, "pReorderableRow", "index"],
        pReorderableRowDisabled: [2, "pReorderableRowDisabled", "pReorderableRowDisabled", booleanAttribute]
      },
      features: [i0.ɵɵInputTransformsFeature]
    });
  }
  return ReorderableRow;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ColumnFilter = /*#__PURE__*/(() => {
  class ColumnFilter {
    document;
    el;
    dt;
    renderer;
    config;
    overlayService;
    cd;
    /**
     * Property represented by the column.
     * @group Props
     */
    field;
    /**
     * Type of the input.
     * @group Props
     */
    type = 'text';
    /**
     * Filter display.
     * @group Props
     */
    display = 'row';
    /**
     * Decides whether to display filter menu popup.
     * @group Props
     */
    showMenu = true;
    /**
     * Filter match mode.
     * @group Props
     */
    matchMode;
    /**
     * Filter operator.
     * @defaultValue 'AND'
     * @group Props
     */
    operator = FilterOperator.AND;
    /**
     * Decides whether to display filter operator.
     * @group Props
     */
    showOperator = true;
    /**
     * Decides whether to display clear filter button.
     * @group Props
     */
    showClearButton = true;
    /**
     * Decides whether to display apply filter button.
     * @group Props
     */
    showApplyButton = true;
    /**
     * Decides whether to display filter match modes.
     * @group Props
     */
    showMatchModes = true;
    /**
     * Decides whether to display add filter button.
     * @group Props
     */
    showAddButton = true;
    /**
     * Decides whether to close popup on clear button click.
     * @group Props
     */
    hideOnClear = false;
    /**
     * Filter placeholder.
     * @group Props
     */
    placeholder;
    /**
     * Filter match mode options.
     * @group Props
     */
    matchModeOptions;
    /**
     * Defines maximum amount of constraints.
     * @group Props
     */
    maxConstraints = 2;
    /**
     * Defines minimum fraction of digits.
     * @group Props
     */
    minFractionDigits;
    /**
     * Defines maximum fraction of digits.
     * @group Props
     */
    maxFractionDigits;
    /**
     * Defines prefix of the filter.
     * @group Props
     */
    prefix;
    /**
     * Defines suffix of the filter.
     * @group Props
     */
    suffix;
    /**
     * Defines filter locale.
     * @group Props
     */
    locale;
    /**
     * Defines filter locale matcher.
     * @group Props
     */
    localeMatcher;
    /**
     * Enables currency input.
     * @group Props
     */
    currency;
    /**
     * Defines the display of the currency input.
     * @group Props
     */
    currencyDisplay;
    /**
     * Defines if filter grouping will be enabled.
     * @group Props
     */
    useGrouping = true;
    /**
     * Defines the visibility of buttons.
     * @group Props
     */
    showButtons = true;
    /**
     * Defines the aria-label of the form element.
     * @group Props
     */
    ariaLabel;
    /**
     * Callback to invoke on overlay is shown.
     * @param {AnimationEvent} originalEvent - animation event.
     * @group Emits
     */
    onShow = new EventEmitter();
    /**
     * Callback to invoke on overlay is hidden.
     * @param {AnimationEvent} originalEvent - animation event.
     * @group Emits
     */
    onHide = new EventEmitter();
    icon;
    clearButtonViewChild;
    templates;
    overlaySubscription;
    headerTemplate;
    filterTemplate;
    footerTemplate;
    filterIconTemplate;
    removeRuleIconTemplate;
    addRuleIconTemplate;
    clearFilterIconTemplate;
    operatorOptions;
    overlayVisible;
    overlay;
    scrollHandler;
    documentClickListener;
    documentResizeListener;
    matchModes;
    translationSubscription;
    resetSubscription;
    selfClick;
    overlayEventListener;
    window;
    overlayId;
    get fieldConstraints() {
      return this.dt.filters ? this.dt.filters[this.field] : null;
    }
    get showRemoveIcon() {
      return this.fieldConstraints ? this.fieldConstraints.length > 1 : false;
    }
    get showMenuButton() {
      return this.showMenu && (this.display === 'row' ? this.type !== 'boolean' : true);
    }
    get isShowOperator() {
      return this.showOperator && this.type !== 'boolean';
    }
    get isShowAddConstraint() {
      return this.showAddButton && this.type !== 'boolean' && this.fieldConstraints && this.fieldConstraints.length < this.maxConstraints;
    }
    get showMenuButtonLabel() {
      return this.config.getTranslation(TranslationKeys.SHOW_FILTER_MENU);
    }
    get applyButtonLabel() {
      return this.config.getTranslation(TranslationKeys.APPLY);
    }
    get clearButtonLabel() {
      return this.config.getTranslation(TranslationKeys.CLEAR);
    }
    get addRuleButtonLabel() {
      return this.config.getTranslation(TranslationKeys.ADD_RULE);
    }
    get removeRuleButtonLabel() {
      return this.config.getTranslation(TranslationKeys.REMOVE_RULE);
    }
    get noFilterLabel() {
      return this.config.getTranslation(TranslationKeys.NO_FILTER);
    }
    get filterMenuButtonAriaLabel() {
      return this.config.translation ? this.overlayVisible ? this.config.translation.aria.hideFilterMenu : this.config.translation.aria.showFilterMenu : undefined;
    }
    get removeRuleButtonAriaLabel() {
      return this.config.translation ? this.config.translation.removeRule : undefined;
    }
    get filterOperatorAriaLabel() {
      return this.config.translation ? this.config.translation.aria.filterOperator : undefined;
    }
    get filterConstraintAriaLabel() {
      return this.config.translation ? this.config.translation.aria.filterConstraint : undefined;
    }
    constructor(document, el, dt, renderer, config, overlayService, cd) {
      this.document = document;
      this.el = el;
      this.dt = dt;
      this.renderer = renderer;
      this.config = config;
      this.overlayService = overlayService;
      this.cd = cd;
      this.window = this.document.defaultView;
    }
    ngOnInit() {
      this.overlayId = UniqueComponentId();
      if (!this.dt.filters[this.field]) {
        this.initFieldFilterConstraint();
      }
      this.translationSubscription = this.config.translationObserver.subscribe(() => {
        this.generateMatchModeOptions();
        this.generateOperatorOptions();
      });
      this.generateMatchModeOptions();
      this.generateOperatorOptions();
    }
    generateMatchModeOptions() {
      this.matchModes = this.matchModeOptions || this.config.filterMatchModeOptions[this.type]?.map(key => {
        return {
          label: this.config.getTranslation(key),
          value: key
        };
      });
    }
    generateOperatorOptions() {
      this.operatorOptions = [{
        label: this.config.getTranslation(TranslationKeys.MATCH_ALL),
        value: FilterOperator.AND
      }, {
        label: this.config.getTranslation(TranslationKeys.MATCH_ANY),
        value: FilterOperator.OR
      }];
    }
    ngAfterContentInit() {
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'header':
            this.headerTemplate = item.template;
            break;
          case 'filter':
            this.filterTemplate = item.template;
            break;
          case 'footer':
            this.footerTemplate = item.template;
            break;
          case 'filtericon':
            this.filterIconTemplate = item.template;
            break;
          case 'clearfiltericon':
            this.clearFilterIconTemplate = item.template;
            break;
          case 'removeruleicon':
            this.removeRuleIconTemplate = item.template;
            break;
          case 'addruleicon':
            this.addRuleIconTemplate = item.template;
            break;
          default:
            this.filterTemplate = item.template;
            break;
        }
      });
    }
    initFieldFilterConstraint() {
      let defaultMatchMode = this.getDefaultMatchMode();
      this.dt.filters[this.field] = this.display == 'row' ? {
        value: null,
        matchMode: defaultMatchMode
      } : [{
        value: null,
        matchMode: defaultMatchMode,
        operator: this.operator
      }];
    }
    onMenuMatchModeChange(value, filterMeta) {
      filterMeta.matchMode = value;
      if (!this.showApplyButton) {
        this.dt._filter();
      }
    }
    onRowMatchModeChange(matchMode) {
      const fieldFilter = this.dt.filters[this.field];
      fieldFilter.matchMode = matchMode;
      if (fieldFilter.value) {
        this.dt._filter();
      }
      this.hide();
    }
    onRowMatchModeKeyDown(event) {
      let item = event.target;
      switch (event.key) {
        case 'ArrowDown':
          var nextItem = this.findNextItem(item);
          if (nextItem) {
            item.removeAttribute('tabindex');
            nextItem.tabIndex = '0';
            nextItem.focus();
          }
          event.preventDefault();
          break;
        case 'ArrowUp':
          var prevItem = this.findPrevItem(item);
          if (prevItem) {
            item.removeAttribute('tabindex');
            prevItem.tabIndex = '0';
            prevItem.focus();
          }
          event.preventDefault();
          break;
      }
    }
    onRowClearItemClick() {
      this.clearFilter();
      this.hide();
    }
    isRowMatchModeSelected(matchMode) {
      return this.dt.filters[this.field]?.matchMode === matchMode;
    }
    addConstraint() {
      this.dt.filters[this.field].push({
        value: null,
        matchMode: this.getDefaultMatchMode(),
        operator: this.getDefaultOperator()
      });
      DomHandler.focus(this.clearButtonViewChild.nativeElement);
    }
    removeConstraint(filterMeta) {
      this.dt.filters[this.field] = this.dt.filters[this.field].filter(meta => meta !== filterMeta);
      if (!this.showApplyButton) {
        this.dt._filter();
      }
      DomHandler.focus(this.clearButtonViewChild.nativeElement);
    }
    onOperatorChange(value) {
      this.dt.filters[this.field].forEach(filterMeta => {
        filterMeta.operator = value;
        this.operator = value;
      });
      if (!this.showApplyButton) {
        this.dt._filter();
      }
    }
    toggleMenu() {
      this.overlayVisible = !this.overlayVisible;
    }
    onToggleButtonKeyDown(event) {
      switch (event.key) {
        case 'Escape':
        case 'Tab':
          this.overlayVisible = false;
          break;
        case 'ArrowDown':
          if (this.overlayVisible) {
            let focusable = DomHandler.getFocusableElements(this.overlay);
            if (focusable) {
              focusable[0].focus();
            }
            event.preventDefault();
          } else if (event.altKey) {
            this.overlayVisible = true;
            event.preventDefault();
          }
          break;
        case 'Enter':
          this.toggleMenu();
          event.preventDefault();
          break;
      }
    }
    onEscape() {
      this.icon?.nativeElement.focus();
    }
    findNextItem(item) {
      let nextItem = item.nextElementSibling;
      if (nextItem) return DomHandler.hasClass(nextItem, 'p-column-filter-separator') ? this.findNextItem(nextItem) : nextItem;else return item.parentElement?.firstElementChild;
    }
    findPrevItem(item) {
      let prevItem = item.previousElementSibling;
      if (prevItem) return DomHandler.hasClass(prevItem, 'p-column-filter-separator') ? this.findPrevItem(prevItem) : prevItem;else return item.parentElement?.lastElementChild;
    }
    onContentClick() {
      this.selfClick = true;
    }
    onOverlayAnimationStart(event) {
      switch (event.toState) {
        case 'visible':
          this.overlay = event.element;
          this.renderer.appendChild(this.document.body, this.overlay);
          ZIndexUtils.set('overlay', this.overlay, this.config.zIndex.overlay);
          DomHandler.absolutePosition(this.overlay, this.icon?.nativeElement);
          this.bindDocumentClickListener();
          this.bindDocumentResizeListener();
          this.bindScrollListener();
          this.overlayEventListener = e => {
            if (this.overlay && this.overlay.contains(e.target)) {
              this.selfClick = true;
            }
          };
          this.overlaySubscription = this.overlayService.clickObservable.subscribe(this.overlayEventListener);
          this.onShow.emit({
            originalEvent: event
          });
          break;
        case 'void':
          this.onOverlayHide();
          if (this.overlaySubscription) {
            this.overlaySubscription.unsubscribe();
          }
          break;
      }
    }
    onOverlayAnimationEnd(event) {
      switch (event.toState) {
        case 'visible':
          this.focusOnFirstElement();
          break;
        case 'void':
          ZIndexUtils.clear(event.element);
          this.onHide.emit({
            originalEvent: event
          });
          break;
      }
    }
    focusOnFirstElement() {
      if (this.overlay) {
        DomHandler.focus(DomHandler.getFirstFocusableElement(this.overlay, ''));
      }
    }
    getDefaultMatchMode() {
      if (this.matchMode) {
        return this.matchMode;
      } else {
        if (this.type === 'text') return FilterMatchMode.STARTS_WITH;else if (this.type === 'numeric') return FilterMatchMode.EQUALS;else if (this.type === 'date') return FilterMatchMode.DATE_IS;else return FilterMatchMode.CONTAINS;
      }
    }
    getDefaultOperator() {
      return this.dt.filters ? this.dt.filters[this.field][0].operator : this.operator;
    }
    hasRowFilter() {
      return this.dt.filters[this.field] && !this.dt.isFilterBlank(this.dt.filters[this.field].value);
    }
    hasFilter() {
      let fieldFilter = this.dt.filters[this.field];
      if (fieldFilter) {
        if (Array.isArray(fieldFilter)) return !this.dt.isFilterBlank(fieldFilter[0].value);else return !this.dt.isFilterBlank(fieldFilter.value);
      }
      return false;
    }
    isOutsideClicked(event) {
      return !(DomHandler.hasClass(this.overlay?.nextElementSibling, 'p-overlay') || this.overlay?.isSameNode(event.target) || this.overlay?.contains(event.target) || this.icon?.nativeElement.isSameNode(event.target) || this.icon?.nativeElement.contains(event.target) || DomHandler.hasClass(event.target, 'p-column-filter-add-button') || DomHandler.hasClass(event.target.parentElement, 'p-column-filter-add-button') || DomHandler.hasClass(event.target, 'p-column-filter-remove-button') || DomHandler.hasClass(event.target.parentElement, 'p-column-filter-remove-button'));
    }
    bindDocumentClickListener() {
      if (!this.documentClickListener) {
        const documentTarget = this.el ? this.el.nativeElement.ownerDocument : 'document';
        this.documentClickListener = this.renderer.listen(documentTarget, 'mousedown', event => {
          let isDateDialog = false;
          document.querySelectorAll('[role="dialog"]').forEach(d => {
            if (DomHandler.hasClass(d, 'p-datepicker')) isDateDialog = true;
          });
          const targetIsColumnFilterMenuButton = event.target.closest('.p-column-filter-menu-button');
          if (this.overlayVisible && this.isOutsideClicked(event) && (targetIsColumnFilterMenuButton || !isDateDialog)) {
            this.hide();
          }
          this.selfClick = false;
        });
      }
    }
    unbindDocumentClickListener() {
      if (this.documentClickListener) {
        this.documentClickListener();
        this.documentClickListener = null;
        this.selfClick = false;
      }
    }
    bindDocumentResizeListener() {
      if (!this.documentResizeListener) {
        this.documentResizeListener = this.renderer.listen(this.window, 'resize', event => {
          if (this.overlayVisible && !DomHandler.isTouchDevice()) {
            this.hide();
          }
        });
      }
    }
    unbindDocumentResizeListener() {
      if (this.documentResizeListener) {
        this.documentResizeListener();
        this.documentResizeListener = null;
      }
    }
    bindScrollListener() {
      if (!this.scrollHandler) {
        this.scrollHandler = new ConnectedOverlayScrollHandler(this.icon?.nativeElement, () => {
          if (this.overlayVisible) {
            this.hide();
          }
        });
      }
      this.scrollHandler.bindScrollListener();
    }
    unbindScrollListener() {
      if (this.scrollHandler) {
        this.scrollHandler.unbindScrollListener();
      }
    }
    hide() {
      this.overlayVisible = false;
      this.cd.markForCheck();
    }
    onOverlayHide() {
      this.unbindDocumentClickListener();
      this.unbindDocumentResizeListener();
      this.unbindScrollListener();
      this.overlay = null;
    }
    clearFilter() {
      this.initFieldFilterConstraint();
      this.dt._filter();
      if (this.hideOnClear) this.hide();
    }
    applyFilter() {
      this.dt._filter();
      this.hide();
    }
    ngOnDestroy() {
      if (this.overlay) {
        this.renderer.appendChild(this.el.nativeElement, this.overlay);
        ZIndexUtils.clear(this.overlay);
        this.onOverlayHide();
      }
      if (this.translationSubscription) {
        this.translationSubscription.unsubscribe();
      }
      if (this.resetSubscription) {
        this.resetSubscription.unsubscribe();
      }
      if (this.overlaySubscription) {
        this.overlaySubscription.unsubscribe();
      }
    }
    static ɵfac = function ColumnFilter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ColumnFilter)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.PrimeNGConfig), i0.ɵɵdirectiveInject(i1.OverlayService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ColumnFilter,
      selectors: [["p-columnFilter"]],
      contentQueries: function ColumnFilter_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function ColumnFilter_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c29, 5);
          i0.ɵɵviewQuery(_c30, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.icon = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.clearButtonViewChild = _t.first);
        }
      },
      hostAttrs: [1, "p-element"],
      inputs: {
        field: "field",
        type: "type",
        display: "display",
        showMenu: [2, "showMenu", "showMenu", booleanAttribute],
        matchMode: "matchMode",
        operator: "operator",
        showOperator: [2, "showOperator", "showOperator", booleanAttribute],
        showClearButton: [2, "showClearButton", "showClearButton", booleanAttribute],
        showApplyButton: [2, "showApplyButton", "showApplyButton", booleanAttribute],
        showMatchModes: [2, "showMatchModes", "showMatchModes", booleanAttribute],
        showAddButton: [2, "showAddButton", "showAddButton", booleanAttribute],
        hideOnClear: [2, "hideOnClear", "hideOnClear", booleanAttribute],
        placeholder: "placeholder",
        matchModeOptions: "matchModeOptions",
        maxConstraints: [2, "maxConstraints", "maxConstraints", numberAttribute],
        minFractionDigits: [2, "minFractionDigits", "minFractionDigits", value => numberAttribute(value, null)],
        maxFractionDigits: [2, "maxFractionDigits", "maxFractionDigits", value => numberAttribute(value, null)],
        prefix: "prefix",
        suffix: "suffix",
        locale: "locale",
        localeMatcher: "localeMatcher",
        currency: "currency",
        currencyDisplay: "currencyDisplay",
        useGrouping: [2, "useGrouping", "useGrouping", booleanAttribute],
        showButtons: [2, "showButtons", "showButtons", booleanAttribute],
        ariaLabel: "ariaLabel"
      },
      outputs: {
        onShow: "onShow",
        onHide: "onHide"
      },
      features: [i0.ɵɵInputTransformsFeature],
      decls: 5,
      vars: 8,
      consts: [["icon", ""], ["menu", ""], ["clearBtn", ""], [1, "p-column-filter", 3, "ngClass"], ["class", "p-fluid", 3, "type", "field", "ariaLabel", "filterConstraint", "filterTemplate", "placeholder", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "locale", "localeMatcher", "currency", "currencyDisplay", "useGrouping", "showButtons", 4, "ngIf"], ["type", "button", "class", "p-column-filter-menu-button p-link", "aria-haspopup", "true", 3, "ngClass", "click", "keydown", 4, "ngIf"], ["type", "button", "class", "p-column-filter-clear-button p-link", 3, "ngClass", "click", 4, "ngIf"], ["role", "dialog", 3, "ngClass", "id", "click", "keydown.escape", 4, "ngIf"], [1, "p-fluid", 3, "type", "field", "ariaLabel", "filterConstraint", "filterTemplate", "placeholder", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "locale", "localeMatcher", "currency", "currencyDisplay", "useGrouping", "showButtons"], ["type", "button", "aria-haspopup", "true", 1, "p-column-filter-menu-button", "p-link", 3, "click", "keydown", "ngClass"], [3, "styleClass", 4, "ngIf"], ["class", "pi-filter-icon", 4, "ngIf"], [3, "styleClass"], [1, "pi-filter-icon"], [4, "ngTemplateOutlet"], ["type", "button", 1, "p-column-filter-clear-button", "p-link", 3, "click", "ngClass"], [4, "ngIf"], ["role", "dialog", 3, "click", "keydown.escape", "ngClass", "id"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "p-column-filter-row-items", 4, "ngIf", "ngIfElse"], [1, "p-column-filter-row-items"], ["class", "p-column-filter-row-item", 3, "ngClass", "click", "keydown", "keydown.enter", 4, "ngFor", "ngForOf"], [1, "p-column-filter-separator"], [1, "p-column-filter-row-item", 3, "click", "keydown", "keydown.enter"], [1, "p-column-filter-row-item", 3, "click", "keydown", "keydown.enter", "ngClass"], ["class", "p-column-filter-operator", 4, "ngIf"], [1, "p-column-filter-constraints"], ["class", "p-column-filter-constraint", 4, "ngFor", "ngForOf"], ["class", "p-column-filter-add-rule", 4, "ngIf"], ["class", "p-column-filter-buttonbar", 4, "ngIf"], [1, "p-column-filter-operator"], ["styleClass", "p-column-filter-operator-dropdown", 3, "ngModelChange", "options", "ngModel"], [1, "p-column-filter-constraint"], ["styleClass", "p-column-filter-matchmode-dropdown", 3, "options", "ngModel", "ngModelChange", 4, "ngIf"], [3, "type", "field", "filterConstraint", "filterTemplate", "placeholder", "minFractionDigits", "maxFractionDigits", "prefix", "suffix", "locale", "localeMatcher", "currency", "currencyDisplay", "useGrouping"], ["type", "button", "pButton", "", "class", "p-column-filter-remove-button p-button-text p-button-danger p-button-sm", "pRipple", "", 3, "label", "click", 4, "ngIf"], ["styleClass", "p-column-filter-matchmode-dropdown", 3, "ngModelChange", "options", "ngModel"], ["type", "button", "pButton", "", "pRipple", "", 1, "p-column-filter-remove-button", "p-button-text", "p-button-danger", "p-button-sm", 3, "click", "label"], [1, "p-column-filter-add-rule"], ["type", "button", "pButton", "", "pRipple", "", 1, "p-column-filter-add-button", "p-button-text", "p-button-sm", 3, "click", "label"], [1, "p-column-filter-buttonbar"], ["type", "button", "pButton", "", "class", "p-button-outlined p-button-sm", "pRipple", "", 3, "label", "click", 4, "ngIf"], ["type", "button", "pButton", "", "class", "p-button-sm", "pRipple", "", 3, "label", "click", 4, "ngIf"], ["type", "button", "pButton", "", "pRipple", "", 1, "p-button-outlined", "p-button-sm", 3, "click", "label"], ["type", "button", "pButton", "", "pRipple", "", 1, "p-button-sm", 3, "click", "label"]],
      template: function ColumnFilter_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 3);
          i0.ɵɵtemplate(1, ColumnFilter_p_columnFilterFormElement_1_Template, 1, 16, "p-columnFilterFormElement", 4)(2, ColumnFilter_button_2_Template, 4, 9, "button", 5)(3, ColumnFilter_button_3_Template, 4, 6, "button", 6)(4, ColumnFilter_div_4_Template, 6, 16, "div", 7);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c31, ctx.display === "row", ctx.display === "menu"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.display === "row");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showMenuButton);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showClearButton && ctx.display === "row");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showMenu && ctx.overlayVisible);
        }
      },
      dependencies: () => [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i6.Dropdown, i7.NgControlStatus, i7.NgModel, i8.ButtonDirective, FilterIcon, FilterSlashIcon, PlusIcon, TrashIcon, ColumnFilterFormElement],
      encapsulation: 2,
      data: {
        animation: [trigger('overlayAnimation', [transition(':enter', [style({
          opacity: 0,
          transform: 'scaleY(0.8)'
        }), animate('.12s cubic-bezier(0, 0, 0.2, 1)')]), transition(':leave', [animate('.1s linear', style({
          opacity: 0
        }))])])]
      }
    });
  }
  return ColumnFilter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ColumnFilterFormElement = /*#__PURE__*/(() => {
  class ColumnFilterFormElement {
    dt;
    colFilter;
    field;
    type;
    filterConstraint;
    filterTemplate;
    placeholder;
    minFractionDigits;
    maxFractionDigits;
    prefix;
    suffix;
    locale;
    localeMatcher;
    currency;
    currencyDisplay;
    useGrouping = true;
    ariaLabel;
    get showButtons() {
      return this.colFilter.showButtons;
    }
    filterCallback;
    constructor(dt, colFilter) {
      this.dt = dt;
      this.colFilter = colFilter;
    }
    ngOnInit() {
      this.filterCallback = value => {
        this.filterConstraint.value = value;
        this.dt._filter();
      };
    }
    onModelChange(value) {
      this.filterConstraint.value = value;
      if (this.type === 'date' || this.type === 'boolean' || value === '') {
        this.dt._filter();
      }
    }
    onTextInputEnterKeyDown(event) {
      this.dt._filter();
      event.preventDefault();
    }
    onNumericInputKeyDown(event) {
      if (event.key === 'Enter') {
        this.dt._filter();
        event.preventDefault();
      }
    }
    static ɵfac = function ColumnFilterFormElement_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ColumnFilterFormElement)(i0.ɵɵdirectiveInject(Table), i0.ɵɵdirectiveInject(ColumnFilter));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ColumnFilterFormElement,
      selectors: [["p-columnFilterFormElement"]],
      hostAttrs: [1, "p-element"],
      inputs: {
        field: "field",
        type: "type",
        filterConstraint: "filterConstraint",
        filterTemplate: "filterTemplate",
        placeholder: "placeholder",
        minFractionDigits: [2, "minFractionDigits", "minFractionDigits", value => numberAttribute(value, null)],
        maxFractionDigits: [2, "maxFractionDigits", "maxFractionDigits", value => numberAttribute(value, null)],
        prefix: "prefix",
        suffix: "suffix",
        locale: "locale",
        localeMatcher: "localeMatcher",
        currency: "currency",
        currencyDisplay: "currencyDisplay",
        useGrouping: [2, "useGrouping", "useGrouping", booleanAttribute],
        ariaLabel: "ariaLabel"
      },
      features: [i0.ɵɵInputTransformsFeature],
      decls: 3,
      vars: 2,
      consts: [["builtInElement", ""], [4, "ngIf", "ngIfElse"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngSwitch"], ["type", "text", "pInputText", "", 3, "ariaLabel", "value", "input", "keydown.enter", 4, "ngSwitchCase"], [3, "ngModel", "showButtons", "minFractionDigits", "maxFractionDigits", "ariaLabel", "prefix", "suffix", "placeholder", "mode", "locale", "localeMatcher", "currency", "currencyDisplay", "useGrouping", "ngModelChange", "onKeyDown", 4, "ngSwitchCase"], [3, "ariaLabel", "ngModel", "ngModelChange", 4, "ngSwitchCase"], ["appendTo", "body", 3, "ariaLabel", "placeholder", "ngModel", "ngModelChange", 4, "ngSwitchCase"], ["type", "text", "pInputText", "", 3, "input", "keydown.enter", "ariaLabel", "value"], [3, "ngModelChange", "onKeyDown", "ngModel", "showButtons", "minFractionDigits", "maxFractionDigits", "ariaLabel", "prefix", "suffix", "placeholder", "mode", "locale", "localeMatcher", "currency", "currencyDisplay", "useGrouping"], [3, "ngModelChange", "ariaLabel", "ngModel"], ["appendTo", "body", 3, "ngModelChange", "ariaLabel", "placeholder", "ngModel"]],
      template: function ColumnFilterFormElement_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ColumnFilterFormElement_ng_container_0_Template, 2, 19, "ng-container", 1)(1, ColumnFilterFormElement_ng_template_1_Template, 5, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const builtInElement_r6 = i0.ɵɵreference(2);
          i0.ɵɵproperty("ngIf", ctx.filterTemplate)("ngIfElse", builtInElement_r6);
        }
      },
      dependencies: [i3.NgIf, i3.NgTemplateOutlet, i3.NgSwitch, i3.NgSwitchCase, i9.InputNumber, i7.NgControlStatus, i7.NgModel, i10.InputText, i11.Calendar, i12.TriStateCheckbox],
      encapsulation: 2
    });
  }
  return ColumnFilterFormElement;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TableModule = /*#__PURE__*/(() => {
  class TableModule {
    static ɵfac = function TableModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TableModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, PaginatorModule, InputTextModule, DropdownModule, FormsModule, ButtonModule, SelectButtonModule, CalendarModule, InputNumberModule, TriStateCheckboxModule, ScrollerModule, ArrowDownIcon, ArrowUpIcon, SpinnerIcon, SortAltIcon, SortAmountUpAltIcon, SortAmountDownIcon, CheckIcon, FilterIcon, FilterSlashIcon, PlusIcon, TrashIcon, SharedModule, ScrollerModule]
    });
  }
  return TableModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CancelEditableRow, CellEditor, ColumnFilter, ColumnFilterFormElement, ContextMenuRow, EditableColumn, EditableRow, FrozenColumn, InitEditableRow, ReorderableColumn, ReorderableRow, ReorderableRowHandle, ResizableColumn, RowGroupHeader, RowToggler, SaveEditableRow, SelectableRow, SelectableRowDblClick, SortIcon, SortableColumn, Table, TableBody, TableCheckbox, TableHeaderCheckbox, TableModule, TableRadioButton, TableService };
